/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 135);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "appendParamObjectToURL", function() { return appendParamObjectToURL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "appendQueryStringToURL", function() { return appendQueryStringToURL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "assignWithDefaults", function() { return assignWithDefaults; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "binaryFind", function() { return binaryFind; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "camelCase", function() { return camelCase; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "capitalize", function() { return capitalize; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "clamp", function() { return clamp; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "clone", function() { return clone; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "compareNumbers", function() { return compareNumbers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "compareStrings", function() { return compareStrings; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "composeAsync", function() { return composeAsync; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "smartCompare", function() { return smartCompare; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "deepEqual", function() { return deepEqual; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "deepInclude", function() { return deepInclude; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "deepUnique", function() { return deepUnique; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "diffObjects", function() { return diffObjects; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "escapeRegExp", function() { return escapeRegExp; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "flatten", function() { return flatten; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "formatConjunction", function() { return formatConjunction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "formatFileSize", function() { return formatFileSize; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "formatUSD", function() { return formatUSD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getLocale", function() { return getLocale; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "numberToLocaleString", function() { return numberToLocaleString; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getIn", function() { return getIn; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "kebabCase", function() { return kebabCase; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isPromise", function() { return isPromise; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isEmpty", function() { return isEmpty; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "loadImage", function() { return loadImage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "loadImages", function() { return loadImages; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "mapByID", function() { return mapByID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "mapcat", function() { return mapcat; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "mergePropertiesWithDefaults", function() { return mergePropertiesWithDefaults; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "objFromQueryString", function() { return objFromQueryString; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "objToQueryString", function() { return objToQueryString; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "errorSensitiveFetch", function() { return errorSensitiveFetch; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "postJSON", function() { return postJSON; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "patchJSON", function() { return patchJSON; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ping", function() { return ping; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "poll", function() { return poll; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "precisionRound", function() { return precisionRound; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "randomInt", function() { return randomInt; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "range", function() { return range; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "request", function() { return request; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "runAsync", function() { return runAsync; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "removeKeys", function() { return removeKeys; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "removeEmptyKeys", function() { return removeEmptyKeys; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "selectKeys", function() { return selectKeys; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "shuffle", function() { return shuffle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "stableSort", function() { return stableSort; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "timeDifference", function() { return timeDifference; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "type", function() { return type; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "wait", function() { return wait; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "timeout", function() { return timeout; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "unique", function() { return unique; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isFunction", function() { return isFunction; });
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var appendParamObjectToURL = function appendParamObjectToURL(url, params) {
  return appendQueryStringToURL(url, objToQueryString(params));
};

var appendQueryStringToURL = function appendQueryStringToURL(url, queryString) {
  if (queryString === "") return url;

  var separator = url.includes("?") ? "&" : "?";

  return "" + url + separator + queryString;
};

// If any key in the `defaults` object doesn't exist in `target`, the key is
// merged. Additional `sources` object arguments are merged into `target`, but
// only the keys that exist in `defaults`.
var assignWithDefaults = function assignWithDefaults(target, defaults) {
  for (var _len = arguments.length, sources = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    sources[_key - 2] = arguments[_key];
  }

  Object.keys(defaults).forEach(function (key) {
    if (!target.hasOwnProperty(key) || target[key] === undefined) {
      target[key] = defaults[key];
    }

    sources.filter(function (source) {
      return source != null && source.hasOwnProperty(key) && source[key] !== undefined;
    }).forEach(function (source) {
      return target[key] = source[key];
    });
  });

  return target;
};

/**
 * Takes an ordered array and returns the first value where fn(value) returns true.
 */
var binaryFind = function binaryFind(arr, fn) {
  var high = arr.length + 1;
  var low = 0;
  while (low + 1 < high) {
    var mid = low + (high - low >> 1);
    if (fn(arr[mid])) {
      high = mid;
    } else {
      low = mid;
    }
  }

  return arr[high];
};

var camelCase = function camelCase(str) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$isSuffix = _ref.isSuffix,
      isSuffix = _ref$isSuffix === undefined ? false : _ref$isSuffix;

  return str.split(/[-_]/g).map(function (part, i) {
    return i === 0 && !isSuffix ? part.toLowerCase() : capitalize(part.toLowerCase());
  }).join("");
};

var capitalize = function capitalize(str) {
  if (str === "") return str;

  return "" + str[0].toUpperCase() + str.slice(1);
};

var clamp = function clamp(x, a, b) {
  if (a > b) {
    return clamp(x, b, a);
  }

  if (x < a) {
    return a;
  }

  if (x > b) {
    return b;
  }

  return x;
};

var clone = function clone(obj) {
  if (obj === undefined) return undefined;

  return JSON.parse(JSON.stringify(obj));
};

var compareNumbers = function compareNumbers(a, b) {
  if (a == null && b == null) return 0;else if (a == null) return -1;else if (b == null) return 1;

  return a - b;
};

var compareStrings = function compareStrings(a, b) {
  return (a || "").trim().toLowerCase().localeCompare((b || "").trim().toLowerCase());
};

/**
 * Composes functions such that any returned Promise is resolved before the next invocation.
 * @param  {Function[]} funcs - A list of potentially async functions that each take a single param. Any null/
 * undefined values are ignored.
 */
var composeAsync = function composeAsync() {
  for (var _len2 = arguments.length, funcs = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    funcs[_key2] = arguments[_key2];
  }

  return function (arg) {
    var res = Promise.resolve(arg);

    var _loop = function _loop(i) {
      var f = funcs[i];
      if (f == null) {
        return "continue";
      }
      res = res.then(function (arg) {
        return f(arg);
      });
    };

    for (var i = funcs.length - 1; i >= 0; i--) {
      var _ret = _loop(i);

      if (_ret === "continue") continue;
    }
    return res;
  };
};

var smartCompare = function smartCompare(a, b) {
  var _ref2 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
      _ref2$reverse = _ref2.reverse,
      reverse = _ref2$reverse === undefined ? false : _ref2$reverse;

  if (a === b) return 0;
  if (type(a) !== type(b) && b != null && a != null) {
    throw new Error("Don't know how to compare type " + type(a) + " with type " + type(b) + "!");
  }
  var compareType = a != null ? type(a) : type(b);

  var _ref3 = reverse ? [b, a] : [a, b],
      _ref4 = _slicedToArray(_ref3, 2),
      valueA = _ref4[0],
      valueB = _ref4[1];

  switch (compareType) {
    case "string":
      return compareStrings(valueA, valueB);
    case "number":
      return compareNumbers(valueA, valueB);
    default:
      // TODO(oscar): Add more types for comparison such as Dates.
      throw new Error("Missing method for comparing type " + compareType);
  }
};

/**
 * Recursively compares 2 JS objects.
 * @param {any} a
 * @param {any} b
 * @param {Object} options
 * @param {boolean} options.toJSON - Uses clone() in order to compare objects as
 * their JSON representations.
 * Useful when comparing plain objects to class instances.
 */
var deepEqual = function deepEqual(a, b) {
  var _ref5 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
      _ref5$toJSON = _ref5.toJSON,
      toJSON = _ref5$toJSON === undefined ? false : _ref5$toJSON;

  if (a === b) {
    return true;
  }

  var compareA = toJSON ? clone(a) : a;
  var compareB = toJSON ? clone(b) : b;
  var tA = type(compareA);
  var tB = type(compareB);

  if (tA === "array" && tB === "array") {
    if (compareA.length !== compareB.length) return false;

    for (var i = 0; i < compareA.length; i++) {
      if (!deepEqual(compareA[i], compareB[i])) return false;
    }

    return true;
  }

  if (tA === "set" && tB === "set") {
    if (compareA.size !== compareB.size) return false;

    var bShallowCopy = new Set(compareB);
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      aLoop: for (var _iterator = compareA[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var aElement = _step.value;

        // First check if there's an equivalent reference in the two sets before checking for deep equality,
        // since the latter is very inefficient.
        if (bShallowCopy.has(aElement)) {
          bShallowCopy.delete(aElement);
          continue;
        }

        var _iteratorNormalCompletion2 = true;
        var _didIteratorError2 = false;
        var _iteratorError2 = undefined;

        try {
          for (var _iterator2 = bShallowCopy[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
            var bElement = _step2.value;

            if (deepEqual(aElement, bElement)) {
              bShallowCopy.delete(bElement);
              continue aLoop;
            }
          }
        } catch (err) {
          _didIteratorError2 = true;
          _iteratorError2 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion2 && _iterator2.return) {
              _iterator2.return();
            }
          } finally {
            if (_didIteratorError2) {
              throw _iteratorError2;
            }
          }
        }

        return false;
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }

    return true;
  }

  if (tA === "object" && tB === "object") {
    for (var k in compareA) {
      if (!(k in compareB)) return false;
    }

    for (var _k in compareB) {
      if (!(_k in compareA) || !deepEqual(compareA[_k], compareB[_k])) return false;
    }

    return true;
  }

  return compareA === compareB;
};

var deepInclude = function deepInclude(parent, child) {
  if (type(parent.some) === "function") {
    return parent.some(function (obj) {
      return deepEqual(obj, child);
    });
  } else if (type(parent) === "object") {
    return Object.values(parent).some(function (obj) {
      return deepEqual(obj, child);
    });
  }
  return false;
};

var deepUnique = function deepUnique(arr) {
  var index = 0;

  var _loop2 = function _loop2() {
    var item = arr[index];
    arr = arr.slice(0, index + 1).concat(arr.slice(index).filter(function (currItem) {
      return !deepEqual(item, currItem);
    }));
    index += 1;
  };

  while (index < arr.length) {
    _loop2();
  }

  return arr;
};

/**
 * @param {Object} a
 * @param {Object} b
 * @param {boolean} includeAKeys
 * @returns {Object} - An object containing keys in `b` if the values differ
 * from those in `a`. If `includeAKeys` is true, the keys in `a` that are NOT in
 * `b` are also included.
 */
var diffObjects = function diffObjects(a, b) {
  var includeAKeys = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  var result = {};
  for (var k in b) {
    if (!deepEqual(a[k], b[k])) {
      result[k] = b[k];
    }
  }
  if (includeAKeys) {
    for (var _k2 in a) {
      if (!(_k2 in b)) {
        result[_k2] = null;
      }
    }
  }

  return result;
};

// https://stackoverflow.com/questions/3446170/escape-string-for-use-in-javascript-regex
var escapeRegExp = function escapeRegExp(str) {
  return str.replace(/[-[\]/{}()*+?.\\^$|]/g, "\\$&");
};

var flatten = function flatten(arr) {
  return [].concat.apply([], arr);
};

/**
 * Takes a list of words and joins them via coordinating conjunction grammar rules. Oxford comma is mandatory.
 * @param {String[]} words
 */
var formatConjunction = function formatConjunction(words) {
  var conjunction = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "and";

  var wc = words.length;
  if (wc <= 2) {
    return words.join(" " + conjunction + " ");
  } else {
    return [].concat(_toConsumableArray(words.slice(0, wc - 1)), [conjunction + " " + words[wc - 1]]).join(", ");
  }
};

var formatFileSize = function formatFileSize(size) {
  // NOTE: Math.log10 is not available in every browser and Math.log / Math.LN10
  // is unreliable.
  var thousands = Math.floor((("" + size).length - 1) / 3);
  return "" + Math.round(size / Math.pow(10, 3 * thousands)) + "BKMGTP"[thousands];
};

var formatUSD = function formatUSD(val) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  options = Object.assign({
    style: "currency",
    currency: "USD"
  }, options);

  return type(val) !== "number" ? null : val.toLocaleString("en", options);
};

var getLocale = function getLocale() {
  var _window = window,
      navigator = _window.navigator;

  if (navigator == null) return null;
  return navigator.languages && navigator.languages.length ? navigator.languages[0] : navigator.language;
};

/**
 * This function is a wrapper for Number.toLocalString() however it tries to use
 * the device's language. If all else fails, it uses "en".
 *
 * TODO(oscar): Fix the Intl polyfill we use, so there's no issue using
 * `undefined` as the locale.
 */
var numberToLocaleString = function numberToLocaleString(n, options, locale) {
  var f = function f(locale) {
    try {
      return Number(n).toLocaleString(locale, options);
    } catch (e) {}
  };
  return f(locale) || f() || f(getLocale()) || f("en");
};

var getIn = function getIn(m, ks, d) {
  if (m == null) return d;
  if (ks.length === 1) {
    return m[ks[0]];
  }

  return getIn(m[ks[0]], ks.slice(1));
};

var kebabCase = function kebabCase(str) {
  // A "-" will be inserted before every capital letter, so make sure the first
  // character isn't capitalized.
  str = str.charAt(0).toLowerCase() + str.slice(1);
  // Convert camel case to kebab case.
  str = str.replace(/[A-Z]/g, "-$&").toLowerCase();
  // Convert snake case to kebab case.
  str = str.replace(/_/g, "-");

  return str;
};

var isPromise = function isPromise(obj) {
  return Promise.resolve(obj) === obj;
};

var isEmpty = function isEmpty(obj) {
  return obj == null || Object.keys(obj).length === 0 &&
  // Needed for iterables like `Set`.
  Array.from(obj).length === 0 && (obj.size || 0) === 0;
};

var loadImage = function loadImage(url) {
  var crossOrigin = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  if (!url) return Promise.reject(new Error("No image URL provided"));

  return new Promise(function (resolve, reject) {
    var img = new Image();
    img.crossOrigin = crossOrigin;
    img.addEventListener("load", function () {
      return resolve(img);
    });
    img.addEventListener("error", reject);
    img.src = url;
    if (img.complete) {
      resolve(img);
    }
  });
};

var loadImages = function loadImages(urls) {
  var crossOrigin = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return Promise.all(urls.filter(function (url) {
    return url != null;
  }).map(function (url) {
    return loadImage(url, crossOrigin);
  }));
};

var mapByID = function mapByID(arr) {
  var fn = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  return arr.reduce(function (map, item) {
    map[item.id] = fn != null ? fn(item) : item;
    return map;
  }, {});
};

var mapcat = function mapcat(arr, fn) {
  return [].concat.apply([], arr.map(fn));
};

// Like `Object.assign`, merges subsequent object arguments into the first
// object argument `defaults`, but only keys that exist in `defaults`.
// Unlike `Object.assign`, does not modify the first argument, but returns a
// shallow clone instead.
var mergePropertiesWithDefaults = function mergePropertiesWithDefaults(defaults) {
  for (var _len3 = arguments.length, args = Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
    args[_key3 - 1] = arguments[_key3];
  }

  if (args.length === 0) return defaults;

  var target = Object.assign(defaults);
  var keys = Object.keys(target);

  args.forEach(function (source) {
    if (source == null) return;

    keys.forEach(function (key) {
      if (source.hasOwnProperty(key) && source[key] !== undefined) {
        target[key] = source[key];
      }
    });
  });

  return target;
};

var objFromQueryString = function objFromQueryString() {
  var str = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : location.search.slice(1);

  return str.split("&").reduce(function (acc, part) {
    var _part$split$map = part.split("=", 2).map(decodeURIComponent),
        _part$split$map2 = _slicedToArray(_part$split$map, 2),
        key = _part$split$map2[0],
        value = _part$split$map2[1];

    if (key != null && value != null) {
      acc[key] = value;
    }

    return acc;
  }, {});
};

var objToQueryString = function objToQueryString(obj) {
  return Object.keys(obj).filter(function (key) {
    return obj[key] != null;
  }).map(function (key) {
    return encodeURIComponent(key) + "=" + encodeURIComponent(obj[key]);
  }).join("&");
};

/**
 * Given a `Promise` that should resolve with a `Response` (e.g. a `Promise` returned by `fetch`), returns
 * a new Promise that will reject if 1) the original `Promise` rejects, 2) the original `Promise` resolves
 * with something that's not a `Response`, or 3) the original response had an error status.
 */
var wrapResponsePromise = function wrapResponsePromise(responsePromise) {
  return new Promise(function (resolve, reject) {
    return responsePromise.then(function (response) {
      if (!(response instanceof Response && response.ok)) {
        reject(response);
        return;
      }

      resolve(response);
    }).catch(reject);
  });
};

/**
 * Like `fetch` but returns a `Promise` that rejects if `!response.ok`. This allows calling code to handle
 * non-ok responses (e.g. 404s and 500s) using `Promise.catch`.
 */
var errorSensitiveFetch = function errorSensitiveFetch() {
  return wrapResponsePromise(fetch.apply(undefined, arguments));
};

var postJSON = function postJSON(url, json, options) {
  return makeJSONRequest(url, json, "POST", options);
};

var patchJSON = function patchJSON(url, json, options) {
  return makeJSONRequest(url, json, "PATCH", options);
};

/**
 * Sends a `fetch` request to `url` using the given `method` (e.g. "GET", "POST", "PATCH") and returns a
 * `Promise` that resolves with a `Response`. If `options.rejectOnErrorResponse === true`, the returned
 * `Promise` will reject if the sever returns an error response.
 */
function makeJSONRequest(url, json, method) {
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var _options$rejectOnErro = options.rejectOnErrorResponse,
      rejectOnErrorResponse = _options$rejectOnErro === undefined ? false : _options$rejectOnErro;

  var fetchPromise = fetch(url, {
    body: JSON.stringify(json),
    credentials: "same-origin",
    headers: { "Content-Type": "application/json; charset=utf-8" },
    method: method
  });
  if (!rejectOnErrorResponse) {
    return fetchPromise;
  }
  return wrapResponsePromise(fetchPromise);
}

var ping = function ping(url) {
  var img = new Image();
  img.src = url;
};

// Polls a `url` for up to `timeoutMS`. Assumes the response is a JSON object
// with keys { state, value } where the values for `state` are one of
// ["success", "failed", "timeout"].
var poll = function poll(url, timeoutMS) {
  var timedOut = false;
  setTimeout(function () {
    return timedOut = true;
  }, timeoutMS);

  var request = function request() {
    if (timedOut) {
      return Promise.reject(new Error("poll exceeded timeout duration"));
    }

    return fetch(url, { credentials: "same-origin" }).then(function (response) {
      return response.json();
    }).then(function (_ref6) {
      var state = _ref6.state,
          value = _ref6.value;

      switch (state) {
        case "success":
          return value;
        case "failed":
          throw new Error("poll received failed response with value: " + value);
        case "timeout":
          return request();
        default:
          throw new Error("poll received response with unknown state: " + state);
      }
    });
  };

  return request();
};

var precisionRound = function precisionRound(number, precision) {
  var factor = Math.pow(10, precision);

  return Math.round(number * factor) / factor;
};

var randomInt = function randomInt(low, high) {
  return low + Math.floor(Math.random() * (high - low));
};

// Returns an array of integers from [start, stop) (i.e. exclusive of stop).
// Special case: if start === stop, return array with start as the only
// element.
var range = function range(start, stop) {
  var step = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;

  if (start === stop) return [start];

  if (stop - start < 0 !== step < 0) {
    throw new Error("Invalid call to range: range(" + start + ", " + stop + ", " + step + ")");
  }

  return Array((stop - start) / step | 0).fill(null).map(function (_, i) {
    return start + i * step;
  });
};

var request = function request(method, url) {
  var headers = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var body = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

  return new Promise(function (resolve, reject) {
    var req = new XMLHttpRequest();
    req.onreadystatechange = function () {
      if (req.readyState === 4 && req.status === 200) {
        resolve(req);
      }
    };
    req.addEventListener("load", resolve.bind(null, req));
    req.addEventListener("error", reject.bind(null, req));
    req.open(method.toUpperCase(), url);
    Object.keys(headers).forEach(function (key) {
      req.setRequestHeader(key, headers[key]);
    });
    req.send(body);
  });
};

var runAsync = function runAsync(fn) {
  setTimeout(fn, 0);
};

var removeKeys = function removeKeys(source, keys) {
  if (source == null) return {};

  return Object.keys(source).filter(function (key) {
    return !keys.includes(key);
  }).reduce(function (target, key) {
    target[key] = source[key];

    return target;
  }, {});
};

/** Remove keys if their value is empty.  */
var removeEmptyKeys = function removeEmptyKeys(source) {
  return selectKeys(source, function (_, val) {
    return !isEmpty(val);
  });
};

var selectKeys = function selectKeys(source, keys) {
  if (source == null) return {};

  switch (type(keys)) {
    case "array":
      return keys.reduce(function (target, key) {
        if (source.hasOwnProperty(key)) {
          target[key] = source[key];
        }

        return target;
      }, {});
    case "function":
      return Object.keys(source).reduce(function (target, key) {
        if (keys(key, source[key])) {
          target[key] = source[key];
        }

        return target;
      }, {});
  }
};

/**
 * Reorders items randomly into a new Array.
 * @param {Iterable} arr
 * @returns {Array}
 */
var shuffle = function shuffle(arr) {
  var result = [].concat(_toConsumableArray(arr));
  for (var i = result.length - 1; i > 0; i--) {
    var j = Math.floor(Math.random() * (i + 1));
    var _ref7 = [result[j], result[i]];
    result[i] = _ref7[0];
    result[j] = _ref7[1];
  }
  return result;
};

// Like `Array.sort()`, but maintains the relative order of array items with
// equal sort values and does not mutate the original array.
var stableSort = function stableSort(arr, sortFn) {
  var index = arr.reduce(function (agg, item, i) {
    agg.set(item, i);

    return agg;
  }, new Map());

  return arr.slice().sort(function (a, b) {
    return sortFn(a, b) || index.get(a) - index.get(b);
  });
};

var timeDifference = function timeDifference(a, b) {
  var msPerSecond = 1000,
      msPerMinute = msPerSecond * 60,
      msPerHour = msPerMinute * 60,
      msPerDay = msPerHour * 24,
      msPerWeek = msPerDay * 7,
      msPerMonth = msPerWeek * 4,
      msPerYear = msPerMonth * 13,
      elapsed = Math.abs(a - b);
  if (a <= b && elapsed < 1000 * 10) {
    return "just now";
  } else {
    var val = void 0,
        units = void 0;
    if (elapsed < msPerMinute) {
      val = Math.round(elapsed / msPerSecond);
      units = "second";
    } else if (elapsed < msPerHour) {
      val = Math.round(elapsed / msPerMinute);
      units = "minute";
    } else if (elapsed < msPerDay) {
      val = Math.round(elapsed / msPerHour);
      units = "hour";
    } else if (elapsed < msPerWeek) {
      val = Math.round(elapsed / msPerDay);
      units = "day";
    } else if (elapsed < msPerMonth) {
      val = Math.round(elapsed / msPerWeek);
      units = "week";
    } else if (elapsed < msPerYear) {
      val = Math.round(elapsed / msPerMonth);
      units = "month";
    } else {
      val = Math.round(elapsed / msPerYear);
      units = "year";
    }

    return [val, "" + units + (val === 1 ? "" : "s"), a < b ? "ago" : "from now"].join(" ");
  }
};

var type = function type(object) {
  return {}.toString.call(object).match(/\s([a-zA-Z]+)/)[1].toLowerCase();
};

/** Returns a Promise that resolves after `ms` ms. */
var wait = function wait(ms) {
  return new Promise(function (resolve) {
    setTimeout(resolve, ms);
  });
};

/** Returns a Promise that rejects after `ms` ms. */
var timeout = function timeout(ms) {
  return new Promise(function (_, reject) {
    setTimeout(function () {
      return reject(new Error("Promise timed out after " + ms + "ms"));
    }, ms);
  });
};

var unique = function unique(arr) {
  return arr.filter(function (el, i) {
    return arr.indexOf(el) === i;
  });
};

var isFunction = function isFunction(object) {
  return type(object) === "function";
};

/***/ }),
/* 1 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "addOneTimeListener", function() { return addOneTimeListener; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "animationEndPromise", function() { return animationEndPromise; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "transitionEndPromise", function() { return transitionEndPromise; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "runTransitionSequence", function() { return runTransitionSequence; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "appendChildren", function() { return appendChildren; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "copyToClipboard", function() { return copyToClipboard; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createElement", function() { return createElement; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "empty", function() { return empty; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchHTML", function() { return fetchHTML; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "firstAncestor", function() { return firstAncestor; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fragmentFromString", function() { return fragmentFromString; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "forceReflow", function() { return forceReflow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "generateSnippetMap", function() { return generateSnippetMap; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getCSSProperty", function() { return getCSSProperty; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getElementsByClass", function() { return getElementsByClass; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getRelativeBoundingClientRect", function() { return getRelativeBoundingClientRect; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getAggregateBoundingClientRect", function() { return getAggregateBoundingClientRect; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getFontSizeToFit", function() { return getFontSizeToFit; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getFontSizeToFitLines", function() { return getFontSizeToFitLines; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "indexOf", function() { return indexOf; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "imageIsRendered", function() { return imageIsRendered; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "off", function() { return off; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "on", function() { return on; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "onAnimationsComplete", function() { return onAnimationsComplete; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "parseCSSLength", function() { return parseCSSLength; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "prependChild", function() { return prependChild; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "replaceStyle", function() { return replaceStyle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "scrollIntoView", function() { return scrollIntoView; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "strToElement", function() { return strToElement; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "strToStyle", function() { return strToStyle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "writeToIframe", function() { return writeToIframe; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "preparetagHTML", function() { return preparetagHTML; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "appendImpressionTags", function() { return appendImpressionTags; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(0);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



var addOneTimeListener = function addOneTimeListener(el, eventName, fn) {
  var ignoreBubbling = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

  var listener = function listener(event) {
    if (ignoreBubbling && event.target !== el) return;

    el.removeEventListener(eventName, listener);
    fn(event);
  };
  el.addEventListener(eventName, listener);
};

/** Responds to the first event triggered. Useful for polyfilling webkit prefixed events. */
var eventRacePromise = function eventRacePromise(el, events) {
  var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
      timeout = _ref.timeout,
      _ref$matchTarget = _ref.matchTarget,
      matchTarget = _ref$matchTarget === undefined ? false : _ref$matchTarget;

  var eventsString = [].concat(events).join(" ");
  return new Promise(function (resolve) {
    var callbackRun = false;
    var callback = function callback() {
      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      if (callbackRun || matchTarget && el !== args[0].target) return;
      callbackRun = true;
      resolve.apply(undefined, args);
      off(el, _defineProperty({}, eventsString, callback));
    };

    on(el, _defineProperty({}, eventsString, callback));
    if (timeout != null) {
      setTimeout(function () {
        return callback({ message: "Promise timed out." });
      }, timeout);
    }
  });
};

var animationEndPromise = function animationEndPromise(el) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return eventRacePromise(el, "animationend webkitAnimationEnd", options);
};

var transitionEndPromise = function transitionEndPromise(el) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return eventRacePromise(el, "transitionend webkitTransitionEnd", options);
};

/**
 * Given:
 *   - `el` - a DOM node
 *   - `transitions` - an array where each element is either 1) a function, or 2) an object of style property
 *     names to values
 * this sequentially 1) runs the function and waits for the Promise returned by the function to resolve (if
 * the function returns a Promise) before moving onto the next step, or 2) applies the styles to `el` and
 * waits for a `transitionend` event before moving onto the next step. Returns a Promise. `timeoutMS` is
 * an optional duration (in ms) after which the next transition should be run even if the previous transition
 * has not completed or if the previous function's returned promise has not resolved.
 */
var runTransitionSequence = function runTransitionSequence(el, transitions) {
  var _ref2 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
      _ref2$timeoutMS = _ref2.timeoutMS,
      timeoutMS = _ref2$timeoutMS === undefined ? null : _ref2$timeoutMS,
      _ref2$continueFn = _ref2.continueFn,
      continueFn = _ref2$continueFn === undefined ? function () {
    return true;
  } : _ref2$continueFn;

  return transitions.reduce(function (prevTransitionEndPromise, thisTransition) {
    return prevTransitionEndPromise.finally(function () {
      if (!continueFn()) {
        return Promise.resolve();
      }

      var currentTransitionEndPromise = void 0;
      if (Object(__WEBPACK_IMPORTED_MODULE_0__utils__["isFunction"])(thisTransition)) {
        currentTransitionEndPromise = thisTransition();
      } else {
        currentTransitionEndPromise = transitionEndPromise(el);
        Object.assign(el.style, thisTransition);
      }

      if (timeoutMS == null) {
        return currentTransitionEndPromise;
      }

      return Promise.race([Object(__WEBPACK_IMPORTED_MODULE_0__utils__["timeout"])(timeoutMS), currentTransitionEndPromise]);
    });
  }, Promise.resolve());
};

var appendChildren = function appendChildren(node, children) {
  var fragment = document.createDocumentFragment();

  children.forEach(function (child) {
    if (!child) return;

    fragment.appendChild(child instanceof Node ? child : createElement(child));
  });

  node.appendChild(fragment);
};

var copyToClipboard = function copyToClipboard(text, multiline) {
  var elemType = multiline ? "textarea" : "input";
  var el = document.createElement(elemType);
  document.body.appendChild(el);
  el.value = text;
  el.select();
  document.execCommand("copy");
  el.remove();
};

/**
 * @param {Object} elementConfig A map of options specifying a new Element.
 * @param {String} [elementConfig.namespace = null] A namespace URI to associate with the new element.
 * See https://developer.mozilla.org/en-US/docs/Web/API/Document/createElementNS for details.
 * @param {String} [elementConfig.tagName = "div"] The tag name determining the result
 * Element's type. Defaults to "div".
 * @param {String[]} [elementConfig.classList = []] A list of classes. Falsy values
 * are ignored. Defaults to [].
 * @param {{}} [elementConfig.style = {}] A map of style settings to merge into the result
 * Element's style. Defaults to {}.
 * @param {{}} [elementConfig.attributes = {}] A map of attributes to set on the result
 * Element. Defaults to {}.
 * @param {{}} [elementConfig.data = {}] A map of data to merge into the result Element's
 * dataset. Defaults to {}.
 * @param {({}|Element)[]} [elementConfig.children = []] An array of Elements or
 * elementConfigs to append as children. Falsy values are ignored. Defaults to [].
 * @param {{}} [elementConfig.eventHandlers = {}] A map from event names to handlers,
 * which will all be assigned to listen on the result Element. Defaults to {}.
 * @returns {HTMLElement} An Element object with properties corresponding to the parameters.
 */
var createElement = function createElement(elementConfig) {
  if (Object(__WEBPACK_IMPORTED_MODULE_0__utils__["type"])(elementConfig) === "string" || Object(__WEBPACK_IMPORTED_MODULE_0__utils__["type"])(elementConfig) === "number") {
    return document.createTextNode(elementConfig);
  }

  var _elementConfig$namesp = elementConfig.namespace,
      namespace = _elementConfig$namesp === undefined ? null : _elementConfig$namesp,
      _elementConfig$tagNam = elementConfig.tagName,
      tagName = _elementConfig$tagNam === undefined ? "div" : _elementConfig$tagNam,
      _elementConfig$classL = elementConfig.classList,
      classList = _elementConfig$classL === undefined ? [] : _elementConfig$classL,
      _elementConfig$style = elementConfig.style,
      style = _elementConfig$style === undefined ? {} : _elementConfig$style,
      _elementConfig$attrib = elementConfig.attributes,
      attributes = _elementConfig$attrib === undefined ? {} : _elementConfig$attrib,
      _elementConfig$data = elementConfig.data,
      data = _elementConfig$data === undefined ? {} : _elementConfig$data,
      _elementConfig$childr = elementConfig.children,
      children = _elementConfig$childr === undefined ? [] : _elementConfig$childr,
      _elementConfig$eventH = elementConfig.eventHandlers,
      eventHandlers = _elementConfig$eventH === undefined ? {} : _elementConfig$eventH,
      unintendedProps = _objectWithoutProperties(elementConfig, ["namespace", "tagName", "classList", "style", "attributes", "data", "children", "eventHandlers"]);

  var unintendedKeys = Object.keys(unintendedProps);
  if (unintendedKeys.length > 0) {
    throw new Error("`createElement` must not receive unintended keys: " + JSON.stringify(unintendedKeys));
  }

  var element = namespace == null ? document.createElement(tagName) : document.createElementNS(namespace, tagName);
  var filteredClassList = (classList || []).filter(function (className) {
    return className;
  });
  if (filteredClassList.length > 0) {
    var _element$classList;

    (_element$classList = element.classList).add.apply(_element$classList, _toConsumableArray(filteredClassList));
  }
  Object.assign(element.style, style);

  Object.entries(attributes).forEach(function (_ref3) {
    var _ref4 = _slicedToArray(_ref3, 2),
        name = _ref4[0],
        value = _ref4[1];

    element.setAttribute(name, value);
  });
  Object.assign(element.dataset, data);

  if (children.length > 0) {
    appendChildren(element, children);
  }

  on(element, eventHandlers);

  return element;
};


var empty = function empty(node) {
  while (node.firstChild) {
    node.removeChild(node.firstChild);
  }

  return node;
};

var fetchHTML = function fetchHTML(url) {
  return fetch(url).then(function (response) {
    return response.text();
  }).then(strToElement);
};

var firstAncestor = function firstAncestor(node, selector) {
  var halt = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "body";

  while (node != null && !node.matches(selector)) {
    if (node.matches(halt)) return null;

    node = node.parentNode;
  }

  return node;
};

/**
 * Returns a DocumentFragment containing the given HTML string, or null if
 * the string is empty or falsey.
 */
var fragmentFromString = function fragmentFromString(strHTML) {
  if (!strHTML) {
    return null;
  }

  var templateEl = document.createElement("template");
  templateEl.innerHTML = strHTML;
  return templateEl.content;
};

// Forces a reflow of the element so that cached styles are recomputed. This is
// important for ensuring that animations are used when changing styles or CSS
// classes via JS. See http://stackoverflow.com/q/11131875.
var forceReflow = function forceReflow(el) {
  el.offsetHeight;
};

var generateSnippetMap = function generateSnippetMap(html) {
  var wrapper = document.createElement("div");
  wrapper.innerHTML = html;
  var snippets = [].concat(_toConsumableArray(wrapper.querySelectorAll("[data-snippet]"))).reduce(function (coll, node) {
    var name = node.dataset.snippet;
    coll[name] = node;
    node.removeAttribute("data-snippet");
    node.remove();

    return coll;
  }, {});

  return function (name) {
    if (snippets[name] == null) return;

    return snippets[name].cloneNode(true);
  };
};

var getCSSProperty = function getCSSProperty(node, property) {
  return window.getComputedStyle(node).getPropertyValue(property);
};

var getElementsByClass = function getElementsByClass(parent, classNames) {
  return classNames.reduce(function (elements, name) {
    elements[Object(__WEBPACK_IMPORTED_MODULE_0__utils__["camelCase"])(name)] = parent.querySelector("." + name);

    return elements;
  }, {});
};

// A version of `getBoundingClientRect` relative to a reference node instead
// of the window.
var getRelativeBoundingClientRect = function getRelativeBoundingClientRect(node) {
  var reference = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  if (reference == null) {
    reference = node.parentNode;
  }

  var rect = node.getBoundingClientRect();
  var refRect = reference.getBoundingClientRect();
  return {
    top: rect.top - refRect.top,
    bottom: rect.bottom - refRect.bottom,
    left: rect.left - refRect.left,
    right: rect.right - refRect.right,
    width: rect.width,
    height: rect.height
  };
};

// Determines a bounding rectangle that encompasses all given nodes.
var getAggregateBoundingClientRect = function getAggregateBoundingClientRect(nodes) {
  return [].concat(_toConsumableArray(nodes)).reduce(function (agg, node) {
    var rect = node.getBoundingClientRect();
    agg.top = Math.min(agg.top, rect.top);
    agg.bottom = Math.max(agg.bottom, rect.bottom);
    agg.left = Math.min(agg.left, rect.left);
    agg.right = Math.max(agg.right, rect.right);
    agg.width = Math.max(agg.width, rect.left - agg.left + rect.width);
    agg.height = Math.max(agg.height, rect.top - agg.top + rect.height);
    return agg;
  }, {
    top: Infinity,
    bottom: 0,
    left: Infinity,
    right: 0,
    width: 0,
    height: 0
  });
};

// Given an element, this will return an integer that is the maximum font size (in px) that allows all the
// text to fit without overflow.
var getFontSizeToFit = function getFontSizeToFit(el) {
  var maxFontSizePx = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 24;

  var startingFontSize = el.style.fontSize;
  var startingOverflow = el.style.overflow;
  el.style.overflow = "hidden";
  var high = maxFontSizePx + 1;
  var low = 0;
  el.style.fontSize = high + "px";
  while (low + 1 < high) {
    var mid = low + (high - low >> 1);
    el.style.fontSize = mid + "px";
    if (el.clientHeight < el.scrollHeight || el.clientWidth < el.scrollWidth) {
      high = mid;
    } else {
      low = mid;
    }
  }

  el.style.fontSize = startingFontSize;
  el.style.overflow = startingOverflow;
  return low;
};

/**
 * Attempt to calculate the `font-size` needed to have the text of `el` fit within the given number of lines.
 *
 * This is far from a perfect solution as there are several factors that determine line count not to mention
 * occasional ambiguity of what constitutes a "line" when there's `innerHTML` to contend with.
 *
 * @param {HTMLElement} el - Element with text to fit `maxLines`.
 * @param {number} maxLines - Max line count to calculate for.
 * @param {number} [precision] - The amount in px to incrementally adjust `font-size` by to determine changes.
 * @return {number} - In px.
 */
var getFontSizeToFitLines = function getFontSizeToFitLines(el, maxLines) {
  var precision = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0.5;

  /**
   * NOTE(oscar): The computed style of certain "older" properties should always be in px regardless of
   * applied style.
   * @see https://developer.mozilla.org/en-US/docs/Web/API/Window/getComputedStyle
   */
  var fontSize = parseFloat(getCSSProperty(el, "font-size"));

  var prevFontSizeStyle = el.style.fontSize;
  var prevHeight = el.style.height;
  var prevLineHeight = el.style.lineHeight;
  el.style.height = "unset";

  // NOTE(oscar): Ensures line-height is sensitive to changes in font-size.
  el.style.lineHeight = "10em";

  var computedFontSize = Object(__WEBPACK_IMPORTED_MODULE_0__utils__["binaryFind"])(Object(__WEBPACK_IMPORTED_MODULE_0__utils__["range"])(precision, fontSize, precision), function (value) {
    el.style.fontSize = value + precision + "px";
    var lineHeight = parseFloat(getCSSProperty(el, "line-height"));
    var paddingTop = parseFloat(getCSSProperty(el, "padding-top"));
    var paddingBottom = parseFloat(getCSSProperty(el, "padding-bottom"));
    var textHeight = el.getBoundingClientRect().height - paddingTop - paddingBottom;
    return textHeight > lineHeight * maxLines;
  }) || fontSize;

  el.style.height = prevHeight;
  el.style.fontSize = prevFontSizeStyle;
  el.style.lineHeight = prevLineHeight;
  return computedFontSize;
};

var indexOf = function indexOf(node) {
  return [].indexOf.call(node.parentNode.children, node);
};

// Returns a Promise that resolves when the passed Image is rendered (determined by polling for a non-zero
// clientWidth and clientHeight).
var imageIsRendered = function imageIsRendered(img) {
  var timeout = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 10000;

  var start = Date.now();
  return new Promise(function (resolve, reject) {
    var checkRendered = function checkRendered() {
      if (Date.now() - start >= timeout) {
        reject(new Error("Timeout loading image \"" + img.src + "\""));
      } else if (img.clientWidth === 0 || img.clientHeight === 0) {
        requestAnimationFrame(checkRendered);
      } else {
        resolve();
      }
    };

    requestAnimationFrame(checkRendered);
  });
};

var off = function off(node, events) {
  Object.keys(events).forEach(function (names) {
    var listener = events[names];

    names.trim().split(/\s+/).forEach(function (name) {
      node.removeEventListener(name, listener);
    });
  });
};

var on = function on(node, events) {
  Object.keys(events).forEach(function (names) {
    var listener = events[names];

    names.trim().split(/\s+/).forEach(function (name) {
      node.addEventListener(name, listener);
    });
  });
};

var onAnimationsComplete = function onAnimationsComplete(els, callback) {
  var animationsLeft = els.length;
  els.forEach(function (el) {
    addOneTimeListener(el, "webkitAnimationEnd", function () {
      animationsLeft -= 1;
      if (animationsLeft === 0) {
        callback();
      }
    });
  });
};

// Returns a map of { units, value } for a CSS length property.
// The length must be a string with "px" or "%" units or a value of 0.
var parseCSSLength = function parseCSSLength(length) {
  if (length === 0 || length === "0") return { value: 0, units: "px" };

  var match = /(.+)(px|%)/.exec(length);
  if (!match) return null;

  var _match = _slicedToArray(match, 3),
      _ = _match[0],
      value = _match[1],
      units = _match[2];

  if (value == null || units == null) return null;

  return { units: units, value: Number(value) };
};

var prependChild = function prependChild(parentNode, node) {
  parentNode.insertBefore(node, parentNode.children[0]);

  return parentNode;
};

var replaceStyle = function replaceStyle(element) {
  for (var _len2 = arguments.length, newStyles = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
    newStyles[_key2 - 1] = arguments[_key2];
  }

  element.removeAttribute("style");
  Object.assign.apply(Object, [element.style].concat(newStyles));
};

var scrollIntoView = function scrollIntoView(node) {
  var rect = node.getBoundingClientRect();
  var pRect = node.parentNode.getBoundingClientRect();
  var topDiff = rect.top - pRect.top;
  var botDiff = rect.bottom - pRect.bottom;

  if (topDiff < 0 && botDiff > 0) {
    node.parentNode.scrollTop += (topDiff + botDiff) / 2;
  } else if (topDiff < 0) {
    node.parentNode.scrollTop += topDiff;
  } else if (botDiff > 0) {
    node.parentNode.scrollTop += botDiff;
  }
};

var strToElement = function strToElement(str) {
  var div = document.createElement("div");
  div.innerHTML = str.replace(/\n\s*/g, "");

  return div.firstChild;
};

var strToStyle = function strToStyle(str) {
  var style = document.createElement("style");
  style.innerHTML = str;

  return style;
};

/** Writes `contentHTML` into `iframeEl`. */
var writeToIframe = function writeToIframe(iframeEl, contentHTML) {
  iframeEl.contentWindow.document.open();
  iframeEl.contentWindow.document.write(contentHTML);
  iframeEl.contentWindow.document.close();
};

var preparetagHTML = function preparetagHTML(tagHTML) {
  var wrapperEl = document.createElement("div");
  wrapperEl.innerHTML = tagHTML;

  // Script tags must be reattached in order to run.
  [].concat(_toConsumableArray(wrapperEl.querySelectorAll("script"))).forEach(function (originalScriptTag) {
    var replacementScriptTag = document.createElement("script");
    [].concat(_toConsumableArray(originalScriptTag.attributes)).forEach(function (_ref5) {
      var name = _ref5.nodeName,
          value = _ref5.nodeValue;

      replacementScriptTag.setAttribute(name, value);
    });
    replacementScriptTag.innerHTML = originalScriptTag.innerHTML;
    originalScriptTag.parentNode.replaceChild(replacementScriptTag, originalScriptTag);
  });

  return wrapperEl;
};

var appendImpressionTags = function appendImpressionTags(containerEl, impressionTags) {
  impressionTags.forEach(function (tagHTML) {
    var wrapper = preparetagHTML(tagHTML);
    containerEl.append(wrapper);
  });
};

/***/ }),
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return PLATFORM_ANDROID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "K", function() { return PLATFORM_IOS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AUDIO_POLICY_ALWAYS_MUTE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return AUDIO_POLICY_ON_INTERACTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return AUDIO_POLICY_NO_RESTRICTIONS; });
/* unused harmony export EXCHANGE_A9TAM */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return EXCHANGE_ADPOPCORN; });
/* unused harmony export EXCHANGE_APPLOVIN */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return EXCHANGE_CONNATIX; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return EXCHANGE_DOUBLECLICK; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return EXCHANGE_INNERACTIVE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return EXCHANGE_IRONSOURCE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return EXCHANGE_MINTEGRAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return EXCHANGE_MOMENTO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return EXCHANGE_PANGLE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return EXCHANGE_VERVE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return EXCHANGE_VUNGLE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return EXCHANGE_XIAOMI; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return ORIENTATION_PORTRAIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return ORIENTATION_LANDSCAPE; });
/* unused harmony export CONNECTION_TYPE_WIFI */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return CLICK_AREA_TYPE_OTHER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return CLICK_AREA_TYPE_CTA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return CLICK_METRIC_TYPE_CLOSE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return CLICK_METRIC_TYPE_CTA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return CLICK_METRIC_TYPE_DEADZONE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return CLICK_METRIC_TYPE_UNKNOWN; });
/* unused harmony export CLICK_REJECTION_REASON_UNKNOWN */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return CLICK_REJECTION_REASON_NO_INTERACTIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return CLICKTHROUGH_URL_TYPE_LIFTOFF_ENDPOINT; });
/* unused harmony export CLICKTHROUGH_URL_TYPE_APP_STORE */
/* unused harmony export CLICK_TRACKING_URL_TYPE_UNKNOWN */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return CLICK_TRACKING_URL_TYPE_LIFTOFF_ENDPOINT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N", function() { return TRACKING_METHOD_OPEN_METHOD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "M", function() { return TRACKING_METHOD_IMAGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "L", function() { return TRACKING_METHOD_BEACON; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return AUTOCLICK_TYPE_LAST_INTERACTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return AUTOCLICK_TYPE_INTERACTION_COUNT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return AUTOCLICK_TYPE_LAST_INTERACTION_AND_INTERACTION_COUNT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return AUTOCLICK_TYPE_COMPLETED_DELAY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return AUTOCLICK_TYPE_LOAD_DELAY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return AUTOCLICK_TYPE_VIEWABLE_DELAY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return AUTOCLICK_TYPE_VIEWABLE_DELAY_WITH_RESET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return CLICK_OPEN_METHOD_MRAID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return CLICK_OPEN_METHOD_ANCHOR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return CLICK_OPEN_METHOD_LOCATION; });
var PLATFORM_ANDROID = "android";
var PLATFORM_IOS = "ios";

var AUDIO_POLICY_ALWAYS_MUTE = "always-mute";
var AUDIO_POLICY_ON_INTERACTION = "on-interaction";
var AUDIO_POLICY_NO_RESTRICTIONS = "no-restrictions";

// TODO(Casey): Use constants instead of string literals for all exchanges
// throughout.
var EXCHANGE_A9TAM = "a9tam";
var EXCHANGE_ADPOPCORN = "adpopcorn";
var EXCHANGE_APPLOVIN = "applovin";
var EXCHANGE_CONNATIX = "connatix";
var EXCHANGE_DOUBLECLICK = "doubleclick";
var EXCHANGE_INNERACTIVE = "inneractive-direct";
var EXCHANGE_IRONSOURCE = "ironsource";
var EXCHANGE_MINTEGRAL = "mintegral";
var EXCHANGE_MOMENTO = "momento";
var EXCHANGE_PANGLE = "pangle";
var EXCHANGE_VERVE = "verve";
var EXCHANGE_VUNGLE = "vungle";
var EXCHANGE_XIAOMI = "xiaomi";

var ORIENTATION_PORTRAIT = "portrait";
var ORIENTATION_LANDSCAPE = "landscape";

// These must correspond to the rtb.proto ConnectionType enum definition.
var CONNECTION_TYPE_WIFI = 2;

// These must correspond to the rtb.proto ClickAreaType enum definition.
var CLICK_AREA_TYPE_OTHER = 1;
var CLICK_AREA_TYPE_CTA = 3;

var CLICK_METRIC_TYPE_CLOSE = "CLOSE";
var CLICK_METRIC_TYPE_CTA = "CTA";
var CLICK_METRIC_TYPE_DEADZONE = "DEADZONE";
var CLICK_METRIC_TYPE_UNKNOWN = "UNKNOWN_CLICK_TYPE";

// This must correspond to the rtb.proto ClickRejectionReason enum definition.
var CLICK_REJECTION_REASON_UNKNOWN = 0;
var CLICK_REJECTION_REASON_NO_INTERACTIONS = 1;

// This must correspond to the auction.proto ClickthroughURLType.
var CLICKTHROUGH_URL_TYPE_LIFTOFF_ENDPOINT = 1;
var CLICKTHROUGH_URL_TYPE_APP_STORE = 2;

// This must correspond to the auction.proto ClickTrackingURLType.
var CLICK_TRACKING_URL_TYPE_UNKNOWN = 0;
var CLICK_TRACKING_URL_TYPE_LIFTOFF_ENDPOINT = 1;

// This must correspond to the rtb.proto TrackingMethod enum definition.
var TRACKING_METHOD_OPEN_METHOD = 1;
var TRACKING_METHOD_IMAGE = 2;
var TRACKING_METHOD_BEACON = 3;

var AUTOCLICK_TYPE_LAST_INTERACTION = "lastInteraction";
var AUTOCLICK_TYPE_INTERACTION_COUNT = "interactionCount";
var AUTOCLICK_TYPE_LAST_INTERACTION_AND_INTERACTION_COUNT = "lastInteractionAndInteractionCount";
var AUTOCLICK_TYPE_COMPLETED_DELAY = "completedDelay";
var AUTOCLICK_TYPE_LOAD_DELAY = "loadDelay";
var AUTOCLICK_TYPE_VIEWABLE_DELAY = "viewableDelay";
var AUTOCLICK_TYPE_VIEWABLE_DELAY_WITH_RESET = "viewableDelayWithReset";

var CLICK_OPEN_METHOD_MRAID = "mraid";
var CLICK_OPEN_METHOD_ANCHOR = "anchor";
var CLICK_OPEN_METHOD_LOCATION = "location";

/***/ }),
/* 3 */,
/* 4 */,
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__adexp__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__error_handling__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__frontendlib_utils__ = __webpack_require__(0);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }





/**
 * Sends log to Adexp.
 */
var postJSON = function postJSON(url, data) {
  /**
   * TODO(oscar): Investigate if we could improve empty payloads.
   * @see https://github.com/liftoffio/liftoff/pull/25293
   */
  if (data == null) {
    console.error("No data to post for logging.");
    return Promise.resolve();
  }
  var payload = JSON.stringify(data);

  if (payload.length < 2) {
    console.error("Data could not be stringified for logging.");
    return Promise.resolve();
  }

  return Object(__WEBPACK_IMPORTED_MODULE_2__frontendlib_utils__["request"])("POST", url, {
    // Don't set the content type to "application/json" because that requires
    // a preflight OPTIONS request (because this is a cross-domain request).
    "Content-Type": "text/plain"
  }, payload).catch(function () {
    console.error("Failed to post JSON for logging.");
  });
};

var postMetricV2 = function postMetricV2(_ref, name, value) {
  var adexpContextSnapshotFn = _ref.adexpContextSnapshotFn,
      endpoint = _ref.endpoint,
      eventTrackingParam = _ref.eventTrackingParam;

  var adexpContext = adexpContextSnapshotFn();
  var payload = new __WEBPACK_IMPORTED_MODULE_0__adexp__["c" /* AdexpMessage */]({
    context: adexpContext,
    metric: new __WEBPACK_IMPORTED_MODULE_0__adexp__["d" /* AdexpMetricV2 */](name, value)
  });

  return postJSON(endpoint + "/adexp_metrics/" + eventTrackingParam, payload);
};

var Logger = function () {
  function Logger() {
    _classCallCheck(this, Logger);
  }

  _createClass(Logger, null, [{
    key: "init",

    // #if process.env.NODE_ENV === "test"
    //   static resetForTests() {
    //     delete this.enabled;
    //     delete this.loggedErrors;
    //     delete this.endpoint;
    //     delete this.eventTrackingParam;
    //     delete this.adexpContextSnapshotFn;
    //   }
    // #endif

    value: function init() {
      this.enabled = false;
      this.loggedErrors = [];
    }
  }, {
    key: "enable",
    value: function enable() {
      this.enabled = true;
    }

    /**
     * Pass the logger required context
     * @param {string} endpoint - The endpoint to which the creative will post
     * AdExp logs or metrics.
     * @param {string} eventTrackingParam - The tracking parameter string which
     * includes encoded bid context information.
     * @param {function} adexpContextSnapshotFn - A function to call that will
     * take a snapshot of the current environment and return an `AdexpContext`
     * object.
     */

  }, {
    key: "passContext",
    value: function passContext(endpoint, eventTrackingParam, adexpContextSnapshotFn) {
      this.endpoint = endpoint;
      this.eventTrackingParam = eventTrackingParam;
      this.adexpContextSnapshotFn = adexpContextSnapshotFn;
    }

    /**
     * Listens for errors that are caught by the window and reports them to adexp.
     * Don't call this if you use your own custom error handlers.
     */

  }, {
    key: "addErrorListeners",
    value: function addErrorListeners() {
      var _this = this;

      window.addEventListener("error", function (errorEvent) {
        var normalizedError = Object(__WEBPACK_IMPORTED_MODULE_1__error_handling__["c" /* normalizeErrorEvent */])(errorEvent);
        _this.recordError(normalizedError);
      });
    }

    /**
     * recordError takes an object like:
     * { message, line, column, sourceURL ... }
     * and logs the error to adexp.
     */

  }, {
    key: "recordError",
    value: function recordError(e) {
      this.recordLabeledError("error", e);
    }
  }, {
    key: "recordLabeledError",
    value: function recordLabeledError(tag, e) {
      // #if process.env.NODE_ENV !== "test"
      console.error(e);
      // #endif
      this._processError(tag, e);
    }
  }, {
    key: "_processError",
    value: function _processError(tag, errorObj) {
      if (Object(__WEBPACK_IMPORTED_MODULE_1__error_handling__["e" /* shouldIgnoreError */])(errorObj)) {
        return;
      }

      var normalizedErr = Object(__WEBPACK_IMPORTED_MODULE_1__error_handling__["b" /* normalizeError */])(errorObj);

      // Only log one error per (sourceURL, line #, message) combination. This
      // prevents noise from certain errors that are logged many times
      // from a single impression.
      var errorIdentifier = [normalizedErr.sourceURL, normalizedErr.line, normalizedErr.message].join("-");

      if (this.loggedErrors.includes(errorIdentifier)) {
        return;
      }

      this.loggedErrors.push(errorIdentifier);
      this.recordLog(tag, normalizedErr.message, new __WEBPACK_IMPORTED_MODULE_0__adexp__["a" /* AdexpJavaScriptError */](normalizedErr));
    }
  }, {
    key: "recordLog",
    value: function recordLog(tag, message, data) {
      if (!this.enabled) {
        return;
      }

      var adexpContext = this.adexpContextSnapshotFn();
      var payload = new __WEBPACK_IMPORTED_MODULE_0__adexp__["c" /* AdexpMessage */]({
        context: adexpContext,
        log: new __WEBPACK_IMPORTED_MODULE_0__adexp__["b" /* AdexpLog */](tag, message, data)
      });

      return postJSON(this.endpoint + "/adexp_log/" + this.eventTrackingParam, payload);
    }
  }, {
    key: "recordMetricV2",
    value: function recordMetricV2(name, value) {
      if (!this.enabled) {
        return Promise.resolve();
      }
      return postMetricV2({
        endpoint: this.endpoint,
        eventTrackingParam: this.eventTrackingParam,
        adexpContextSnapshotFn: this.adexpContextSnapshotFn
      }, name, value);
    }
  }, {
    key: "recordVXOnlyAdexpMetric",
    value: function recordVXOnlyAdexpMetric(name, value) {
      if (!Number.isInteger(value)) {
        console.debug("Expected an integer value for VXOnlyAdexpMetric: " + name);
        return;
      }

      return this.alwaysRecordMetricV2("custom_event", {
        name: name,
        value: value
      });
    }
  }, {
    key: "alwaysRecordMetricV2",
    value: function alwaysRecordMetricV2(name, value) {
      return postMetricV2({
        endpoint: this.endpoint,
        eventTrackingParam: this.eventTrackingParam,
        adexpContextSnapshotFn: this.adexpContextSnapshotFn
      }, name, value);
    }
  }]);

  return Logger;
}();

// TODO(oscar): Create a global Logger.


Logger.init();

/* harmony default export */ __webpack_exports__["a"] = (Logger);

/***/ }),
/* 6 */,
/* 7 */,
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var AutoclickBehaviorAbstract = function () {
  function AutoclickBehaviorAbstract(_ref) {
    var autoclick = _ref.autoclick,
        behavior = _ref.behavior,
        delayClickthroughHandler = _ref.delayClickthroughHandler;

    _classCallCheck(this, AutoclickBehaviorAbstract);

    this._autoclick = autoclick;
    this._behavior = behavior;
    this.internalCount = 0;
    this.delayClickthroughHandler = delayClickthroughHandler;
    this.init();
  }

  /** Runs when the class is instantiated. */


  _createClass(AutoclickBehaviorAbstract, [{
    key: "init",
    value: function init() {}

    /**
     * Only relevant for types that count something like interactions.
     * @returns {number} - Minimum amount until enabling delayed clickthrough.
     */

  }, {
    key: "getBehaviorCount",
    value: function getBehaviorCount() {
      return this._behavior == null ? null : this._behavior.count;
    }
  }, {
    key: "getBehaviorType",
    value: function getBehaviorType() {
      return this._behavior == null ? null : this._behavior.type;
    }

    /**
     * How long to delay clickthrough by.
     * @returns {number} - Delay value in milliseconds.
     */

  }, {
    key: "getBehaviorDelay",
    value: function getBehaviorDelay() {
      return this._behavior == null ? null : this._behavior.delay;
    }
  }, {
    key: "isCountReached",
    value: function isCountReached() {
      return this.getCurrentCount() >= this.getBehaviorCount();
    }
  }, {
    key: "getCurrentCount",
    value: function getCurrentCount() {
      return this.internalCount;
    }
  }, {
    key: "setCurrentCount",
    value: function setCurrentCount(n) {
      if (typeof n !== "number") {
        throw new Error("n must be a number, got: " + n);
      }
      this.internalCount = n;
    }

    /** Triggers a delayed clickthrough event. */

  }, {
    key: "delayClickthrough",
    value: function delayClickthrough() {
      var delay = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.getBehaviorDelay();

      if (!this.isCountReached()) return;

      this.delayClickthroughHandler(delay);
    }

    /**
     * Triggered by the InteractionMonitor class.
     */

  }, {
    key: "onInteraction",
    value: function onInteraction(_) {}

    /**
     * Should trigger when the creative is "finished". Typically this is the moment
     * an endscreen will appear.
     */

  }, {
    key: "onCompleted",
    value: function onCompleted() {}

    /**
     * Triggers when an "engagement" event occurs. Engagement must be fired by the
     * creative or a subcomponent thereof.
     */

  }, {
    key: "onEngagement",
    value: function onEngagement() {}
  }, {
    key: "onHtmlLoaded",
    value: function onHtmlLoaded() {}
  }, {
    key: "onViewable",
    value: function onViewable() {}
  }, {
    key: "onViewableChange",
    value: function onViewableChange(_) {}
  }]);

  return AutoclickBehaviorAbstract;
}();

/* harmony default export */ __webpack_exports__["a"] = (AutoclickBehaviorAbstract);

/***/ }),
/* 9 */,
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export isTestError */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Warning; });
/* unused harmony export tryParseStackInfo */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return normalizeError; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return normalizeErrorEvent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return normalizePromiseRejectionEvent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return shouldIgnoreError; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__frontendlib_utils__ = __webpack_require__(0);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



// if process.env.NODE_ENV === "test"
var isTestError = function isTestError(error) {
  // NOTE(Austin): Annoyingly, assertion errors will loop back here in
  // tests, so we have to ignore these.
  return error != null && error.constructor.name === "AssertionError";
};
// #endif

var Warning = function (_Error) {
  _inherits(Warning, _Error);

  function Warning() {
    var _ref;

    _classCallCheck(this, Warning);

    for (var _len = arguments.length, params = Array(_len), _key = 0; _key < _len; _key++) {
      params[_key] = arguments[_key];
    }

    // Maintains proper stack trace for where our error was thrown (only available on V8)
    var _this = _possibleConstructorReturn(this, (_ref = Warning.__proto__ || Object.getPrototypeOf(Warning)).call.apply(_ref, [this].concat(params)));

    if (Error.captureStackTrace) {
      Error.captureStackTrace(_this, Warning);
    }
    _this.severity = "warning";
    return _this;
  }

  return Warning;
}(Error);

var tryConvertStringToNumber = function tryConvertStringToNumber(str) {
  if (str == null) {
    return 0;
  }

  var parsed = parseInt(str);
  if (Number.isNaN(parsed)) {
    return 0;
  }

  return parsed;
};

var tryParseStackInfo = function tryParseStackInfo(stack) {
  if (stack == null) {
    return null;
  }

  var match = String(stack).match(
  // NOTE(Austin): We include about:srcdoc for inner_env errors.
  /(\b(?:[^ ]*\.js.*?)|(?:about:srcdoc)):(\d+)?:?(\d+)?/);

  if (match == null) {
    return null;
  }

  // Line and column need to be integers. We have them in our adexp
  // protobuf this way, so if they aren't we'll get a malformed message.
  return {
    sourceURL: match[1],
    line: tryConvertStringToNumber(match[2]),
    column: tryConvertStringToNumber(match[3])
  };
};

/**
 * Converts an Error or string into a map like
 * { message, stack, sourceURL, line, column }
 */
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Error/Error
var normalizeError = function normalizeError(obj) {
  if (obj == null) {
    return null;
  }

  if (typeof obj === "string") {
    return {
      message: obj
    };
  }

  var errorProps = Object(__WEBPACK_IMPORTED_MODULE_0__frontendlib_utils__["selectKeys"])(obj, Object.getOwnPropertyNames(obj));

  return Object.assign({}, tryParseStackInfo(errorProps.stack), errorProps);
};

/**
 * Converts an ErrorEvent object to a map like:
 * { message, line, column, sourceURL }
 * plus any additional information the error object contains.
 */
var normalizeErrorEvent = function normalizeErrorEvent(_ref2) {
  var message = _ref2.message,
      filename = _ref2.filename,
      lineno = _ref2.lineno,
      colno = _ref2.colno,
      error = _ref2.error;

  try {
    // Possible keys in an ErrorEvent:
    // [stack, name, fileName, lineNumber, columnNumber]
    var errorProps = error != null ? Object(__WEBPACK_IMPORTED_MODULE_0__frontendlib_utils__["selectKeys"])(error, Object.getOwnPropertyNames(error)) : {};

    var errorObj = Object.assign({
      message: message,
      severity: error && error.severity ? error.severity : "error",
      line: lineno,
      column: colno,
      sourceURL: filename
    }, errorProps);

    if (error == null) {
      return errorObj;
    }

    var parsedInfo = tryParseStackInfo(error.stack);
    return Object(__WEBPACK_IMPORTED_MODULE_0__frontendlib_utils__["mergePropertiesWithDefaults"])(errorObj, parsedInfo);
  } catch (e) {
    console.error("Error in normalizeErrorEvent: " + e.stack);
    return null;
  }
};

/**
 * Converts an PromiseRejectionEvent object to a map like
 * { message, line, column, sourceURL }
 * plus any additional information the error object contains.
 */
var normalizePromiseRejectionEvent = function normalizePromiseRejectionEvent(_ref3) {
  var reason = _ref3.reason;

  try {
    var reasonIsError = reason instanceof Error;
    var reasonIsString = typeof reason === "string";

    var errorMessage = reasonIsString ? reason : reason.message;

    // Possible keys in object (* are non-standard):
    // [message, stack*, name, fileName*, lineNumber*, columnNumber*]
    var errorProps = reasonIsError ? Object(__WEBPACK_IMPORTED_MODULE_0__frontendlib_utils__["selectKeys"])(reason, Object.getOwnPropertyNames(reason)) : {};

    var errorObj = Object.assign({
      message: errorMessage
    }, errorProps);

    return Object(__WEBPACK_IMPORTED_MODULE_0__frontendlib_utils__["mergePropertiesWithDefaults"])(errorObj, tryParseStackInfo(reason.stack));
  } catch (e) {
    console.error("Error in normalizePromiseRejectionEvent: " + e.stack);
    return null;
  }
};

/**
 * Normalizes the error and returns true if the error should be ingored;
 * otherwise, returns false.
 */
var shouldIgnoreError = function shouldIgnoreError(errorObj) {
  // Report only errors with non-malformed sourceURL.
  if (errorObj == null || errorObj.sourceURL === "undefined") {
    return true;
  }

  // mraid.js from adverty.com is a buggy implemenation. SMAATO and PUBMATIC are
  // the exchanges using such version and we see strange errors from the most.
  // While we are working with them to get a good MRAID implementation we filter
  // the noisy error messages by checking where the mraid.js is from.
  var stackFilter = new RegExp("adverty\\.com/.*mraid\\.js");

  // We see these errors quite often, and they are not related to our code.
  var regexFilters = ["Cannot read properties of undefined \\(reading 'fireEvent'\\)", "Cannot read property 'fireEvent' of undefined", "showInterstitial", "al_onPoststitialDismiss", "AFMA_ReceiveMessage", "webviewDidAppear", "AFMA_updateActiveView is not a function", "al_onAdViewRendered", "mraidbridge", "MoatMAK", "$adgIOS", "googqscp", "inmobi", "Script error", "avidbridge"];
  var messageFilter = new RegExp(regexFilters.join("|"));
  var errorStr = errorObj.message || errorObj.toString();
  if (messageFilter.test(errorStr) || stackFilter.test(errorObj.stack)) {
    return true;
  }

  var normalized = Object(__WEBPACK_IMPORTED_MODULE_0__frontendlib_utils__["selectKeys"])(errorObj, ["message", "line", "column", "stack", "sourceURL"]);

  var nKeys = Object.keys(normalized).length;
  var onlyMessage = "message" in errorObj && nKeys === 1 && errorObj.message === "undefined is not a function";

  var onlyMessageStack = "stack" in errorObj && "message" in errorObj && nKeys === 2 && errorObj.stack === "" && errorObj.message === "undefined is not a function";

  var noSourceURL = errorObj.sourceURL == null && nKeys === 5;
  return onlyMessage || onlyMessageStack || noSourceURL;
};

/***/ }),
/* 11 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(0);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }



var EventListener = function () {
  _createClass(EventListener, null, [{
    key: "pubsubify",
    value: function pubsubify(object) {
      var methods = Object.getOwnPropertyNames(EventListener.prototype).filter(function (name) {
        return name !== "constructor";
      });
      Object.assign(object, new EventListener());
      Object.assign(object, Object(__WEBPACK_IMPORTED_MODULE_0__utils__["selectKeys"])(EventListener.prototype, methods));
    }
  }]);

  function EventListener() {
    _classCallCheck(this, EventListener);

    this.events = {};
  }

  _createClass(EventListener, [{
    key: "on",
    value: function on(map, callback) {
      var _this = this;

      if (Object(__WEBPACK_IMPORTED_MODULE_0__utils__["type"])(map) !== "object") {
        map = _defineProperty({}, map, callback);
      }

      Object.keys(map).forEach(function (name) {
        if (_this.events[name] == null) {
          _this.events[name] = [];
        }

        _this.events[name].push(map[name]);
      });
    }
  }, {
    key: "once",
    value: function once(name, callback) {
      var _this2 = this;

      var single = function single() {
        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        _this2.off(name, single);
        callback.apply(null, args);
      };

      this.on(name, single);
    }
  }, {
    key: "off",
    value: function off(map, callback) {
      var _this3 = this;

      if (Object(__WEBPACK_IMPORTED_MODULE_0__utils__["type"])(map) !== "object") {
        map = _defineProperty({}, map, callback);
      }

      Object.keys(map).forEach(function (name) {
        if (_this3.events[name] == null) return;

        var callback = map[name];
        if (callback == null) return delete _this3.events[name];

        _this3.events[name] = _this3.events[name].filter(function (cb) {
          return cb !== callback;
        });
        if (_this3.events[name].length === 0) {
          delete _this3.events[name];
        }
      });
    }
  }, {
    key: "emit",
    value: function emit(name) {
      for (var _len2 = arguments.length, args = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
        args[_key2 - 1] = arguments[_key2];
      }

      if (this.events[name] == null) return;

      return Promise.all(this.events[name].map(function (cb) {
        return cb.apply(null, args);
      }));
    }
  }, {
    key: "relay",
    value: function relay(listener, onEvent) {
      var emitEvent = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : onEvent;

      this.on(onEvent, listener.emit.bind(listener, emitEvent));
    }
  }]);

  return EventListener;
}();

/* harmony default export */ __webpack_exports__["a"] = (EventListener);

/***/ }),
/* 12 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__frontendlib_event_listener__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__frontendlib_utils__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__logger__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__error_handling__ = __webpack_require__(10);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }







/**
 * This interval is the time between attempts to open a URL via different
 * methods (see `LiftoffMRAID.open`).
 */
var CLICK_RETRY_INTERVAL_MS = 1000;

var mraidOpenOnlyExchanges = new Set([__WEBPACK_IMPORTED_MODULE_2__constants__["z" /* EXCHANGE_INNERACTIVE */], __WEBPACK_IMPORTED_MODULE_2__constants__["A" /* EXCHANGE_IRONSOURCE */], __WEBPACK_IMPORTED_MODULE_2__constants__["B" /* EXCHANGE_MINTEGRAL */], __WEBPACK_IMPORTED_MODULE_2__constants__["E" /* EXCHANGE_VERVE */], __WEBPACK_IMPORTED_MODULE_2__constants__["F" /* EXCHANGE_VUNGLE */]]);

var mraidOpenUncertainExchanges = new Set([__WEBPACK_IMPORTED_MODULE_2__constants__["w" /* EXCHANGE_ADPOPCORN */], __WEBPACK_IMPORTED_MODULE_2__constants__["x" /* EXCHANGE_CONNATIX */], __WEBPACK_IMPORTED_MODULE_2__constants__["C" /* EXCHANGE_MOMENTO */], __WEBPACK_IMPORTED_MODULE_2__constants__["D" /* EXCHANGE_PANGLE */], __WEBPACK_IMPORTED_MODULE_2__constants__["G" /* EXCHANGE_XIAOMI */]]);

/**
 * This is a low-level wrapper around mraid that should be usable generally
 * (i.e. in any HTML ad environment). It's used by both madlib and third-party
 * creatives.
 */

var LiftoffMRAID = function () {
  function LiftoffMRAID() {
    _classCallCheck(this, LiftoffMRAID);
  }

  _createClass(LiftoffMRAID, null, [{
    key: "init",

    /**
     * Among other things, this function attaches event listeners to the
     * window.mraid object. It should be called as soon as possible after
     * window.mraid is defined. Because of this side-effect, it should also only
     * be called once.
     */
    value: function init() {
      this.liftoffMraidInitTimestamp = Date.now();

      __WEBPACK_IMPORTED_MODULE_0__frontendlib_event_listener__["a" /* default */].pubsubify(this);
      this.on = this.on.bind(this);
      this.once = this.once.bind(this);
      this._addMraidEventListener = this._addMraidEventListener.bind(this);

      this.viewableDurationMS = null;
      this.lastViewableTS = null;
      this.clickRetryTimeout = null;
      this.lastOpenedURL = null;
      this.isOrientationLocked = false;
      this.orientationToLock = null;
      this.viewable = null;
      this.isViewableByEvent = null;

      /** Keeps track of each version of window.mraid loaded. */
      this.mraids = [];
      /** This index of this.mraids that is currently loaded on window.mraid. */
      this.mraidIndex = null;

      /**
       * This object keeps track of what the current mraid object supports at the
       * moment support was checked.
       */
      this.supported = {
        methods: {},
        /**
         * NOTE(oscar): Unlike MRAID methods, we log mraid events that we listen
         * to as they occur.
         */
        events: {}
      };

      this._setInitialState();
      this._addEventListeners();
    }

    /** Returns time since LiftoffMRAID has been initialized in milliseconds. */

  }, {
    key: "sinceInit",
    value: function sinceInit() {
      return Date.now() - this.liftoffMraidInitTimestamp;
    }
  }, {
    key: "getSupportedLog",
    value: function getSupportedLog() {
      return Object.assign({
        "document.hidden": document.hidden,
        "document.visibilityState": document.visibilityState,
        "LiftoffMRAID.viewable": LiftoffMRAID.viewable,
        MRAID_ENV: window.MRAID_ENV
      }, this.supported);
    }
  }, {
    key: "_setInitialState",
    value: function _setInitialState() {
      var _this = this;

      var mraid = this.getMRAID();
      this.ready = this._mraidTry(function () {
        return _this.hasSupport("getState") && mraid.getState() === "default";
      }, { tag: "getState", fallback: false });

      this.isViewableByEvent = this.hasSupport("isViewable") ? this._mraidTry(function () {
        return mraid.isViewable();
      }, {
        tag: "isViewable",
        // NOTE(oscar): If isViewable() still fails, we fall back to
        // document.visibilityState.
        fallback: document.visibilityState !== "hidden"
      }) : document.visibilityState !== "hidden";
      this.processViewableChange(this.isViewableByEvent && this.isViewportShown());
      this.viewableDurationMS = 0;
    }

    /** TODO(oscar): Don't append to log if it won't be sent to Adexp. */

  }, {
    key: "_appendEventLog",
    value: function _appendEventLog(eventName, mraidIndex, args) {
      if (this.supported.events[eventName] == null) {
        this.supported.events[eventName] = [];
      }
      this.supported.events[eventName].push({
        sinceInitMs: this.sinceInit(),
        args: args,
        mraidIndex: mraidIndex,
        version: this.getMRAIDVersion()
      });
    }

    /**
     * This function is used to wrap calls to mraid methods in a try/catch block.
     * Any error gets logged in this.supported.errors.
     *
     * In general, this.hasSupport() is used to check for support. This function
     * serves as a further safeguard against errors due to faulty mraid
     * implementations.
     */

  }, {
    key: "_mraidTry",
    value: function _mraidTry(func, _ref) {
      var _ref$tag = _ref.tag,
          tag = _ref$tag === undefined ? "other" : _ref$tag,
          _ref$fallback = _ref.fallback,
          fallback = _ref$fallback === undefined ? undefined : _ref$fallback,
          _ref$logError = _ref.logError,
          logError = _ref$logError === undefined ? true : _ref$logError;

      try {
        return func();
      } catch (e) {
        if (logError) {
          // Record the error.
          this.supported.errors = this.supported.errors || [];
          var version = void 0;
          try {
            version = this.getMRAID().getVersion();
          } catch (ee) {
            console.error("Failed to get MRAID version", ee);
          }
          this.supported.errors.push({
            tag: tag,
            sinceInitMs: this.sinceInit(),
            message: e != null ? e.message : null,
            mraidIndex: this.mraidIndex,
            version: version
          });
        }
        return fallback;
      }
    }
  }, {
    key: "_addMraidEventListener",
    value: function _addMraidEventListener(eventName, callback) {
      var _this2 = this;

      if (!this.hasSupport("addEventListener")) return;

      var mraid = this.getMRAID();
      var mraidIndex = this.mraidIndex;

      this._mraidTry(function () {
        mraid.addEventListener(eventName, function () {
          for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
          }

          _this2._appendEventLog(eventName, mraidIndex, args);

          callback.apply(undefined, args);
        });
      }, { tag: eventName });
    }
  }, {
    key: "_addEventListeners",
    value: function _addEventListeners() {
      var _this3 = this;

      // "error" events include 2 arguments: a message and an action. The action
      // is the MRAID API call that caused the error.
      this._addMraidEventListener("error", function () {
        for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
          args[_key2] = arguments[_key2];
        }

        var e = new Error("MRAID error: " + args);
        _this3.emit("error", e);
      });
      this._addMraidEventListener("ready", function () {
        if (_this3.ready) return;
        _this3.ready = true;
        _this3.emit("ready");
      });
      this._addMraidEventListener("viewableChange", function (viewable) {
        _this3.isViewableByEvent = viewable;
        _this3.processViewableChange(_this3.isViewableByEvent && _this3.isViewportShown());
      });

      // NOTE(oscar): We're using _addMraidEventListener to log this event.
      this._addMraidEventListener("exposureChange", function () {});

      /**
       * The following is a fallback in case mraid's viewableChange is not
       * supported.
       */
      document.addEventListener("visibilitychange", function () {
        for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
          args[_key3] = arguments[_key3];
        }

        _this3._appendEventLog("document.visibilitychange", _this3.mraidIndex, args);

        /**
         * We delay the following by an event cycle to allow mraid's
         * viewableChange event to occur first.
         */
        Object(__WEBPACK_IMPORTED_MODULE_1__frontendlib_utils__["runAsync"])(function () {
          if (_this3.supported.events.viewableChange == null) {
            _this3.isViewableByEvent = document.visibilityState !== "hidden";
            _this3.processViewableChange(_this3.isViewableByEvent && _this3.isViewportShown());
          }
        });
      });
    }
  }, {
    key: "processViewableChange",
    value: function processViewableChange(isViewable) {
      /**
       * NOTE(oscar): On the off chance the mraid implementation gives us
       * truthy/falsey values instead.
       */
      var normalizedIsViewable = !!isViewable;
      if (normalizedIsViewable === this.viewable) return;
      this.viewable = normalizedIsViewable;

      if (this.viewable) {
        this.lastViewableTS = Date.now();
        if (!this.isOrientationLocked && this.orientationToLock != null) {
          // NOTE(oscar): We won't lock the orientation until after the ad is
          // viewable.
          this.lockOrientation(this.orientationToLock);
        }
      } else {
        this.viewableDurationMS += this.lastViewableTS == null ? 0 : Date.now() - this.lastViewableTS;
        this.lastOpenedURL = null;
        clearTimeout(this.clickRetryTimeout);
      }

      if (this.viewable) {
        this.emit("viewable");
      }
      this.emit("viewableChange", this.viewable);
    }
  }, {
    key: "onReady",
    value: function onReady(fn) {
      if (this.ready) {
        Object(__WEBPACK_IMPORTED_MODULE_1__frontendlib_utils__["runAsync"])(fn);
        return;
      }
      this.once("ready", fn);
    }

    /**
     * Adds a listener to the "viewable" event. The "viewable" event fires
     * whenever we believe the ad has become visible to the user. If the ad was
     * already visible, then it fires the listener immediately.
     * @param {Function} callback
     * @param {boolean} continuous – Whether to listen to all viewable events.
     * Defaults to false, meaning it will only trigger the callback once.
     * @returns
     */

  }, {
    key: "onViewable",
    value: function onViewable(callback) {
      var continuous = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      if (this.viewable) {
        Object(__WEBPACK_IMPORTED_MODULE_1__frontendlib_utils__["runAsync"])(callback);
        if (!continuous) return;
      }
      var deferrer = continuous ? this.on : this.once;
      deferrer("viewable", callback);
    }

    /** Runs fn now with current viewable value and on "viewableChange" event. */

  }, {
    key: "nowAndOnViewableChange",
    value: function nowAndOnViewableChange(fn) {
      var _this4 = this;

      Object(__WEBPACK_IMPORTED_MODULE_1__frontendlib_utils__["runAsync"])(function () {
        return fn(_this4.viewable);
      });

      this.on("viewableChange", fn);
    }

    // TODO(oscar): Replace with nowAndOnViewableChange once v2 productionizes.

  }, {
    key: "onViewableChange",
    value: function onViewableChange(fn) {
      this.nowAndOnViewableChange(fn);
    }

    // IMPORTANT: This method MUST be called synchronously with a user action.

  }, {
    key: "open",
    value: function open(url, _ref2) {
      var _this5 = this;

      var exchange = _ref2.exchange,
          platform = _ref2.platform,
          _ref2$abTests = _ref2.abTests,
          abTests = _ref2$abTests === undefined ? [] : _ref2$abTests,
          _ref2$isLiftoffURL = _ref2.isLiftoffURL,
          isLiftoffURL = _ref2$isLiftoffURL === undefined ? false : _ref2$isLiftoffURL,
          _ref2$isAutoclick = _ref2.isAutoclick,
          isAutoclick = _ref2$isAutoclick === undefined ? false : _ref2$isAutoclick;

      // To prevent the click waterfall from resetting if the user clicks twice in
      // rapid succession, don't restart the waterfall unless the URL being opened
      // is different.
      if (this.lastOpenedURL === url) return;

      this.lastOpenedURL = url;
      clearTimeout(this.clickRetryTimeout);

      var mraidOpenIsSupported = this.hasSupport("open");
      var isMRAIDOnlyExchange = mraidOpenOnlyExchanges.has(exchange);
      var requireMRAID = mraidOpenIsSupported && (isAutoclick || isMRAIDOnlyExchange);

      var getFinalClickURL = function getFinalClickURL(openMethod) {
        return isLiftoffURL ? Object(__WEBPACK_IMPORTED_MODULE_1__frontendlib_utils__["appendParamObjectToURL"])(url, {
          open_method: openMethod,
          tracking_method: __WEBPACK_IMPORTED_MODULE_2__constants__["N" /* TRACKING_METHOD_OPEN_METHOD */]
        }) : url;
      };
      var mraidOpen = function mraidOpen(url) {
        if (!_this5.ready) {
          _this5.emit("error", new Error("Called mraid.open before mraid was ready"));
        }
        _this5.getMRAID().open(url);
      };
      var anchorOpen = function anchorOpen(url) {
        var a = document.createElement("a");
        a.href = url;
        a.target = "_blank";
        a.click();
      };
      var locationOpen = function locationOpen(url) {
        window.location = url;
      };

      // To ensure that the user can click through, attempt multiple methods of
      // navigating to the URL. In order, they are:
      // 1. `mraid.open`, if mraid is available
      // 2. A fake anchor element
      // 3. `window.location`
      var openMethods = [{
        type: __WEBPACK_IMPORTED_MODULE_2__constants__["t" /* CLICK_OPEN_METHOD_MRAID */],
        enabled: mraidOpenIsSupported,
        fn: mraidOpen
      }, {
        type: __WEBPACK_IMPORTED_MODULE_2__constants__["r" /* CLICK_OPEN_METHOD_ANCHOR */],
        enabled: !requireMRAID,
        fn: anchorOpen
      }, {
        type: __WEBPACK_IMPORTED_MODULE_2__constants__["s" /* CLICK_OPEN_METHOD_LOCATION */],
        enabled: !requireMRAID,
        fn: locationOpen
      }].filter(function (_ref3) {
        var enabled = _ref3.enabled;
        return enabled;
      });

      /**
       * Checks if we expect for the SKProductView will open. If so, then it's
       * likely for no visibility event to occur.
       * TODO(oscar/cwu): Replace url check with other `skproductview` indicating
       * boolean that should be populated from h2go.
       */
      var isOpenSKProductView = function isOpenSKProductView(openMethod, url) {
        var appleStoreUrlPrefix = new RegExp("^(https?://)?apps\\.apple\\.com");
        return openMethod.type === __WEBPACK_IMPORTED_MODULE_2__constants__["t" /* CLICK_OPEN_METHOD_MRAID */] && appleStoreUrlPrefix.test(url);
      };

      var tryOpen = function tryOpen() {
        var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

        // We don't emit any error if we're in the waterfall experiment
        // because this is guaranteed to happen if the user clicks more than
        // once (whereas in the original this will only happen if it thinks a
        // click failed).
        if (index > 0) {
          var methodType = openMethods[index - 1].type;
          _this5.emit("error", new __WEBPACK_IMPORTED_MODULE_4__error_handling__["a" /* Warning */]("Failed to open " + url + " using " + methodType));
        }
        if (index === openMethods.length - 1) {
          _this5.lastOpenedURL = null;
        }
        if (index >= openMethods.length && !(index === 1 && isOpenSKProductView(openMethods[0], url))) {
          _this5.emit("error", new Error("Failed to open " + url + " by any methods. Tried " + openMethods.length + " method(s)"));
          return;
        }

        var openMethod = openMethods[index];
        var finalClickURL = getFinalClickURL(openMethod.type);
        openMethod.fn(finalClickURL);
        _this5.emit("clickMethodTried", {
          clickOpenMethod: openMethod.type,
          isAutoclick: isAutoclick
        });
        __WEBPACK_IMPORTED_MODULE_3__logger__["a" /* default */].recordMetricV2("click_url_open", {
          method: openMethod.type,
          index: index,
          total: openMethods.length,
          is_mraid_ready: _this5.ready
        });

        _this5.clickRetryTimeout = setTimeout(tryOpen.bind(_this5, index + 1), CLICK_RETRY_INTERVAL_MS);
      };

      if (isMRAIDOnlyExchange) {
        mraidOpen(getFinalClickURL(__WEBPACK_IMPORTED_MODULE_2__constants__["t" /* CLICK_OPEN_METHOD_MRAID */]));
        __WEBPACK_IMPORTED_MODULE_3__logger__["a" /* default */].recordMetricV2("click_url_open", {
          method: __WEBPACK_IMPORTED_MODULE_2__constants__["t" /* CLICK_OPEN_METHOD_MRAID */],
          index: 0,
          total: 1,
          is_mraid_ready: this.ready
        });
      } else if (mraidOpenUncertainExchanges.has(exchange)) {
        // Keep these exchanges still in the click waterfall for now.
        tryOpen();
      } else if (abTests.includes("click-waterfall-removal-experiment")) {
        mraidOpen(getFinalClickURL(__WEBPACK_IMPORTED_MODULE_2__constants__["t" /* CLICK_OPEN_METHOD_MRAID */]));
        __WEBPACK_IMPORTED_MODULE_3__logger__["a" /* default */].recordMetricV2("click_url_open", {
          method: __WEBPACK_IMPORTED_MODULE_2__constants__["t" /* CLICK_OPEN_METHOD_MRAID */],
          index: 0,
          total: 1,
          is_mraid_ready: this.ready
        });
      } else {
        tryOpen();
      }
    }
  }, {
    key: "close",
    value: function close() {
      var _this6 = this;

      this.onReady(function () {
        __WEBPACK_IMPORTED_MODULE_3__logger__["a" /* default */].recordMetricV2("close_count", 1);

        if (!_this6.hasSupport("close")) {
          _this6.emit("error", new __WEBPACK_IMPORTED_MODULE_4__error_handling__["a" /* Warning */]("Attempted to call 'MRAID.close' when it is not supported."));
          return;
        }

        _this6.getMRAID().close();
      });
    }

    // NOTE(brian): The `useCustomClose` method is deprecated (read: ignored) in
    // MRAID 3.0.
    // NOTE(Casey): Unity's `useCustomClose` throws an error. Although we handle
    // this case by not trying custom custom close on Unity, this implementation
    // handles that scenario in case other exchanges are (unknowingly) similar.
    /**
     * Returns a `Promise` that resolves with `false` if custom close was not set
     * or to `true` if custom close was set successfully. The `Promise` rejects
     * if an error was thrown.
     */

  }, {
    key: "useCustomClose",
    value: function useCustomClose(use) {
      var _this7 = this;

      return new Promise(function (resolve, reject) {
        try {
          _this7.onReady(function () {
            if (!(_this7.hasSupport("useCustomClose") && _this7.hasSupport("close") && use)) {
              return resolve(false);
            }
            var mraid = _this7.getMRAID();
            mraid.useCustomClose(use);
            resolve(use);
          });
        } catch (e) {
          reject(e);
        }
      });
    }
  }, {
    key: "getViewableDurationMS",
    value: function getViewableDurationMS() {
      if (!this.viewable) return this.viewableDurationMS;
      if (this.lastViewableTS == null) {
        console.error("Internal LiftoffMRAID error: this.lastViewableTS should be set.");
        return this.viewableDurationMS;
      }
      return this.viewableDurationMS + (Date.now() - this.lastViewableTS);
    }
  }, {
    key: "lockOrientation",
    value: function lockOrientation(orientation) {
      if (!this.ready || !this.viewable || !this.hasSupport("setOrientationProperties")) {
        return;
      }

      this.orientationToLock = orientation;
      var mraid = this.getMRAID();
      this._mraidTry(function () {
        mraid.setOrientationProperties({
          allowOrientationChange: false,
          forceOrientation: orientation
        });
      }, { tag: "setOrientationProperties" });
      this.isOrientationLocked = true;
    }
  }, {
    key: "getMRAID",
    value: function getMRAID() {
      var windowMraid = window.mraid;
      if (windowMraid != null) {
        // NOTE(oscar): There are some sdks that will delete window.mraid after it
        // was initialized. In some cases at least, this is done to replace the
        // mraid object with a new one, but it's unclear why this is done in an
        // asynchronous way. In order not to race with the SDK's implementation of
        // MRAID, we will use the last mraid object loaded as a fallback.
        // Related test: https://docs.google.com/document/d/1TWLnTFlTGFc6ZJB_UXfR8QvmEa8x_d3k532fmX-13Fs
        // Related test 2: https://docs.google.com/document/d/1iChTG_zLZvQzI5Opw-6kpHqRCXRYklTPpbNB7TPBFdQ
        this.mraidIndex = this.mraids.indexOf(windowMraid);
        if (this.mraidIndex === -1) {
          this.mraidIndex = this.mraids.length;
          this.mraids.push(windowMraid);
        }
      }

      return this.mraids[this.mraidIndex];
    }
  }, {
    key: "logMethodSupport",
    value: function logMethodSupport(methodName, isSupported) {
      if (this.supported.methods[methodName] == null) {
        this.supported.methods[methodName] = {};
      }
      if (this.supported.methods[methodName][this.mraidIndex] == null) {
        this.supported.methods[methodName][this.mraidIndex] = [];
      }
      // NOTE(oscar): The MRAID spec allows for a method to go from no support to
      // support when the mraid's "ready" event triggers.
      this.supported.methods[methodName][this.mraidIndex].push({
        sinceInitMs: this.sinceInit(),
        ready: this.ready,
        support: isSupported,
        /** Logging is disabled here to prevent an infinite loop. */
        version: this.getMRAIDVersion({ log: false })
      });
    }

    /**
     * Checks to see if the MRAID implementation supports the given method.
     * More specifically, this checks to see if the method is a function on the
     * window.mraid object. It does not actually call the method to see if it
     * works and any caller should be prepared to handle errors.
     *
     * @param {string} prop - The name of the method to check.
     * @param {Object} options
     * @param {boolean} options.log - Whether to log the result of the check.
     */

  }, {
    key: "hasSupport",
    value: function hasSupport(prop) {
      var _ref4 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
          _ref4$log = _ref4.log,
          log = _ref4$log === undefined ? true : _ref4$log;

      var mraid = this.getMRAID();
      if (mraid == null) {
        return false;
      }

      if (prop === "mraid") {
        return true;
      }

      var support = Object(__WEBPACK_IMPORTED_MODULE_1__frontendlib_utils__["type"])(mraid[prop]) === "function";

      if (log) {
        this.logMethodSupport(prop, support);
      }

      return support;
    }

    /** Returns the currently loaded MRAID version. */

  }, {
    key: "getMRAIDVersion",
    value: function getMRAIDVersion() {
      var _this8 = this;

      var _ref5 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref5$log = _ref5.log,
          log = _ref5$log === undefined ? true : _ref5$log;

      return this._mraidTry(function () {
        return _this8.hasSupport("getVersion", { log: log }) ? _this8.getMRAID().getVersion() : null;
      }, { tag: "getVersion", logError: log });
    }
  }, {
    key: "isViewportShown",
    value: function isViewportShown() {
      return window.innerHeight > 0 && window.innerWidth > 0;
    }
  }]);

  return LiftoffMRAID;
}();

if (window._LiftoffMRAID == null) {
  LiftoffMRAID.init();
  /**
   * NOTE(oscar): Global state is needed in order to only call .init() once and
   * to ensure that the same LiftoffMRAID is exported.
   */
  window._LiftoffMRAID = LiftoffMRAID;
}

/* harmony default export */ __webpack_exports__["a"] = (window._LiftoffMRAID);

/***/ }),
/* 13 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return AdexpMetricV2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AdexpJavaScriptError; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return AdexpLog; });
/* unused harmony export AdexpContext */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return AdexpMessage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getAdexpContextSnapshotFn; });
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// Wrappers around adexp objects contained in adexpjson.go

var AdexpMetricV2 = function AdexpMetricV2(name, value) {
  _classCallCheck(this, AdexpMetricV2);

  this.name = name;
  this.value = value;
};

var AdexpJavaScriptError = function AdexpJavaScriptError() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      message = _ref.message,
      _ref$severity = _ref.severity,
      severity = _ref$severity === undefined ? "error" : _ref$severity,
      sourceURL = _ref.sourceURL,
      line = _ref.line,
      column = _ref.column,
      stack = _ref.stack;

  _classCallCheck(this, AdexpJavaScriptError);

  this.error = {
    message: message,
    severity: severity,
    sourceURL: sourceURL,
    line: line,
    column: column,
    stack: stack
  };
};

var AdexpLog = function AdexpLog(tag, message, data) {
  _classCallCheck(this, AdexpLog);

  this.tag = tag;
  this.message = message;
  Object.assign(this, data);
};

var AdexpContext = function AdexpContext() {
  var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      viewportWidth = _ref2.viewportWidth,
      viewportHeight = _ref2.viewportHeight,
      adLanguage = _ref2.adLanguage,
      mraid = _ref2.mraid;

  _classCallCheck(this, AdexpContext);

  this.ad_language = adLanguage;
  this.mraid = mraid;
  this.viewport_height = viewportHeight;
  this.viewport_width = viewportWidth;
};

var AdexpMessage = function AdexpMessage() {
  var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      context = _ref3.context,
      metric = _ref3.metric,
      log = _ref3.log;

  _classCallCheck(this, AdexpMessage);

  Object.assign(this, context);
  // NOTE(Austin): metrics_v2 must be an array. For now
  // we don't log more than one metric at a time though.
  this.metrics_v2 = metric != null ? [metric] : undefined;
  this.log = log;
};

// TODO(Austin): Consolidate ClickMetric here.

/**
 * Returns a function that takes a snapshot of the current environment
 * and returns a `AdexpContext`.
 */
var getAdexpContextSnapshotFn = function getAdexpContextSnapshotFn(viewportEl, hasMraidFn) {
  return function () {
    var _ref4 = viewportEl != null ? viewportEl.getBoundingClientRect() : {},
        width = _ref4.width,
        height = _ref4.height;

    return new AdexpContext({
      viewportWidth: width != null ? Math.round(width) : undefined,
      viewportHeight: height != null ? Math.round(height) : undefined,
      adLanguage: navigator.language,
      mraid: hasMraidFn()
    });
  };
};

/***/ }),
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var patchedObjects = [];

var MonkeyPatch = function () {
  function MonkeyPatch() {
    _classCallCheck(this, MonkeyPatch);
  }

  _createClass(MonkeyPatch, null, [{
    key: "_applyPatch",

    // #if process.env.NODE_ENV === "test"
    //   static resetAll() {
    //     patchedObjects.forEach(({ obj, propertyName, dataKey, value }) => {
    //       MonkeyPatch._applyPatch(obj, propertyName, { [dataKey]: value });
    //     });
    // 
    //     // Clear the array.
    //     patchedObjects.splice(0, patchedObjects.length);
    //   }
    // #endif

    value: function _applyPatch(obj, propertyName, protoMap) {
      if (obj.propertyName !== undefined) {
        delete obj[propertyName];
      }

      try {
        // See
        // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/defineProperty#Description
        Object.defineProperty(obj, propertyName, protoMap);
      } catch (e) {
        // TODO(Austin): Delete added patchedObject entry?
        throw new Error("Cannot monkey patch " + obj.constructor.name + "[" + propertyName + "], because: '" + e + "'.");
      }
    }
  }, {
    key: "_patch",
    value: function _patch(obj, propertyName, dataKey, value) {
      var originalValue = Object.getOwnPropertyDescriptor(obj, propertyName)[dataKey];

      patchedObjects.push({
        obj: obj,
        propertyName: propertyName,
        dataKey: dataKey,
        value: originalValue
      });

      MonkeyPatch._applyPatch(obj, propertyName, _defineProperty({}, dataKey, value));
    }
  }, {
    key: "patchFunction",
    value: function patchFunction(obj, propertyName, fn) {
      // "value" is the property value. See doc in _applyPatch.
      MonkeyPatch._patch(obj, propertyName, "value", fn);
    }
  }, {
    key: "patchSetter",
    value: function patchSetter(obj, propertyName, fn) {
      // "set" is the property setter. See doc in _applyPatch.
      MonkeyPatch._patch(obj, propertyName, "set", fn);
    }
  }, {
    key: "patchGetter",
    value: function patchGetter(obj, propertyName, fn) {
      // "get" is the property getter. See doc in _applyPatch.
      MonkeyPatch._patch(obj, propertyName, "get", fn);
    }
  }]);

  return MonkeyPatch;
}();

/* harmony default export */ __webpack_exports__["a"] = (MonkeyPatch);

/***/ }),
/* 21 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return pointInCTA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return clickAreaTypeFromEvent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return isDeadzoneCoord; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(2);
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

/**
 * Contains logic to determine whether cta was clicked. This is not the optimal
 * way to do it - a better way would be to include CTA location as part of the
 * creative's concept rendering configuration and to set it explicitly.
 */



var pointInEl = function pointInEl(el, x, y) {
  var _el$getBoundingClient = el.getBoundingClientRect(),
      elTop = _el$getBoundingClient.top,
      elRight = _el$getBoundingClient.right,
      elBottom = _el$getBoundingClient.bottom,
      elLeft = _el$getBoundingClient.left;

  return x >= elLeft && x <= elRight && y >= elTop && y <= elBottom;
};

/**
 * Returns true iff (x, y) is within the bounds of a CTA. We
 * consider an element to be a "CTA element" if it's part of the generic-cta or
 * custom-cta components or is in a container that has 'cta' in the id. This can
 * give both false positives (e.g. if a non-CTA image is placed in a CTA
 * container) and false negatives (e.g. if a CTA is embedded in a larger image
 * in one of the "fill" templates), but it's probably close to the best we can
 * do without manual tagging. We include all descendants of cta
 * containers/components, because sometimes their children overflow.
 */
var pointInCTA = function pointInCTA(x, y) {
  return [].concat(_toConsumableArray(document.querySelectorAll([".generic-cta", ".generic-cta *", ".custom-cta", ".custom-cta *", ".cta-container", ".cta-container *", ".liftoff-cta", ".liftoff-cta *", ".product-view-cta .light", ".last-chance-endscreen-container"].join(", ")))).some(function (ctaEl) {
    return pointInEl(ctaEl, x, y);
  });
};

/**
 * Returns true iff e is a MouseEvent that occurred over a CTA.
 */
var clickAreaTypeFromEvent = function clickAreaTypeFromEvent(e) {
  return pointInCTA(e.clientX, e.clientY) ? __WEBPACK_IMPORTED_MODULE_0__constants__["l" /* CLICK_AREA_TYPE_CTA */] : __WEBPACK_IMPORTED_MODULE_0__constants__["m" /* CLICK_AREA_TYPE_OTHER */];
};

var isDeadzoneCoord = function isDeadzoneCoord(_ref) {
  var x = _ref.x,
      y = _ref.y;

  if (!Number.isFinite(x) || !Number.isFinite(y)) {
    console.warn("Unexpected coords", { x: x, y: y });
    return;
  }
  return [].concat(_toConsumableArray(document.body.querySelectorAll(".liftoff-deadzone"))).some(function (el) {
    return pointInEl(el, x, y);
  });
};

/***/ }),
/* 22 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return MESSAGE_CREATIVE_MADE_SOUND; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return MESSAGE_TOGGLE_MUTED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return MESSAGE_INTERACTION_CHANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MESSAGE_CLICKTHROUGH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return MESSAGE_MRAID_EVENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return MESSAGE_MRAID_CALL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return MESSAGE_UPDATED_MRAID_PROPERTIES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return MESSAGE_INNER_ENV_INIT_COMPLETE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return MESSAGE_OUTER_ENV_INIT_COMPLETE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return MESSAGE_REQUEST_DOM_SNAPSHOT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return MESSAGE_DOM_SNAPSHOT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return MESSAGE_INNER_ENV_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return MESSAGE_RESIZE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return MESSAGE_VUNGLE_CLICKTHROUGH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return MESSAGE_TRESENSA_INTERACTION; });
var MESSAGE_CREATIVE_MADE_SOUND = "CREATIVE_MADE_SOUND";
var MESSAGE_TOGGLE_MUTED = "TOGGLE_MUTED";
var MESSAGE_INTERACTION_CHANGE = "INTERACTION_CHANGE";
var MESSAGE_CLICKTHROUGH = "CLICKTHROUGH";
var MESSAGE_MRAID_EVENT = "MRAID_EVENT";
var MESSAGE_MRAID_CALL = "MRAID_CALL";
var MESSAGE_UPDATED_MRAID_PROPERTIES = "UPDATED_MRAID_PROPERTIES";
var MESSAGE_INNER_ENV_INIT_COMPLETE = "INNER_ENV_INIT_COMPLETE";
var MESSAGE_OUTER_ENV_INIT_COMPLETE = "OUTER_ENV_INIT_COMPLETE";
var MESSAGE_REQUEST_DOM_SNAPSHOT = "REQUEST_DOM_SNAPSHOT";
var MESSAGE_DOM_SNAPSHOT = "DOM_SNAPSHOT";
var MESSAGE_INNER_ENV_ERROR = "INNER_ENV_ERROR";
var MESSAGE_RESIZE = "RESIZE";

// External Messages from Vungle.
var MESSAGE_VUNGLE_CLICKTHROUGH = "download";

// External Messages from Tresensa creatives.
var MESSAGE_TRESENSA_INTERACTION = "tre_interaction";

/***/ }),
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__frontendlib_dom_utils__ = __webpack_require__(1);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }



var AudioToggleIcon = function () {
  function AudioToggleIcon() {
    _classCallCheck(this, AudioToggleIcon);

    this.el = Object(__WEBPACK_IMPORTED_MODULE_0__frontendlib_dom_utils__["strToElement"])("\n      <div class=\"audio-toggle-icon\"\n          style=\"margin:10px;border-radius:25px;background-color:black;line-height:10px\">\n        <svg fill=\"#FFFFFF\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"\n          width=\"30\" height=\"30\" viewBox=\"0 0 16 16\"\n        >\n          <g class=\"audio-toggle-unmute\" transform=\"translate(8 8) scale(0.69 0.69) translate(-8 -8)\">\n            <polygon points=\"\n              14.293,14.293 1.707,1.707 1,2.414 4.586,6 4,6 4,10 7,10 11,14 11,12.414 13.586,15\n            \"></polygon>\n            <polygon points=\"11,2 7.207,5.793 11,9.586\"></polygon>\n          </g>\n          <g class=\"audio-toggle-mute\" transform=\"translate(8 8) scale(0.69 0.69) translate(-8 -8)\">\n            <polygon points=\"7,6 4,6 4,10 7,10 11,14 11,2\"></polygon>\n          </g>\n        </svg>\n      </div>\n    ");

    this.setMuted(true);
  }

  _createClass(AudioToggleIcon, [{
    key: "getElement",
    value: function getElement() {
      return this.el;
    }
  }, {
    key: "setMuted",
    value: function setMuted(muted) {
      this.el.querySelector(".audio-toggle-unmute").style.display = muted ? "" : "none";
      this.el.querySelector(".audio-toggle-mute").style.display = muted ? "none" : "";
    }
  }]);

  return AudioToggleIcon;
}();

/* harmony default export */ __webpack_exports__["a"] = (AudioToggleIcon);

/***/ }),
/* 29 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__monkey_patch__ = __webpack_require__(20);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }



/**
 * Returns true iff `el` is a media (audio or video) element;
 */
var isMediaElement = function isMediaElement(el) {
  return el.tagName === "VIDEO" || el.tagName === "AUDIO";
};

/**
 * Assuming `el` is a playing video, returns `true` iff it has audio data.
 */
var doesVideoHaveAudio = function doesVideoHaveAudio(el) {
  return el.audioTracks != null && el.audioTracks.length > 0 || el.webkitAudioDecodedByteCount != null && el.webkitAudioDecodedByteCount > 0;
};

// Minimum bin size of a web audio analyzer node frequency spectrum. See:
// https://developer.mozilla.org/en-US/docs/Web/API/AnalyserNode/fftSize#Value.
var MIN_FFT_SIZE = 32;

/**
 * Global controller for web audio. This works by monkey-patching the
 * `AudioContext` constructor and redefining `AudioContext.destination`
 * (normally an `AudioDestinationNode` that routes sound to the speakers)
 * to a node that allows the global controller to intercept and control all
 * output. This is used by `GlobalAudioController`--it's not intended to be
 * used directly. `cb` is a function that will be called the first time any
 * `AudioContext` produces a sound.
 */

var GlobalWebAudioController = function () {
  function GlobalWebAudioController() {
    _classCallCheck(this, GlobalWebAudioController);
  }

  _createClass(GlobalWebAudioController, null, [{
    key: "reset",

    // if process.env.NODE_ENV === "test"
    /**
     * Resets all state back to it's uninitialized state.
     * Used for testing purposes.
     */
    value: function reset() {
      GlobalWebAudioController._firstSoundMade = false;
      GlobalWebAudioController._muted = null;
    }
    // #endif

  }, {
    key: "init",
    value: function init(cb) {
      GlobalWebAudioController._muted = null;
      GlobalWebAudioController._cb = cb;
      GlobalWebAudioController._firstSoundMade = false;
      GlobalWebAudioController._gainNodes = [];

      try {
        var originalAudioContext = window.AudioContext || window.webkitAudioContext;

        /**
         * An alternative to monkey-patching the `AudioContext` constructor would
         * be to monkey-patch the `AudioContext.prototype.destination` getter,
         * but this doesn't work on old (pre-getter) browsers.
         */
        window.AudioContext = window.webkitAudioContext = function AudioContext() {
          for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
          }

          var audioCtx = new (Function.prototype.bind.apply(originalAudioContext, [null].concat(args)))();
          var gainNode = audioCtx.createGain();
          var analyserNode = audioCtx.createAnalyser();
          // We just want to know if the `AudioContext` is producing _any_ sound
          // and don't care about the frequency spectrum per se. We therefore used
          // the smallest allowed FFT size.
          analyserNode.fftSize = MIN_FFT_SIZE;
          var freqData = new Uint8Array(analyserNode.frequencyBinCount);
          var soundPollInterval = setInterval(function () {
            analyserNode.getByteFrequencyData(freqData);
            var i = 0;
            for (; i < freqData.length; i++) {
              if (freqData[i] !== 0) break;
            }
            if (i === freqData.length) return;
            clearInterval(soundPollInterval);
            GlobalWebAudioController._handleFirstSound();
          }, 10);
          /**
           * The resulting node structure is:
           *   input -> analyser -> gain -> destination
           * We use the analyser node to detect when the AudioContext is producing
           * sound and the gain node to globally control output.
           */
          var originalDestination = audioCtx.destination;
          analyserNode.connect(gainNode);
          gainNode.connect(originalDestination);
          gainNode.gain.value = GlobalWebAudioController._muted ? 0 : 1;
          GlobalWebAudioController._gainNodes.push(gainNode);

          Object.defineProperty(audioCtx, "destination", {
            value: analyserNode,
            // Ensure that our destination node is the only destination node.
            writable: false,
            configurable: false
          });

          return audioCtx;
        };
      } catch (_) {
        console.error("Unable to monkey-patch AudioContext");
      }
    }
  }, {
    key: "_handleFirstSound",
    value: function _handleFirstSound() {
      if (GlobalWebAudioController._firstSoundMade) return;
      GlobalWebAudioController._cb();
      GlobalWebAudioController._firstSoundMade = true;
    }

    /**
     * Mutes all `AudioContext`s when `shouldMute === true` and restores all
     * `AudioContext`s to the state set by the user when `shouldMute === false`.
     */

  }, {
    key: "setMuted",
    value: function setMuted(shouldMute) {
      if (GlobalWebAudioController._muted === shouldMute) {
        return;
      }
      GlobalWebAudioController._muted = shouldMute;
      GlobalWebAudioController._gainNodes.forEach(function (gainNode) {
        gainNode.gain.value = shouldMute ? 0 : 1;
      });
    }
  }]);

  return GlobalWebAudioController;
}();

/**
 * Utility for tracking media elements. Media elements can come into existence
 * in several different ways, which requies multiple different tricks for
 * becoming aware of their existence:
 *   1) They may exist in the DOM on page load (i.e. be embedded directly in
 *      the HTML document) - these can be detected by querying the dom for video
 *      and audio elements
 *   2) They can be produced from an HTML string (e.g. `someEl.innerHTML =
 *      "<audio ... />"`) and appended to the DOM. They must fire a "loadstart"
 *      event after being appended to the DOM, or the `load` or `play` methods
 *      may be called directly on the element. These can be detected by
 *      listening for "loadstart" events and by monkey-patching the `load` and
 *      `play` methods. This is true regardless of whether or not autoplay is
 *      true.
 *   3) `document.createElement` - these are detected by monkey-patching
 *      `Document.prototype.createElement`. These won't be caught by the
 *      approaches in 2 if the "autoplay" attribute is set to `true` (since they
 *      can make sound without ever being explicitly loaded, played, or append
 *      to the DOM).
 *   4) The `Audio` constructor - these are detected by monkey-patching the
 *      `Audio` constructor.
 */


var MediaElementWatcher = function () {
  function MediaElementWatcher() {
    _classCallCheck(this, MediaElementWatcher);

    throw new Error("Cannot construct instances of MediaElementWatcher.");
  }

  /**
   * Initializes the class, and immediately calls function `cb` once for each
   * media element that already exists. Subsequently calls `cb` whenever a new
   * media element is created. This should only be called once.
   */


  _createClass(MediaElementWatcher, null, [{
    key: "init",
    value: function init(cb) {
      MediaElementWatcher._cb = cb;
      MediaElementWatcher._seenElements = new WeakSet();

      var originalCreateElement = Document.prototype.createElement;
      __WEBPACK_IMPORTED_MODULE_0__monkey_patch__["a" /* default */].patchFunction(Document.prototype, "createElement", function () {
        for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
          args[_key2] = arguments[_key2];
        }

        var el = originalCreateElement.apply(this, args);
        MediaElementWatcher._handleNewElement(el);
        return el;
      });

      var originalAudio = window.Audio;
      window.Audio = function Audio() {
        for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
          args[_key3] = arguments[_key3];
        }

        var a = new (Function.prototype.bind.apply(originalAudio, [null].concat(args)))();
        MediaElementWatcher._handleNewElement(a);
        return a;
      };
      window.Audio.prototype = originalAudio.prototype;

      ["play", "load"].forEach(function (methodName) {
        var originalMethod = HTMLMediaElement.prototype[methodName];
        __WEBPACK_IMPORTED_MODULE_0__monkey_patch__["a" /* default */].patchFunction(HTMLMediaElement.prototype, methodName, function () {
          MediaElementWatcher._handleNewElement(this);

          for (var _len4 = arguments.length, args = Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
            args[_key4] = arguments[_key4];
          }

          return originalMethod.apply(this, args);
        });
      });

      window.addEventListener("loadstart", function (e) {
        MediaElementWatcher._handleNewElement(e.target);
      }, true);

      document.querySelectorAll("video, audio").forEach(function (el) {
        MediaElementWatcher._cb(el);
      });
    }
  }, {
    key: "_handleNewElement",
    value: function _handleNewElement(el) {
      if (!isMediaElement(el) || MediaElementWatcher._seenElements.has(el)) {
        return;
      }
      MediaElementWatcher._seenElements.add(el);
      MediaElementWatcher._cb(el);
    }
  }]);

  return MediaElementWatcher;
}();

/**
 * Global controller for media (audio and video) elements. Used by
 * `GlobalAudioController` and not intended to be used directly. `cb` is a
 * function that will be called the first time any media element can
 * produce a sound (were global control not applied).
 */


var GlobalMediaElementAudioController = function () {
  // #if process.env.NODE_ENV === "test"
  //   /**
  //    * Resets all state back to it's uninitialized state.
  //    * Used for testing purposes.
  //    */
  //   static reset() {
  //     GlobalMediaElementAudioController._firstSoundMade = false;
  //     GlobalMediaElementAudioController._globallyMuted = null;
  //   }
  // #endif

  function GlobalMediaElementAudioController() {
    _classCallCheck(this, GlobalMediaElementAudioController);

    throw new Error("Cannot construct instances of GlobalMediaElementAudioController.");
  }

  _createClass(GlobalMediaElementAudioController, null, [{
    key: "init",
    value: function init(cb) {
      GlobalMediaElementAudioController._globallyMuted = null;
      /**
       * We keep track of the values for el.muted set by the user for each media
       * el. When we globally unmute, we restore the set state (so calling
       * `GlobalMediaElementAudioController.unmute()` does not unmute
       * elements that the user has set to be muted).
       */
      GlobalMediaElementAudioController._elToSetState = new WeakMap();
      GlobalMediaElementAudioController._allMediaEls = [];
      GlobalMediaElementAudioController._firstSoundMade = false;
      GlobalMediaElementAudioController._cb = cb;

      try {
        GlobalMediaElementAudioController._originalMutedSetter = Object.getOwnPropertyDescriptor(HTMLMediaElement.prototype, "muted").set;
        var originalMutedGetter = Object.getOwnPropertyDescriptor(HTMLMediaElement.prototype, "muted").get;

        __WEBPACK_IMPORTED_MODULE_0__monkey_patch__["a" /* default */].patchSetter(HTMLMediaElement.prototype, "muted", function (val) {
          GlobalMediaElementAudioController._elToSetState.set(this, val);
          if (GlobalMediaElementAudioController._canMakeSound(this)) {
            GlobalMediaElementAudioController._handleFirstSound();
          }

          var systemMutedState = originalMutedGetter.call(this);
          if (GlobalMediaElementAudioController._globallyMuted && (systemMutedState || !val)) {
            return;
          }
          GlobalMediaElementAudioController._originalMutedSetter.call(this, val);
        });

        // Patch the "muted" getter so that it returns the value set by the user,
        // rather than the underlying "system" value.
        __WEBPACK_IMPORTED_MODULE_0__monkey_patch__["a" /* default */].patchGetter(HTMLMediaElement.prototype, "muted", function () {
          var recordedSetState = GlobalMediaElementAudioController._elToSetState.get(this);
          return recordedSetState == null ? originalMutedGetter.call(this) : recordedSetState;
        });
        // #if process.env.NODE_ENV === "test"
        //       // Expose the underlying system muted setting to tests.
        //       Object.defineProperty(HTMLMediaElement.prototype, "systemMutedState", {
        //         get: originalMutedGetter,
        //       });
        // #endif
      } catch (_) {
        /**
         * Monkey-patching will fail on old (pre-setter) browsers. In this case,
         * we have no way of keeping track of the set state.
         * (Listening for "volumechange" events doesn't work, because if we force
         * the state to `true` due to globally muting, then the event will not
         * fire if the user subsequently sets the `muted` to `true`.) In this
         * case, we just keep the page globally muted.
         */
        GlobalMediaElementAudioController._originalMutedSetter = function (mute) {
          this.muted = mute;
        };
        console.error("Unable to monkey-patch HTMLMediaElement.muted");
      }

      MediaElementWatcher.init(function (el) {
        if (!GlobalMediaElementAudioController._allMediaEls.includes(el)) {
          GlobalMediaElementAudioController._allMediaEls.push(el);
        }
        GlobalMediaElementAudioController._watchForSound(el);
        GlobalMediaElementAudioController._toggleElementMuted(el, GlobalMediaElementAudioController._globallyMuted);
      });
    }

    /**
     * Returns `true` iff `el` would be able to make a sound were it not being
     * controlled by this global controller. We consider an element able to make
     * a sound if it is either an audio element or is a video with audio tracks.
     * Assumes that `el` is in the playing state (whether or not a video has
     * audio cannot be determined for all browsers for media that are not
     * playing).
     */

  }, {
    key: "_canMakeSound",
    value: function _canMakeSound(el) {
      var isMuted = GlobalMediaElementAudioController._elToSetState.get(el);
      return !isMuted && (el.tagName === "AUDIO" || doesVideoHaveAudio(el));
    }
  }, {
    key: "_watchForSound",
    value: function _watchForSound(el) {
      if (!el.paused && GlobalMediaElementAudioController._canMakeSound(el)) {
        GlobalMediaElementAudioController._handleFirstSound();
        return;
      }

      el.addEventListener("playing", function () {
        if (!GlobalMediaElementAudioController._canMakeSound(el)) return;
        GlobalMediaElementAudioController._handleFirstSound();
      });
    }

    /**
     * Forces `el.muted` to `muted` (a boolean). Assumes that if `muted === true`,
     * the value of `el.muted` is the state set by the user.
     * (i.e. This is not idempotent.)
     */

  }, {
    key: "_toggleElementMuted",
    value: function _toggleElementMuted(el, muted) {
      if (muted) {
        GlobalMediaElementAudioController._elToSetState.set(el, el.muted);
        GlobalMediaElementAudioController._originalMutedSetter.call(el, true);
        return;
      }

      GlobalMediaElementAudioController._originalMutedSetter.call(el, GlobalMediaElementAudioController._elToSetState.get(el));
    }
  }, {
    key: "_toggleMediaMuted",
    value: function _toggleMediaMuted(muted) {
      GlobalMediaElementAudioController._allMediaEls.forEach(function (el) {
        GlobalMediaElementAudioController._toggleElementMuted(el, muted);
      });
    }
  }, {
    key: "_handleFirstSound",
    value: function _handleFirstSound() {
      if (GlobalMediaElementAudioController._firstSoundMade) return;
      GlobalMediaElementAudioController._cb();
      GlobalMediaElementAudioController._firstSoundMade = true;
    }

    /**
     * Mutes all HTML media elements when `shouldMute === true` and restores the
     * set state of all HTML media elements when `shouldMute === false`.
     */

  }, {
    key: "setMuted",
    value: function setMuted(shouldMute) {
      if (GlobalMediaElementAudioController._globallyMuted === shouldMute) {
        return;
      }
      GlobalMediaElementAudioController._toggleMediaMuted(shouldMute);
      GlobalMediaElementAudioController._globallyMuted = shouldMute;
    }
  }]);

  return GlobalMediaElementAudioController;
}();

/**
 * Global controller for all possible sources of audio in a web page, except
 * for `iframe`s. The public interface consists of only two methods:
 *   - `GlobalAudioController.setMuted` - takes a boolean indicating whether
 *      audio from all sound sources (HTML media elements and web audio) should
 *      be muted (true) or not (false);
 *   - `GlobalAudioController.onFirstSound` - receives one argument, a function
 *      that will be called immediately if the page is already making sound or
 *      otherwise will be called once when the page first makes a sound
 *      (possibly never).
 */


var GlobalAudioController = function () {
  // #if process.env.NODE_ENV === "test"
  //   /**
  //    * Just to facilitate testing of `onFirstSound` by allowing the registered
  //    * callback to be run multiple times when new sources of sound are added to
  //    * the testing environment page.
  //    */
  //   static reset() {
  //     GlobalAudioController._firstSoundMade = false;
  //     GlobalAudioController._onFirstSoundCallbacks = [];
  // 
  //     GlobalMediaElementAudioController.reset();
  //     GlobalWebAudioController.reset();
  //   }
  // #endif

  function GlobalAudioController() {
    _classCallCheck(this, GlobalAudioController);

    throw new Error("Cannot construct instances of GlobalAudioController.");
  }

  /**
   * This class is invasive insofar as implements a series of monkey patches on
   * browser API objects. We thus only initialize it when it's actually used.
   */


  _createClass(GlobalAudioController, null, [{
    key: "_init",
    value: function _init() {
      if (GlobalAudioController._initialized) {
        return;
      }
      GlobalAudioController._initialized = true;
      GlobalAudioController._firstSoundMade = false;
      GlobalAudioController._onFirstSoundCallbacks = [];

      var handleFirstSound = function handleFirstSound() {
        if (GlobalAudioController._firstSoundMade) {
          return;
        }
        GlobalAudioController._firstSoundMade = true;
        GlobalAudioController._onFirstSoundCallbacks.forEach(function (cb) {
          return cb();
        });
      };
      GlobalMediaElementAudioController.init(handleFirstSound);
      GlobalWebAudioController.init(handleFirstSound);
    }
  }, {
    key: "setMuted",
    value: function setMuted(shouldMute) {
      GlobalAudioController._init();
      GlobalMediaElementAudioController.setMuted(shouldMute);
      GlobalWebAudioController.setMuted(shouldMute);
    }
  }, {
    key: "runAfterFirstSound",
    value: function runAfterFirstSound(cb) {
      GlobalAudioController._init();
      if (GlobalAudioController._firstSoundMade) {
        cb();
        return;
      }

      GlobalAudioController._onFirstSoundCallbacks.push(cb);
    }
  }]);

  return GlobalAudioController;
}();

GlobalAudioController._initialized = false;

/* harmony default export */ __webpack_exports__["a"] = (GlobalAudioController);

/***/ }),
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return applyLiftoffPolicy; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return postHTMLReturn; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getDOMSnapshot; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return configureHTMLReturn; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_audio_toggle_icon__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_global_audio_controller__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__madlib_liftoff_mraid__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__frontendlib_utils__ = __webpack_require__(0);






var CLOSE_Z = 99;
var WATERMARKS_Z = 98;

/**
 * Returns a close element with a countdown timer that starts at `delay` seconds.
 */
var createCloseEl = function createCloseEl(delay) {
  var closeEl = document.createElement("div");
  closeEl.id = "liftoff-close";
  Object.assign(closeEl.style, {
    display: "block",
    position: "absolute",
    top: "10px",
    right: "10px",
    width: "32px",
    height: "32px",
    zIndex: CLOSE_Z
  });
  var buttonStyles = {
    width: "100%",
    height: "100%",
    display: "block",
    position: "absolute",
    top: "0",
    left: "0",
    fontSize: "16px",
    lineHeight: "28px",
    textAlign: "center",
    border: "2px solid #FFF",
    borderRadius: "50%",
    boxSizing: "border-box",
    pointerEvents: "all"
  };
  var closeTargetEl = document.createElement("div");
  closeTargetEl.classList.add("liftoff-close-target");
  Object.assign(closeTargetEl.style, buttonStyles, {
    color: "#EEE",
    backgroundColor: "#000"
  });
  // This is a nice close X.
  closeTargetEl.innerHTML = "&#10005";
  closeTargetEl.addEventListener("click", function (e) {
    __WEBPACK_IMPORTED_MODULE_2__madlib_liftoff_mraid__["a" /* default */].close();
    e.stopPropagation();
  });
  closeEl.appendChild(closeTargetEl);
  if (delay > 0) {
    var closeDelayEl = document.createElement("div");
    closeDelayEl.classList.add("liftoff-close-delay");
    Object.assign(closeDelayEl.style, buttonStyles, {
      color: "#555",
      backgroundColor: "#BBB"
    });
    var countdown = delay;
    closeDelayEl.textContent = countdown;
    closeDelayEl.style.display = "block";
    var closeDelayInterval = setInterval(function () {
      countdown -= 1;
      if (countdown > 0) {
        closeDelayEl.textContent = countdown;
        return;
      }
      closeDelayEl.style.display = "none";
      clearInterval(closeDelayInterval);
    }, 1000);
    closeEl.appendChild(closeDelayEl);
  }
  return closeEl;
};

/**
 * Calls `callback` on the user's first interaction.
 */
var onFirstInteraction = function onFirstInteraction(callback) {
  var hasUserInteracted = false;
  var handleFirstInteraction = function handleFirstInteraction(e) {
    window.removeEventListener("mousedown", handleFirstInteraction, true);
    window.removeEventListener("touchstart", handleFirstInteraction, true);
    if (hasUserInteracted) return;
    hasUserInteracted = true;
    callback(e);
  };
  window.addEventListener("mousedown", handleFirstInteraction, true);
  window.addEventListener("touchstart", handleFirstInteraction, true);
};

/**
 * Creates an icon in the lower-right corner that allows the user to globally toggle the creative's audio on
 * and off. The toggle only appears on creatives that have autoplay audio (i.e. audio that plays prior to user
 * interaction). For creatives that have autoplay audio, the creative is globally muted by default but will
 * become globally unmuted when the user interacts with the creative.
 */
var createGlobalAudioToggle = function createGlobalAudioToggle() {
  var el = document.createElement("div");
  el.classList.add("liftoff-global-audio-toggle");
  Object.assign(el.style, {
    opacity: "0.5",
    display: "none",
    pointerEvents: "all",
    right: "0",
    bottom: "0",
    position: "absolute"
  });
  var icon = new __WEBPACK_IMPORTED_MODULE_0__lib_audio_toggle_icon__["a" /* default */]();
  var iconEl = icon.getElement();
  el.appendChild(iconEl);

  var isCurrentlyMuted = false;
  var setMuted = function setMuted(shouldMute) {
    if (shouldMute === isCurrentlyMuted) return;
    isCurrentlyMuted = shouldMute;
    __WEBPACK_IMPORTED_MODULE_1__lib_global_audio_controller__["a" /* default */].setMuted(shouldMute);
    icon.setMuted(shouldMute);
  };

  var hasUserInteracted = false;
  onFirstInteraction(function (e) {
    hasUserInteracted = true;
    // Interactions with the global audio toggle icon are handled by the click listener below.
    if (el.contains(e.target)) return;
    setMuted(false);
  });

  iconEl.addEventListener("click", function () {
    setMuted(!isCurrentlyMuted);
  });

  __WEBPACK_IMPORTED_MODULE_1__lib_global_audio_controller__["a" /* default */].runAfterFirstSound(function () {
    if (hasUserInteracted) return;
    el.style.display = "inline-block";
  });

  setMuted(true);
  return el;
};

var globallyMuteAllAudio = function globallyMuteAllAudio() {
  __WEBPACK_IMPORTED_MODULE_1__lib_global_audio_controller__["a" /* default */].setMuted(true);
};

/**
 * Performs various operations required to conform to exchange- and/or country-specific creative policies.
 * This is used by both madlib HTML and CSP (third-party) creatives.
 * Requires:
 *   - creativePolicy - An object with keys:
 *       addBorder (boolean)
 *       showAdChoices (boolean)
 *       showChineseWatermark (boolean)
 *       russianAgeRating (number)
 *   - bidContext - An object with keys: { creativeID, platform, exchange, sourceAppName, sourceAppID }
 */
var applyLiftoffPolicy = function applyLiftoffPolicy(snippetEl, _ref, _ref2) {
  var addBorder = _ref.addBorder,
      showAdChoices = _ref.showAdChoices,
      russianAgeRating = _ref.russianAgeRating,
      showChineseWatermark = _ref.showChineseWatermark,
      useCustomClose = _ref.useCustomClose,
      closeDelay = _ref.closeDelay,
      audioPolicy = _ref.audioPolicy;
  var creativeID = _ref2.creativeID,
      platform = _ref2.platform,
      exchange = _ref2.exchange,
      sourceAppName = _ref2.sourceAppName,
      sourceAppID = _ref2.sourceAppID,
      cdnURL = _ref2.cdnURL;

  var watermarksEl = document.createElement("div");
  watermarksEl.classList.add("liftoff-watermarks");
  Object.assign(watermarksEl.style, {
    position: "absolute",
    bottom: "0",
    left: "0",
    zIndex: "" + WATERMARKS_Z,
    height: "18px",
    pointerEvents: "none"
  });

  /**
   * Creates an element to apply a border around the whole creative (required for banners on certain
   * exchanges). We do this rather than adding a border directly to `#liftoff-snippet`, because the latter
   * changes the size of the snippet content by 2 * border-width, resulting in slightly inconsistent
   * rendering depending on whether the border is there or not.
   */
  if (addBorder) {
    var el = document.createElement("div");
    el.id = "liftoff-border";
    Object.assign(el.style, {
      width: "100%",
      height: "100%",
      position: "absolute",
      border: "1px solid #AAA",
      boxSizing: "border-box",
      zIndex: "10",
      pointerEvents: "none"
    });
    document.body.appendChild(el);
  }

  if (showAdChoices) {
    // NOTE(Austin): We append these parameters for Google Analytics and more
    // granular cloudfront logs.
    var queryParams = {
      creative_id: creativeID,
      platform: platform,
      exchange: exchange,
      source_app_name: sourceAppName,
      source_app_id: sourceAppID
    };

    var a = document.createElement("a");
    a.classList.add("ad-choices-icon");
    var optoutPageURL = __WEBPACK_IMPORTED_MODULE_4__frontendlib_utils__["appendParamObjectToURL"](cdnURL + "/optout.html", queryParams);

    if (exchange === __WEBPACK_IMPORTED_MODULE_3__constants__["y" /* EXCHANGE_DOUBLECLICK */]) {
      // NOTE (Austin): Letting the click from the anchor tag intentionally take
      // the user out of the ad provides a better experience, as the in-app
      // browser is broken on some inventory (e.g., DoubleClick). Some
      // exchanges, such as Unity, open the in-app browser regardless, leading to
      // a poor user experience. Additionally, certain exchanges ignore our
      // mraid.open or window.open parameters, opening the clickthrough URL in a
      // new browser anyway.
      // TODO(Austin): Test making this the default.
      a.setAttribute("target", "_blank");
      a.setAttribute("href", optoutPageURL);
    } else {
      // NOTE(oscar): Chartboost recommends we open the ad choices link using
      // MRAID.
      a.addEventListener("click", function (e) {
        e.preventDefault();
        __WEBPACK_IMPORTED_MODULE_2__madlib_liftoff_mraid__["a" /* default */].open(optoutPageURL, { exchange: exchange, platform: platform });
      });
    }

    Object.assign(a.style, {
      width: "20px",
      height: "100%",
      display: "inline-block",
      backgroundColor: "rgba(204, 204, 204, 0.6)",
      backgroundImage: "url(" + cdnURL + "/adchoices.png)",
      backgroundPosition: "center",
      backgroundRepeat: "no-repeat",
      backgroundSize: "12px 12px",
      pointerEvents: "all"
    });
    watermarksEl.appendChild(a);
  }

  if (russianAgeRating != null) {
    var ageTag = document.createElement("div");
    ageTag.textContent = russianAgeRating + "+";
    ageTag.classList.add("age-rating");
    Object.assign(ageTag.style, {
      color: "blue",
      fontSize: "10px",
      fontWeight: "500",
      background: "whitesmoke",
      borderRadius: "0 5px 0 0",
      padding: "0 3px",
      opacity: "0.75",
      display: "inline",
      verticalAlign: "bottom",
      pointerEvents: "none",
      lineHeight: "20px"
    });
    watermarksEl.appendChild(ageTag);
  }

  if (showChineseWatermark) {
    var _el = document.createElement("div");
    _el.classList.add("chinese-watermark");
    Object.assign(_el.style, {
      display: "inline-block",
      height: "100%",
      width: "42px",
      pointerEvents: "none",
      backgroundColor: "rgba(204, 204, 204, 0.6)",
      backgroundImage: "url(" + cdnURL + "/chinese_watermark.png)",
      backgroundPosition: "center",
      backgroundRepeat: "no-repeat",
      backgroundSize: "contain"
    });
    watermarksEl.appendChild(_el);
  }

  if (audioPolicy === __WEBPACK_IMPORTED_MODULE_3__constants__["a" /* AUDIO_POLICY_ALWAYS_MUTE */]) {
    globallyMuteAllAudio();
  } else if (audioPolicy === __WEBPACK_IMPORTED_MODULE_3__constants__["c" /* AUDIO_POLICY_ON_INTERACTION */]) {
    var globalAudioToggleEl = createGlobalAudioToggle();
    snippetEl.appendChild(globalAudioToggleEl);
  }

  __WEBPACK_IMPORTED_MODULE_2__madlib_liftoff_mraid__["a" /* default */].useCustomClose(useCustomClose).then(function (isUsingCustomClose) {
    if (!isUsingCustomClose) return;
    var closeEl = createCloseEl(closeDelay);
    snippetEl.appendChild(closeEl);
  });

  snippetEl.appendChild(watermarksEl);
  return snippetEl;
};

var postHTMLReturn = function postHTMLReturn(adexpEndpoint, html) {
  return __WEBPACK_IMPORTED_MODULE_4__frontendlib_utils__["request"]("POST", adexpEndpoint + "/html_return", {
    // Don't set the content type to "application/json" because that requires
    // a preflight OPTIONS request (because this is a cross-domain request).
    "Content-Type": "text/plain"
  }, html);
};

var getDOMSnapshot = function getDOMSnapshot() {
  return document.documentElement.outerHTML;
};

/**
 * Given `adexpEndpoint` (the AdExp host as a `String`), this sends an HTML
 * return after `htmlReturnDelay` ms. Returns a `Promise` that resolves when
 * the HTML return HTTP request is complete.
 */
var configureHTMLReturn = function configureHTMLReturn(adexpEndpoint, htmlReturnDelay) {
  var postHTML = function postHTML() {
    console.info("Returning HTML");
    return postHTMLReturn(adexpEndpoint, getDOMSnapshot());
  };

  if (htmlReturnDelay == null || htmlReturnDelay === 0) {
    // NOTE(oscar): A delay of 0 ideally should return the DOM before any JS
    // manipulation, so we capture the state of the DOM immediately.
    return postHTML();
  }

  return new Promise(function (resolve, reject) {
    setTimeout(function () {
      return postHTML().then(resolve, reject);
    }, htmlReturnDelay);
  });
};

/***/ }),
/* 37 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export throttle */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return intentionalInteractionCounterFn; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__cta__ = __webpack_require__(21);


var throttle = function throttle(f, ms) {
  var ignore = false;

  return function () {
    if (ignore) return;
    f.apply(undefined, arguments);
    ignore = true;
    setTimeout(function () {
      ignore = false;
    }, ms);
  };
};

var intentionalInteractionCounterFn = function intentionalInteractionCounterFn(minimumInteractions) {
  /**
   * InteractionMonitor has somewhat imperfect de-duplication logic for what
   * counts as a full interaction. It also doesn't account for intentional
   * interactions. Also note that onInteractionChange() triggers for every
   * start, drag, and end event.
   *
   * For our purposes, we'll use both InteractionMonitor's count and a custom
   * counter.
   */
  var intentionalInteractionsFromMonitor = new Set();
  var intentionalInteractionCountFromThrottle = 0;

  var countIntentionalInteractionThrottle = throttle(function () {
    intentionalInteractionCountFromThrottle += 1;
  },
  /** Count interactions only once every 0.4 seconds. */
  400);

  var getCurrentCount = function getCurrentCount() {
    return Math.min(intentionalInteractionCountFromThrottle, intentionalInteractionsFromMonitor.size);
  };

  var countIntentionalInteractions = function countIntentionalInteractions(e) {
    if (Object(__WEBPACK_IMPORTED_MODULE_0__cta__["b" /* isDeadzoneCoord */])({
      x: e.lastInteraction.startX,
      y: e.lastInteraction.startY
    })) {
      return;
    }
    /**
     * NOTE(oscar): e.cumulativeStats.interactionCount is only incremented for
     * full interactions (or at least in theory). It also counts deadzone
     * interactions. Here we use interactionCount to identify which counts are
     * intentional.
     */
    if (e.cumulativeStats.interactionCount > 0 && intentionalInteractionsFromMonitor.size <= minimumInteractions) {
      intentionalInteractionsFromMonitor.add(e.cumulativeStats.interactionCount);
    }
    countIntentionalInteractionThrottle();
  };
  return function (e) {
    countIntentionalInteractions(e);
    return getCurrentCount();
  };
};

/***/ }),
/* 38 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__frontendlib_dom_utils__ = __webpack_require__(1);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }



/*
 * ClickInteraction is used to connect elements that respond to clicks
 * with the elements that trigger click events. Primarily, this allows
 * dynamic CTAs to respond to click events on click overlays or any
 * other clickthrough element.
 */

// Global state for two-click CTAs.
var hasBeenClicked = false;
var firstClickHandlers = [];

// Global state for slider CTAs.
var SLIDER_COMPLETION_RATIO = 0.7;
var sliders = [];

var setSlideDistance = function setSlideDistance(value) {
  sliders.forEach(function (_ref) {
    var sliderSize = _ref.sliderSize,
        setSlideRatio = _ref.setSlideRatio;
    return setSlideRatio(value / sliderSize);
  });
};

var getPointerEventX = function getPointerEventX(e) {
  return (e.changedTouches && e.changedTouches[0] || e.touches && e.touches[0] || e).clientX;
};

var ClickInteraction = function () {
  function ClickInteraction() {
    _classCallCheck(this, ClickInteraction);
  }

  _createClass(ClickInteraction, null, [{
    key: "captureFirstClick",
    value: function captureFirstClick(handleFirstClick) {
      firstClickHandlers.push(handleFirstClick);
    }
  }, {
    key: "captureSlideClick",
    value: function captureSlideClick(_ref2) {
      var onCompleted = _ref2.onCompleted,
          sliderSize = _ref2.sliderSize,
          setSlideRatio = _ref2.setSlideRatio;

      sliders.push({ onCompleted: onCompleted, sliderSize: sliderSize, setSlideRatio: setSlideRatio });
    }
  }, {
    key: "addListeners",
    value: function addListeners(clickEl, onClickComplete) {
      clickEl.addEventListener("click", function (e) {
        if (sliders.length > 0) {
          return;
        }

        if (!hasBeenClicked) {
          hasBeenClicked = true;

          if (firstClickHandlers.length > 0) {
            firstClickHandlers.forEach(function (handler) {
              return handler(e);
            });

            return;
          }
        }

        onClickComplete(e);
      }, true);

      var slideStartPosition = null;
      __WEBPACK_IMPORTED_MODULE_0__frontendlib_dom_utils__["on"](clickEl, {
        "mousedown touchstart": function mousedownTouchstart(e) {
          slideStartPosition = getPointerEventX(e);
        },
        "mousemove touchmove": function mousemoveTouchmove(e) {
          if (slideStartPosition == null) return;

          setSlideDistance(getPointerEventX(e) - slideStartPosition);
        },
        "mouseup mouseleave touchend": function mouseupMouseleaveTouchend(e) {
          if (slideStartPosition == null) return;

          var slideDistance = getPointerEventX(e) - slideStartPosition;
          var completedSliders = sliders.filter(function (_ref3) {
            var sliderSize = _ref3.sliderSize;
            return slideDistance > sliderSize * SLIDER_COMPLETION_RATIO;
          });

          if (completedSliders.length > 0) {
            completedSliders.forEach(function (_ref4) {
              var onCompleted = _ref4.onCompleted;
              return onCompleted();
            });
            Promise.resolve(onClickComplete(e)).then(function () {
              return new Promise(function (resolve) {
                return setTimeout(resolve, 1000);
              });
            }).then(function () {
              return setSlideDistance(0);
            });
          } else {
            setSlideDistance(0);
          }

          slideStartPosition = null;
        }
      });
    }
  }]);

  return ClickInteraction;
}();

/* harmony default export */ __webpack_exports__["a"] = (ClickInteraction);

/***/ }),
/* 39 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return addDeadzoneStyles; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__frontendlib_dom_utils__ = __webpack_require__(1);


/** TODO(oscar): This is a temporary solution to add deadzones to CSPs. */
var addDeadzoneStyles = function addDeadzoneStyles() {
  var el = Object(__WEBPACK_IMPORTED_MODULE_0__frontendlib_dom_utils__["strToElement"])("\n  <style>\n    .liftoff-deadzone.deadzone-experiment {\n      position: absolute;\n      width: max(50px, min(85px, 11vw));\n      height: max(50px, min(85px, 11vw));\n      z-index: 96;\n    }\n    .liftoff-deadzone.top-left {\n      top: 0;\n      left: 0;\n    }\n    .liftoff-deadzone.top-right {\n      top: 0;\n      right: 0;\n    }\n  </style>\n  ");
  document.head.appendChild(el);
};

var addDeadzones = function addDeadzones(useExpandedZones) {
  var rootEl = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : document.body;

  var deadzoneEls = [Object(__WEBPACK_IMPORTED_MODULE_0__frontendlib_dom_utils__["strToElement"])("<div class=\"liftoff-deadzone top-left\"></div>"), Object(__WEBPACK_IMPORTED_MODULE_0__frontendlib_dom_utils__["strToElement"])("<div class=\"liftoff-deadzone top-right\"></div>")];
  deadzoneEls.forEach(function (el) {
    if (useExpandedZones) {
      el.classList.add("deadzone-experiment");
    }
    rootEl.appendChild(el);
  });
};

/* harmony default export */ __webpack_exports__["b"] = (addDeadzones);

/***/ }),
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getClickTrackingQueryParams; });
/* unused harmony export constructLiftoffClickURL */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return handleClick; });
/* unused harmony export _forUnitTestingOnly */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__madlib_liftoff_mraid__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__madlib_logger__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__frontendlib_utils__ = __webpack_require__(0);





var getLiftoffContainerRect = function getLiftoffContainerRect() {
  // NOTE(Casey): 'liftoff-snippet' might not exist if the creative is not
  // fully initialized.
  var containerEl = document.getElementById("liftoff-snippet") || document.body;
  return containerEl.getBoundingClientRect();
};

var getClickTrackingQueryParams = function getClickTrackingQueryParams(allInteractionData) {
  var _ref = allInteractionData || {},
      lastInteraction = _ref.lastInteraction,
      cumulativeStats = _ref.cumulativeStats;

  var containerRect = getLiftoffContainerRect();

  var params = {
    // Unix timestamp of when the click is sent.
    ct: Date.now(),
    // Width of #liftoff-snippet in px.
    aw: containerRect.width.toFixed(),
    // Height of #liftoff-snippet in px.
    ah: containerRect.height.toFixed(),
    // Whether or not MRAID is supported for this impression, determined
    // empirically based on the presence/absence of the mraid object.
    m: __WEBPACK_IMPORTED_MODULE_0__madlib_liftoff_mraid__["a" /* default */].hasSupport("mraid") ? 1 : 0,
    // Total duration, in ms, that the creative was viewable prior to the
    // click. This depends on the mraid "viewableChange" event, so its
    // accuracy depends on the exchange's implementation.
    tv: __WEBPACK_IMPORTED_MODULE_0__madlib_liftoff_mraid__["a" /* default */].getViewableDurationMS()
  };

  if (lastInteraction == null) {
    return params;
  }

  // NOTE(Casey): We see some rare events that do not have x/y coordinates.
  if (lastInteraction.startX != null) {
    // The horizontal position of the click in pixels, relative to the
    // upper-left corner of #liftoff-snippet.
    params.cx = (lastInteraction.startX - containerRect.left).toFixed();
  }

  if (lastInteraction.startY != null) {
    // The vertical position of the click in pixels, relative to the
    // upper-left corner of #liftoff-snippet.
    params.cy = (lastInteraction.startY - containerRect.top).toFixed();
  }

  if (lastInteraction.durationMS != null) {
    // Duration in milliseconds of the click, as measured by the difference
    // between timestamps on the start and end events (e.g. touchstart and
    // touchend).
    params.dur = lastInteraction.durationMS.toFixed();
  }

  Object.assign(params, {
    // The value of Event.isTrusted (see
    // https://developer.mozilla.org/en-US/docs/Web/API/Event/isTrusted).
    it: lastInteraction.isTrusted ? 1 : 0,
    // Maximum force of the interaction on a 0-100 scale. derived from
    // Touch.force (for TouchEvents), MouseEvent.webkitForce, or
    // PointerEvent.pressure.  This may be 0 or have some arbitrary value if
    // the pointer device/surface doesn't support force/pressure measurement.
    frc: Math.round(lastInteraction.maxForce * 100),
    // Maximum area of the screen with which the user interacted in px^2  (e.g.
    // the area of the screen covered by a finger during a click). May be 0 or
    // have some arbitrary value if the pointer device/surface doesn't support
    // area measurement.
    ar: lastInteraction.maxArea.toFixed(),
    // Path length traversed from the beginning to the end of the click, in px.
    d: lastInteraction.distance.toFixed(),
    // An enum describing the type of pointing device--Mouse, Touch, or other
    // (e.g. pen/stylus). See the constants defined in `InteractionMonitor`
    // and the corresponding definitions in rtb.proto.
    pt: lastInteraction.pointerType,
    // Total number of distinct interactions detected prior to and including the
    // click. "Distinct interactions" are bounded by start/end events or by
    // the pointing device leaving the creative.
    ic: cumulativeStats.interactionCount,
    // Total path length of all interactions.
    tid: cumulativeStats.totalDistance.toFixed()
  });

  return params;
};

/**
 * Given a baseClickURL (a string), attaches the caller's query
 * parameters provided as an object, and returns a string.
 */
var constructLiftoffClickURL = function constructLiftoffClickURL(baseClickURL, queryParams) {
  return __WEBPACK_IMPORTED_MODULE_3__frontendlib_utils__["appendParamObjectToURL"](baseClickURL, queryParams);
};

/**
 * Returns a Promise that resolves when the tracking pixel at url is loaded.
 */
var pingTrackingURLWithImage = function pingTrackingURLWithImage(url) {
  return new Promise(function (resolve) {
    // NOTE(Austin): Image is a the best method here as far as we know because
    // it's a foolproof way to get a no-cors request and avoid any strange
    // behavior with XMLHttpRequest. One downside is that Image only tells us
    // when it's fully loaded, and technically we don't need to wait that long.
    // We technically only need to wait for the request to send (we don't need
    // to wait for the response).

    // NOTE(Casey): In some cases (e.g. SKAdNetwork impressions on some
    // exchanges), we "force" a direct clickthrough with a click-tracking URL
    // that redirects to the MMP and app store. We still use an image tag to
    // ping Usher and the MMP, but it will generate an error. We still want
    // to click through in this case.

    // TODO(Casey): Consider alternatives to this (e.g. using an iframe).

    var img = new Image();
    img.onload = function () {
      return resolve(url);
    };

    // TODO(Austin): Investigate if there are errors here that should be
    // rejected.
    img.onerror = function () {
      return resolve(url);
    };
    img.src = url;
  }).catch(function (e) {
    __WEBPACK_IMPORTED_MODULE_1__madlib_logger__["a" /* default */].recordLabeledError("clicktracking_img_error", e || {});
  });
};

/**
 * pingTrackingURLWithBeacon sends a ping using the beacon API,
 * which guarantees that the url will be reached before the page is disposed.
 * See: https://developer.mozilla.org/en-US/docs/Web/API/Beacon_API
 */
var pingTrackingURLWithBeacon = function pingTrackingURLWithBeacon(url) {
  return new Promise(function (resolve, reject) {
    if (navigator.sendBeacon(url)) {
      resolve();
    } else {
      reject();
    }
  });
};

/**
 * NOTE(Casey): When the return_js=true query param is attached to an Usher URL,
 * Usher will return a JavaScript file containing
 * '_loOpen("{{HTTP_REDIRECT_URL}}")'. For unknown reasons, this
 * method for fetching the redirect URL works better than fetching it via XHR,
 * possibly due to CORS restrictions. See
 * https://docs.google.com/document/d/1nzlGVs9HNSY_Wd29UzoZSx1luZIwufl6yiQ8AXol7cU/
 */
var clickthroughWithScriptTag = function clickthroughWithScriptTag(_ref2) {
  var clickthroughURL = _ref2.clickthroughURL,
      platform = _ref2.platform,
      exchange = _ref2.exchange,
      _ref2$abTests = _ref2.abTests,
      abTests = _ref2$abTests === undefined ? [] : _ref2$abTests,
      _ref2$onlyMraid = _ref2.onlyMraid,
      onlyMraid = _ref2$onlyMraid === undefined ? false : _ref2$onlyMraid;

  window._loOpen = function (clickURL) {
    return (
      // We assume the url returned is never a liftoff url.
      __WEBPACK_IMPORTED_MODULE_0__madlib_liftoff_mraid__["a" /* default */].open(clickURL, {
        platform: platform,
        exchange: exchange,
        abTests: abTests,
        isLiftoffURL: false,
        onlyMraid: onlyMraid
      })
    );
  };
  return new Promise(function (resolve) {
    var script = document.createElement("script");
    script.onload = resolve;
    script.onerror = function (e) {
      __WEBPACK_IMPORTED_MODULE_1__madlib_logger__["a" /* default */].recordLabeledError("click_script_error", e || {});
    };
    script.src = __WEBPACK_IMPORTED_MODULE_3__frontendlib_utils__["appendParamObjectToURL"](clickthroughURL, {
      return_js: true
    });
    document.body.appendChild(script);
  }).catch(function (e) {
    __WEBPACK_IMPORTED_MODULE_1__madlib_logger__["a" /* default */].recordLabeledError("clickthrough_error", e || {});
  });
};

/**
 * Returns true if clickTrackingURL (an object like { url, type }) is a Liftoff
 * click tracking URL.
 */
var isLiftoffClickTrackingURL = function isLiftoffClickTrackingURL(clickTrackingURL) {
  return clickTrackingURL.type === __WEBPACK_IMPORTED_MODULE_2__constants__["v" /* CLICK_TRACKING_URL_TYPE_LIFTOFF_ENDPOINT */];
};

/**
 * Prepares and pings a clickTrackingURL (an object like { url, type }); common
 * Liftoff query parameters and the caller's queryParams are attached only to
 * Liftoff clickTrackingURLs.
 */
var pingClickTrackingURL = function pingClickTrackingURL(clickTrackingURL, queryParams) {
  var abTests = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];

  var getClickTrackingURLString = function getClickTrackingURLString(trackingMethod) {
    // NOTE(Austin): Right now we should only have "liftoff" click tracking
    // URLs (i.e. http://click.liftoff.io/v1/campaign_click/... ).
    return isLiftoffClickTrackingURL(clickTrackingURL) ? constructLiftoffClickURL(clickTrackingURL.url, Object.assign({}, queryParams, {
      tracking_method: trackingMethod
    })) : clickTrackingURL.url;
  };

  // The waterfall of click tracking methods to try (in priority order).
  // Each object in the array should contain a map with the following
  // keys:
  // - method: The tracking method integer, as described in rtb.proto
  //           TrackingMethod.
  // - canUse: Whether the method should be tried.
  // - pingFn: The function to ping that takes a URL string and returns a
  //           promise.
  var clickTrackingWaterfall = [{
    method: __WEBPACK_IMPORTED_MODULE_2__constants__["L" /* TRACKING_METHOD_BEACON */],
    canUse: abTests != null && abTests.includes("madlib-beacon-ping-experiment") && isLiftoffClickTrackingURL(clickTrackingURL) && navigator.sendBeacon != null,
    pingFn: pingTrackingURLWithBeacon
  }, {
    method: __WEBPACK_IMPORTED_MODULE_2__constants__["M" /* TRACKING_METHOD_IMAGE */],
    canUse: true,
    pingFn: pingTrackingURLWithImage
  }];

  // Chain all promises to try each click tracking method. If the
  // method at the previous index returns a rejected promise,
  // we try the next; otherwise we return. If we reach the end without
  // any methods succeeding, this method returns a rejected promise.
  return clickTrackingWaterfall.filter(function (_ref3) {
    var canUse = _ref3.canUse;
    return canUse;
  }).reduce(function (prevPromiseFn, nextWaterfallOption) {
    return function () {
      var method = nextWaterfallOption.method,
          pingFn = nextWaterfallOption.pingFn;

      var urlString = getClickTrackingURLString(method);
      return prevPromiseFn().catch(function () {
        return pingFn(urlString);
      });
    };
  }, function () {
    return Promise.reject();
  })();
};

var handleClickTracking = function handleClickTracking(clickTrackingURLs, queryParams) {
  var abTests = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];

  return new Promise(function (resolve) {
    var pingCompletePromises = clickTrackingURLs.map(function (clickTrackingURL) {
      return pingClickTrackingURL(clickTrackingURL, queryParams, abTests);
    });

    Promise.all(pingCompletePromises).then(resolve);
  }).catch(function (e) {
    __WEBPACK_IMPORTED_MODULE_1__madlib_logger__["a" /* default */].recordLabeledError("clicktracking_error", e || {});
  });
};

var isLiftoffClickthroughURL = function isLiftoffClickthroughURL(clickthroughURL) {
  return clickthroughURL.type === __WEBPACK_IMPORTED_MODULE_2__constants__["k" /* CLICKTHROUGH_URL_TYPE_LIFTOFF_ENDPOINT */];
};

/**
 * Opens a clickthrough URL (object like { url, type }) using the best method
 * for the given context (platform, isReengagement).
 */
var handleClickthrough = function handleClickthrough(_ref4) {
  var clickthroughURL = _ref4.clickthroughURL,
      queryParams = _ref4.queryParams,
      exchange = _ref4.exchange,
      platform = _ref4.platform,
      isReengagement = _ref4.isReengagement,
      _ref4$abTests = _ref4.abTests,
      abTests = _ref4$abTests === undefined ? [] : _ref4$abTests;

  /**
   * NOTE(oscar): As of it 2022-10-31, we only want to use MRAID for iOS POD.
   * The main reason for this is because we want to guarantee that:
   *
   * 1. SKStoreProductViewController (i.e. App Store overlay) is used. This
   * assumes mraid is needed for this.
   * 2. The click waterfall does not also open the App Store. This is an issue
   * we've seen with AppLovin, but it may affect other exchanges.
   */
  var isAutoclick = !!queryParams.pv;

  return new Promise(function (resolve) {
    var isLiftoffURL = isLiftoffClickthroughURL(clickthroughURL);
    var urlStr = isLiftoffURL ? constructLiftoffClickURL(clickthroughURL.url, queryParams) : clickthroughURL.url;

    if (queryParams.mac || queryParams.dap) {
      // The method name here is pingClickTrackingURL we do ping clickthrough
      // URL here as this is a background click.
      pingClickTrackingURL(clickthroughURL, queryParams, abTests);
    } else {
      /**
       * NOTE(Casey): On Android, script tag clicks perform better than redirect
       * clicks, while on iOS the opposite is true. However, for reengagement on
       * iOS, trackers may use "universal links", which are special web pages that
       * deeplink to an app or redirect to the app store. These links historically
       * have not worked with redirects, so we fetch the link and send the user
       * directly.
       * NOTE(Polly): We append a suffix to certain fyber clickthrough urls when
       * the native browser should be opened upon a click. We should not use the
       * script tag when the "FYBER_OPEN_BROWSER" suffix is present in the url.
       * TODO(Casey): Test if we can now redirect to universal links on iOS
       * (we have been told that this may have been fixed).
       */
      if (isLiftoffURL && (platform === __WEBPACK_IMPORTED_MODULE_2__constants__["J" /* PLATFORM_ANDROID */] || isReengagement) && !urlStr.includes("FYBER_OPEN_BROWSER")) {
        return clickthroughWithScriptTag({
          clickthroughURL: urlStr,
          platform: platform,
          exchange: exchange,
          abTests: abTests
        });
      }

      __WEBPACK_IMPORTED_MODULE_0__madlib_liftoff_mraid__["a" /* default */].open(urlStr, {
        exchange: exchange,
        platform: platform,
        abTests: abTests,
        isLiftoffURL: isLiftoffURL,
        isAutoclick: isAutoclick
      });
    }

    resolve();
  }).catch(function (e) {
    __WEBPACK_IMPORTED_MODULE_1__madlib_logger__["a" /* default */].recordLabeledError("clickthrough_error", e || {});
  });
};

/**
 * Given clickConfig, an object like:
 *
 *   {
 *     clickthroughURL: { url, type },
 *     clickTrackingURLs: [{ url, type }, { url, type }, ...],
 *   }
 *
 * prepares all URLs as appropriate based on type, pings tracking URLs, and
 * opens the click URL using the optimal method for a given context
 * (isReengagement, platform).
 */
var handleClick = function handleClick(_ref5) {
  var clickConfig = _ref5.clickConfig,
      queryParams = _ref5.queryParams,
      isReengagement = _ref5.isReengagement,
      platform = _ref5.platform,
      exchange = _ref5.exchange,
      _ref5$abTests = _ref5.abTests,
      abTests = _ref5$abTests === undefined ? null : _ref5$abTests;

  // NOTE(oscar): Some exchanges wrap our URLs in order to track their
  // metrics. We perform an asynchronous ping to this link while redirecting
  // users to our actual link to reduce latency.

  // TODO(Casey): Determine if we can move the exchange ping URL into
  // clickTrackingURLs and handle along with our own tracking URLs.
  var exchangePingElem = document.getElementById("exchange-ping-url");

  if (exchangePingElem != null && exchangePingElem.href != null) {
    __WEBPACK_IMPORTED_MODULE_3__frontendlib_utils__["ping"](exchangePingElem.href);
  }

  var clickthroughURL = clickConfig.clickthroughURL,
      clickTrackingURLs = clickConfig.clickTrackingURLs;


  var clickthroughParams = {
    clickthroughURL: clickthroughURL,
    queryParams: queryParams,
    platform: platform,
    isReengagement: isReengagement,
    exchange: exchange,
    abTests: abTests
  };
  /**
   * Handles both clicktracking and clickthrough.
   *
   * NOTE(Austin): We are testing waiting for the exchange ping to see if there
   * is some race condition.
   *
   * TODO(Austin): Consolidate rejected promises and log errors here.
   */
  var doFullClick = function doFullClick() {
    /** Product View clicks are not tracked. */
    var promise = Promise.resolve();
    if (!queryParams.pv) {
      promise = handleClickTracking(clickTrackingURLs, queryParams, abTests);
    }

    return promise.then(function () {
      return handleClickthrough(clickthroughParams);
    });
  };

  return doFullClick();
};

var _forUnitTestingOnly = {
  pingTrackingURLWithImage: pingTrackingURLWithImage,
  isLiftoffClickTrackingURL: isLiftoffClickTrackingURL,
  pingClickTrackingURL: pingClickTrackingURL,
  handleClickTracking: handleClickTracking,
  isLiftoffClickthroughURL: isLiftoffClickthroughURL,
  clickthroughWithScriptTag: clickthroughWithScriptTag,
  handleClickthrough: handleClickthrough,
  // We re-export LiftoffMRAID for unit testing to ensure that tests and the
  // functions in this file refer to the identical LiftoffMRAID object.
  LiftoffMRAID: __WEBPACK_IMPORTED_MODULE_0__madlib_liftoff_mraid__["a" /* default */]
};

/***/ }),
/* 57 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return InteractionMonitor; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__frontendlib_utils__ = __webpack_require__(0);
var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

/**
 * This includes classes for tracking interactions with creatives. The data
 * they collect are attached as query parameters to clicks (the last
 * interaction prior to a click is assumed to be the click itself).
 *
 * We listen for all three possible types of events (MouseEvents,
 * PointerEvents, and TouchEvents), because 1) device capabilities differ, so
 * different events may fire on different devices, and 2) some third-party
 * creatives block propagation of some events such that later events do not
 * fire (e.g. if they stop propagation of a PointerEvent, then the
 * corresponding TouchEvent will not fire). However, we collect data from
 * only one type of event in the following order of priority: 1) touch,
 * 2) pointer, 3) mouse (e.g. we only collect pointer data if we're not
 * receiving touch events).
 *
 * We somewhat arbitrarily define interactions as starting and ending at
 * the window's boundaries (i.e. if the user moves over a path that leaves
 * and then re-enters window, this would count as two interactions: one ends
 * when their finger leaves the window, and another one starts when it
 * re-enters the window).
 */


var POINTER_TYPE_TOUCH = 1;
var POINTER_TYPE_MOUSE = 2;
// POINTER_TYPE_POINTER is a catch-all for anything other than touch or mouse.
var POINTER_TYPE_POINTER = 3;

/**
 * Returns the pointer type of a PointerEvent.
 */
var getPointerEventPointerType = function getPointerEventPointerType(pointerEvent) {
  switch (pointerEvent.pointerType) {
    case "mouse":
      return POINTER_TYPE_MOUSE;
    case "touch":
      return POINTER_TYPE_TOUCH;
    default:
      return POINTER_TYPE_POINTER;
  }
};

/**
 * Given a MouseEvent or a PointerEvent, returns true iff a device button
 * is pressed (returns false if this cannot be determined from the event).
 */
var isButtonPressed = function isButtonPressed(e) {
  // e.which is a non-standard fallback for old versions of Safari.
  var buttons = e.buttons != null ? e.buttons : e.which;
  return buttons != null && buttons !== 0;
};

/** Returns the linear distance between (startX, startY) and (endX, endY). */
var computeDistance = function computeDistance(startX, startY, endX, endY) {
  return Math.sqrt(Math.pow(startX - endX, 2) + Math.pow(startY - endY, 2));
};

/**
 * Returns true iff the given TouchEvent has some touch-point within the bounds
 * of the window.
 */
var isTouchInWindow = function isTouchInWindow(e) {
  return [].concat(_toConsumableArray(e.changedTouches)).some(function (touch) {
    var clientX = touch.clientX,
        clientY = touch.clientY;

    return clientX >= 0 && clientX <= window.innerWidth && clientY >= 0 && clientY <= window.innerHeight;
  });
};

/**
 * Returns the maximum force of all touches in a TouchEvent, or 0 if force
 * information is not available.
 */
var maxTouchEventForce = function maxTouchEventForce(e) {
  var touchForces = [].concat(_toConsumableArray(e.changedTouches), _toConsumableArray(e.touches)).map(function (touch) {
    return touch.force || 0;
  });

  return Math.max.apply(Math, [0].concat(_toConsumableArray(touchForces)));
};

/**
 * Returns the total touch area of a TouchEvent, or 0 if touch area is not
 * available.
 */
var touchEventArea = function touchEventArea(e) {
  return [].concat(_toConsumableArray(e.touches)).reduce(function (sum, touch) {
    var radiusX = touch.radiusX,
        radiusY = touch.radiusY;

    var area = radiusX == null || radiusY == null ? 0 : Math.PI * radiusX * radiusY;
    return sum + area;
  }, 0);
};

var Interaction = function () {
  function Interaction(startEvent) {
    _classCallCheck(this, Interaction);

    this._startEvent = startEvent;
    this._lastMoveEvent = null;
    this._endEvent = null;
    this._maxForce = startEvent.force;
    this._maxArea = startEvent.area;
    this._totalDistance = 0;
  }

  _createClass(Interaction, [{
    key: "setEndEvent",
    value: function setEndEvent(endEvent) {
      this._updateMetrics(endEvent);
      this._endEvent = endEvent;
    }
  }, {
    key: "setLastMoveEvent",
    value: function setLastMoveEvent(moveEvent) {
      this._updateMetrics(moveEvent);
      this._lastMoveEvent = moveEvent;
    }
  }, {
    key: "isInProgress",
    value: function isInProgress() {
      return this._startEvent != null && this._endEvent == null;
    }
  }, {
    key: "isComplete",
    value: function isComplete() {
      return this._startEvent != null && this._endEvent != null;
    }
  }, {
    key: "getMetrics",
    value: function getMetrics() {
      var metrics = {
        startX: this._startEvent.x,
        startY: this._startEvent.y,
        isTrusted: this._startEvent.isTrusted,
        maxForce: this._maxForce,
        maxArea: this._maxArea,
        distance: this._totalDistance,
        pointerType: this._startEvent.pointerType
        // Omit durationMS because a null duration is different
        // than a duration of 0, it's important to distinguish the two.
        // The nullable value is allowed by the rtb.proto.Click object.
      };

      if (this.isComplete()) {
        // Add data that requires the interaction to be complete,
        // (i.e. has a end event).
        Object.assign(metrics, {
          durationMS: this._endEvent.timestamp - this._startEvent.timestamp
        });
      }

      return metrics;
    }
  }, {
    key: "_updateMetrics",
    value: function _updateMetrics(newEvent) {
      this._maxForce = Math.max(this._maxForce, newEvent.force);
      this._lastMaxArea = Math.max(this._maxArea, newEvent.area);

      var lastEvent = this._lastMoveEvent || this._startEvent;
      this._totalDistance += computeDistance(lastEvent.x, lastEvent.y, newEvent.x, newEvent.y);
    }
  }]);

  return Interaction;
}();

/**
 * This is an abstract base class for monitoring interaction events. Concrete
 * subclasses must define two methods:
 *
 * 1) _attachEventListeners: this must attach the relevant listeners to the
 * window and call _handleStartEvent, _handleEndEvent, and _handleMoveEvent
 * with the proper raw event.
 * 2) _normalizeEvent: this must take a raw event of the relevant type and
 * return a "normalized event" (an object like { x, y, isTrusted, timestamp,
 * force, area, pointerType }.
 */


var InteractionEventMonitor = function () {
  // #if process.env.NODE_ENV === "test"
  //   destroy() {
  //     this._attachedEventListeners.forEach(
  //       ({ eventName, handler, listenerOptions }) => {
  //         window.removeEventListener(eventName, handler, listenerOptions);
  //       }
  //     );
  //     this._attachedEventListeners = [];
  //   }
  // #endif

  function InteractionEventMonitor() {
    _classCallCheck(this, InteractionEventMonitor);

    this._interactionCount = 0;
    this._totalInteractionDistance = 0;
    this._lastInteraction = null;
    this._interactionStartHandlers = [];
    this._interactionEndHandlers = [];
    this._attachedEventListeners = [];
    this._attachEventListeners();
  }

  _createClass(InteractionEventMonitor, [{
    key: "listenFor",
    value: function listenFor(eventName, handler) {
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

      var listenerOptions = Object.assign({
        // NOTE(Austin): By default, it's absolutely critical we capture events
        // as they bubble down so we have interaction data before developers
        // presumably call our `Liftoff.open` method in an event listener handler.
        capture: true
      }, options);
      this._attachedEventListeners.push({
        eventName: eventName,
        handler: handler,
        listenerOptions: listenerOptions
      });
      window.addEventListener(eventName, handler, listenerOptions);
    }
  }, {
    key: "onInteractionStart",
    value: function onInteractionStart(handlerFn) {
      if (this._interactionStartHandlers.includes(handlerFn)) {
        return;
      }

      this._interactionStartHandlers.push(handlerFn);
    }
  }, {
    key: "_handleStartEvent",
    value: function _handleStartEvent(e) {
      if (this.isInteractionInProgress()) {
        // This could occur if another interaction starts before another one
        // completes (e.g. in the case of multiple pointer devices) or if the
        // device fires multiple 'start' events in some cases (e.g. firing
        // "pointerover" and then "pointerdown" for touch events).
        return;
      }

      var normalizedEvent = this._normalizeEvent(e);
      this._lastInteraction = new Interaction(normalizedEvent);
      this._interactionStartHandlers.forEach(function (handler) {
        return handler();
      });
    }
  }, {
    key: "onInteractionEnd",
    value: function onInteractionEnd(handlerFn) {
      if (this._interactionEndHandlers.includes(handlerFn)) {
        return;
      }

      this._interactionEndHandlers.push(handlerFn);
    }
  }, {
    key: "_handleEndEvent",
    value: function _handleEndEvent(e) {
      if (!this.isInteractionInProgress()) {
        return;
      }
      var normalizedEvent = this._normalizeEvent(e);
      this._lastInteraction.setEndEvent(normalizedEvent);

      this._updateCumulativeInteractionStats();
      this._interactionEndHandlers.forEach(function (handler) {
        return handler();
      });
    }
  }, {
    key: "_handleMoveEvent",
    value: function _handleMoveEvent(e) {
      if (!this.isInteractionInProgress()) {
        return;
      }

      var normalizedEvent = this._normalizeEvent(e);
      this._lastInteraction.setLastMoveEvent(normalizedEvent);
    }
  }, {
    key: "isInteractionInProgress",
    value: function isInteractionInProgress() {
      return this._lastInteraction != null && this._lastInteraction.isInProgress();
    }
  }, {
    key: "isLastInteractionComplete",
    value: function isLastInteractionComplete() {
      return this._lastInteraction != null && this._lastInteraction.isComplete();
    }
  }, {
    key: "getLastInteractionData",
    value: function getLastInteractionData() {
      return this._lastInteraction && this._lastInteraction.getMetrics();
    }
  }, {
    key: "getAllInteractionData",
    value: function getAllInteractionData() {
      return {
        lastInteraction: this.getLastInteractionData(),
        cumulativeStats: this.getCumulativeInteractionStats()
      };
    }
  }, {
    key: "_updateCumulativeInteractionStats",
    value: function _updateCumulativeInteractionStats() {
      this._interactionCount += 1;
      this._totalInteractionDistance += this._lastInteraction.getMetrics().distance;
    }
  }, {
    key: "getCumulativeInteractionStats",
    value: function getCumulativeInteractionStats() {
      return {
        interactionCount: this._interactionCount,
        totalDistance: this._totalInteractionDistance
      };
    }
  }, {
    key: "_normalizeEvent",
    value: function _normalizeEvent(_) {
      throw new Error("_normalizeEvent must be implemented by a concrete subclass");
    }
  }, {
    key: "_attachEventListeners",
    value: function _attachEventListeners() {
      throw new Error("_attachEventListeners must be implemented by a concrete subclass");
    }
  }]);

  return InteractionEventMonitor;
}();

var MouseEventMonitor = function (_InteractionEventMoni) {
  _inherits(MouseEventMonitor, _InteractionEventMoni);

  function MouseEventMonitor() {
    _classCallCheck(this, MouseEventMonitor);

    return _possibleConstructorReturn(this, (MouseEventMonitor.__proto__ || Object.getPrototypeOf(MouseEventMonitor)).call(this));
  }

  _createClass(MouseEventMonitor, [{
    key: "_normalizeEvent",
    value: function _normalizeEvent(e) {
      return {
        x: e.pageX,
        y: e.pageY,
        isTrusted: e.isTrusted,
        timestamp: e.timeStamp,
        // NOTE(Casey): MouseEvent.webkitForce is non-standard, but we collect
        // it if it's available anyway.
        force: e.webkitForce || 0,
        area: 0,
        pointerType: POINTER_TYPE_MOUSE
      };
    }
  }, {
    key: "_attachEventListeners",
    value: function _attachEventListeners() {
      var _this2 = this;

      _get(MouseEventMonitor.prototype.__proto__ || Object.getPrototypeOf(MouseEventMonitor.prototype), "listenFor", this).call(this, "mousedown", function (e) {
        return _this2._handleStartEvent(e);
      });
      _get(MouseEventMonitor.prototype.__proto__ || Object.getPrototypeOf(MouseEventMonitor.prototype), "listenFor", this).call(this, "mouseover", function (e) {
        if (!isButtonPressed(e)) return;
        _this2._handleStartEvent(e);
      });
      _get(MouseEventMonitor.prototype.__proto__ || Object.getPrototypeOf(MouseEventMonitor.prototype), "listenFor", this).call(this, "mouseup", function (e) {
        return _this2._handleEndEvent(e);
      });
      _get(MouseEventMonitor.prototype.__proto__ || Object.getPrototypeOf(MouseEventMonitor.prototype), "listenFor", this).call(this, "mouseout", function (e) {
        if (!isButtonPressed(e)) return;
        _this2._handleEndEvent(e);
      });
      _get(MouseEventMonitor.prototype.__proto__ || Object.getPrototypeOf(MouseEventMonitor.prototype), "listenFor", this).call(this, "mousemove", function (e) {
        if (!isButtonPressed(e)) return;
        _this2._handleMoveEvent(e);
      });
    }
  }]);

  return MouseEventMonitor;
}(InteractionEventMonitor);

var PointerEventMonitor = function (_InteractionEventMoni2) {
  _inherits(PointerEventMonitor, _InteractionEventMoni2);

  function PointerEventMonitor() {
    _classCallCheck(this, PointerEventMonitor);

    return _possibleConstructorReturn(this, (PointerEventMonitor.__proto__ || Object.getPrototypeOf(PointerEventMonitor)).call(this));
  }

  _createClass(PointerEventMonitor, [{
    key: "_normalizeEvent",
    value: function _normalizeEvent(e) {
      return {
        x: e.pageX,
        y: e.pageY,
        isTrusted: e.isTrusted,
        timestamp: e.timeStamp,
        force: e.pressure,
        // NOTE(Casey): We consider pointer area as an ellipse for consistency
        // with touch events.
        area: Math.PI * e.width * e.height / 4,
        pointerType: getPointerEventPointerType(e)
      };
    }
  }, {
    key: "_attachEventListeners",
    value: function _attachEventListeners() {
      var _this4 = this;

      _get(PointerEventMonitor.prototype.__proto__ || Object.getPrototypeOf(PointerEventMonitor.prototype), "listenFor", this).call(this, "pointerdown", function (e) {
        return _this4._handleStartEvent(e);
      });
      _get(PointerEventMonitor.prototype.__proto__ || Object.getPrototypeOf(PointerEventMonitor.prototype), "listenFor", this).call(this, "pointerover", function (e) {
        if (!isButtonPressed(e)) return;
        _this4._handleStartEvent(e);
      });
      _get(PointerEventMonitor.prototype.__proto__ || Object.getPrototypeOf(PointerEventMonitor.prototype), "listenFor", this).call(this, "pointerup", function (e) {
        return _this4._handleEndEvent(e);
      });
      _get(PointerEventMonitor.prototype.__proto__ || Object.getPrototypeOf(PointerEventMonitor.prototype), "listenFor", this).call(this, "pointercancel", function (e) {
        return _this4._handleEndEvent(e);
      });
      _get(PointerEventMonitor.prototype.__proto__ || Object.getPrototypeOf(PointerEventMonitor.prototype), "listenFor", this).call(this, "pointerout", function (e) {
        if (!isButtonPressed(e)) return;
        _this4._handleEndEvent(e);
      });
      _get(PointerEventMonitor.prototype.__proto__ || Object.getPrototypeOf(PointerEventMonitor.prototype), "listenFor", this).call(this, "pointermove", function (e) {
        if (!isButtonPressed(e)) return;
        _this4._handleMoveEvent(e);
      });
    }
  }]);

  return PointerEventMonitor;
}(InteractionEventMonitor);

var TouchEventMonitor = function (_InteractionEventMoni3) {
  _inherits(TouchEventMonitor, _InteractionEventMoni3);

  function TouchEventMonitor() {
    _classCallCheck(this, TouchEventMonitor);

    return _possibleConstructorReturn(this, (TouchEventMonitor.__proto__ || Object.getPrototypeOf(TouchEventMonitor)).call(this));
  }

  _createClass(TouchEventMonitor, [{
    key: "_normalizeEvent",
    value: function _normalizeEvent(e) {
      return {
        // NOTE(Casey): We arbitrarily choose a changed touch to use for the
        // interaction position, making distance measures inaccurate for multi-
        // touch interactions.
        x: e.changedTouches[0].pageX,
        y: e.changedTouches[0].pageY,
        isTrusted: e.isTrusted,
        timestamp: e.timeStamp,
        force: maxTouchEventForce(e),
        area: touchEventArea(e),
        pointerType: POINTER_TYPE_TOUCH
      };
    }
  }, {
    key: "_attachEventListeners",
    value: function _attachEventListeners() {
      var _this6 = this;

      _get(TouchEventMonitor.prototype.__proto__ || Object.getPrototypeOf(TouchEventMonitor.prototype), "listenFor", this).call(this, "touchstart", function (e) {
        return _this6._handleStartEvent(e);
      });
      _get(TouchEventMonitor.prototype.__proto__ || Object.getPrototypeOf(TouchEventMonitor.prototype), "listenFor", this).call(this, "touchend", function (e) {
        if (e.touches.length !== 0) return;
        _this6._handleEndEvent(e);
      });
      _get(TouchEventMonitor.prototype.__proto__ || Object.getPrototypeOf(TouchEventMonitor.prototype), "listenFor", this).call(this, "touchcancel", function (e) {
        return _this6._handleEndEvent(e);
      });
      _get(TouchEventMonitor.prototype.__proto__ || Object.getPrototypeOf(TouchEventMonitor.prototype), "listenFor", this).call(this, "touchmove", function (e) {
        // NOTE(Casey): There are no touch events analogous to
        // mouseover/pointerover and mouseout/pointerout, so we check if the touch
        // is within the window during move events instead.
        var isInWindow = isTouchInWindow(e);
        if (!isInWindow && _this6.isInteractionInProgress()) {
          // The touch started inside the window and has now moved outside of it.
          _this6._handleEndEvent(e);
        } else if (isInWindow && _this6.isLastInteractionComplete()) {
          // The touch started outside of the window and moved into the window,
          // so we need to start tracking a new interaction.
          _this6._handleStartEvent(e);
        } else {
          // This event is part of the interaction we're currently tracking.
          _this6._handleMoveEvent(e);
        }
      });
    }
  }]);

  return TouchEventMonitor;
}(InteractionEventMonitor);

var InteractionMonitor = function () {
  // #if process.env.NODE_ENV === "test"
  //   destroy() {
  //     this._monitors.forEach((monitor) => {
  //       monitor.destroy();
  //     });
  //     this._monitors = [];
  //   }
  // #endif

  function InteractionMonitor() {
    var _this7 = this;

    _classCallCheck(this, InteractionMonitor);

    // These events are ordered by priority, from highest to lowest.
    this._monitors = [new TouchEventMonitor(), new PointerEventMonitor(), new MouseEventMonitor()];

    this._monitors.forEach(function (monitor) {
      monitor.onInteractionStart(_this7._handleInteractionEvent.bind(_this7));
    });
    this._monitors.forEach(function (monitor) {
      monitor.onInteractionEnd(_this7._handleInteractionEvent.bind(_this7));
    });

    this._previousAllInteractionData = null;
    this._interactionChangeHandlers = [];
  }

  /**
   * Given a function that will receive an object like that returned by
   * getAllInteractionData, sets up listeners so that handlerFn will be called
   * whenever any interaction data change.
   */


  _createClass(InteractionMonitor, [{
    key: "onInteractionChange",
    value: function onInteractionChange(handlerFn) {
      if (this._interactionChangeHandlers.includes(handlerFn)) {
        return;
      }

      this._interactionChangeHandlers.push(handlerFn);
    }
  }, {
    key: "_handleInteractionEvent",
    value: function _handleInteractionEvent() {
      var currentAllInteractionData = this.getAllInteractionData();
      if (Object(__WEBPACK_IMPORTED_MODULE_0__frontendlib_utils__["deepEqual"])(this._previousAllInteractionData, currentAllInteractionData)) {
        return;
      }

      this._previousAllInteractionData = currentAllInteractionData;
      this._interactionChangeHandlers.forEach(function (handler) {
        handler(currentAllInteractionData);
      });
    }
  }, {
    key: "_chooseEventMonitorWithInProgressInteractions",
    value: function _chooseEventMonitorWithInProgressInteractions() {
      return this._monitors.find(function (eventMonitor) {
        return eventMonitor.isInteractionInProgress();
      });
    }
  }, {
    key: "_chooseEventMonitorWithCompletedInteractions",
    value: function _chooseEventMonitorWithCompletedInteractions() {
      return this._monitors.find(function (eventMonitor) {
        return eventMonitor.isLastInteractionComplete();
      });
    }
  }, {
    key: "_chooseEventMonitor",
    value: function _chooseEventMonitor() {
      // Since this class is used by in-house and third-party creatives
      // we prioritize partial interactions (i.e. clickthrough events
      // that fire before the touchEnd/clickEnd/etc. fires).
      return this._chooseEventMonitorWithInProgressInteractions() || this._chooseEventMonitorWithCompletedInteractions();
    }

    /**
     * Returns a map containing the last interaction and the cumulative
     * statistics. Prefer using this over calling `getLastInteractionData` and
     * `getCumulativeInteractionStats` separately.
     */

  }, {
    key: "getAllInteractionData",
    value: function getAllInteractionData() {
      var eventMonitor = this._chooseEventMonitor();
      if (eventMonitor == null) {
        return null;
      }

      return eventMonitor.getAllInteractionData();
    }

    /**
     * Returns an object like { startX, startY, isTrusted, durationMS, maxForce
     * maxArea, distance, pointerType } describing the last interaction.
     */

  }, {
    key: "getLastInteractionData",
    value: function getLastInteractionData() {
      var eventMonitor = this._chooseEventMonitor();
      if (eventMonitor == null) {
        return null;
      }

      return eventMonitor.getLastInteractionData();
    }

    /** Returns an object like { interactionCount, totalDistance }. */

  }, {
    key: "getCumulativeInteractionStats",
    value: function getCumulativeInteractionStats() {
      var eventMonitor = this._chooseEventMonitor();
      if (eventMonitor == null) {
        return null;
      }

      return eventMonitor.getCumulativeInteractionStats();
    }
  }]);

  return InteractionMonitor;
}();



/***/ }),
/* 58 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__behaviors_AutoclickBehaviorCompletedDelay__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__behaviors_AutoclickBehaviorInteractionCount__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__behaviors_AutoclickBehaviorLastInteraction__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__behaviors_AutoclickBehaviorLastInteractionAndCount__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__behaviors_AutoclickBehaviorLoadDelay__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__behaviors_AutoclickBehaviorViewableDelay__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__behaviors_AutoclickBehaviorViewableDelayWithReset__ = __webpack_require__(65);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _behaviorClasses;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }










var behaviorClasses = (_behaviorClasses = {}, _defineProperty(_behaviorClasses, __WEBPACK_IMPORTED_MODULE_0__constants__["d" /* AUTOCLICK_TYPE_COMPLETED_DELAY */], __WEBPACK_IMPORTED_MODULE_1__behaviors_AutoclickBehaviorCompletedDelay__["a" /* default */]), _defineProperty(_behaviorClasses, __WEBPACK_IMPORTED_MODULE_0__constants__["e" /* AUTOCLICK_TYPE_INTERACTION_COUNT */], __WEBPACK_IMPORTED_MODULE_2__behaviors_AutoclickBehaviorInteractionCount__["a" /* default */]), _defineProperty(_behaviorClasses, __WEBPACK_IMPORTED_MODULE_0__constants__["f" /* AUTOCLICK_TYPE_LAST_INTERACTION */], __WEBPACK_IMPORTED_MODULE_3__behaviors_AutoclickBehaviorLastInteraction__["a" /* default */]), _defineProperty(_behaviorClasses, __WEBPACK_IMPORTED_MODULE_0__constants__["g" /* AUTOCLICK_TYPE_LAST_INTERACTION_AND_INTERACTION_COUNT */], __WEBPACK_IMPORTED_MODULE_4__behaviors_AutoclickBehaviorLastInteractionAndCount__["a" /* default */]), _defineProperty(_behaviorClasses, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* AUTOCLICK_TYPE_LOAD_DELAY */], __WEBPACK_IMPORTED_MODULE_5__behaviors_AutoclickBehaviorLoadDelay__["a" /* default */]), _defineProperty(_behaviorClasses, __WEBPACK_IMPORTED_MODULE_0__constants__["i" /* AUTOCLICK_TYPE_VIEWABLE_DELAY */], __WEBPACK_IMPORTED_MODULE_6__behaviors_AutoclickBehaviorViewableDelay__["a" /* default */]), _defineProperty(_behaviorClasses, __WEBPACK_IMPORTED_MODULE_0__constants__["j" /* AUTOCLICK_TYPE_VIEWABLE_DELAY_WITH_RESET */], __WEBPACK_IMPORTED_MODULE_7__behaviors_AutoclickBehaviorViewableDelayWithReset__["a" /* default */]), _behaviorClasses);

var MONITORED_EVENTS = {
  INTERACTION_EVENT: "interactionEvent",
  COMPLETED: "completed",
  ENGAGEMENT: "engagement",
  HTML_LOADED: "htmlLoaded",
  VIEWABLE: "viewable",
  VIEWABLE_CHANGE: "viewableChange"
};

var AUTOCLICK_EVENT_COUNT_CHANGE = "countChanged";

/**
 * @callback ClickthroughHandler
 * @param  {object} lastEvent - The last Interaction event.
 */

/**
 * @typedef AutoclickBehaviorConfig
 * @property {string} type - autoclick variant type.
 * @property {number} delay - In ms. Time to wait until opening App Store from
 * autoclick click.
 * @property {number} count - Max occurrences of events as determined by type.
 */

/**
 * Controls App Store On Interaction, aka. autoclick, behavior.
 * @see https://docs.google.com/document/d/1QYHzXt1oxmGIx2F63XErz7dF4SD6pxSi-1mkxxnHsUU/edit#heading=h.bypyxke51ec
 */

var Autoclick = function () {
  /**
   *
   * @param {AutoclickBehaviorConfig} behavior - Describes the autoclick behavior.
   * @param {Object} ctx
   * @param {ClickthroughHandler} ctx.clickthroughHandler
   * @returns
   */
  function Autoclick(behavior, _ref) {
    var _eventListeners;

    var clickthroughHandler = _ref.clickthroughHandler;

    _classCallCheck(this, Autoclick);

    if (behavior == null) {
      this.disable();
      return;
    }
    this._clickthroughHandler = clickthroughHandler;
    this._lastCount = 0;
    this._lastInteraction = null;

    this._behavior = behavior;
    var behaviorType = behavior == null ? null : behavior.type;
    if (behaviorClasses[behaviorType] == null) {
      console.error("Behavior class not found: " + behaviorType);
      this.disable();
      return;
    }
    /** @type {AutoclickBehaviorInteractionCount|AutoclickBehaviorCompletedDelay|AutoclickBehaviorLastInteraction|AutoclickBehaviorLastInteractionAndCount} */
    this.behaviorClass = new behaviorClasses[behaviorType]({
      autoclick: this,
      behavior: behavior,
      delayClickthroughHandler: this._handleDelayClickthrough.bind(this)
    });

    this._handleDelayClickthrough = this._handleDelayClickthrough.bind(this);

    this.eventListeners = (_eventListeners = {}, _defineProperty(_eventListeners, MONITORED_EVENTS.ENGAGEMENT, [this.behaviorClass.onEngagement.bind(this.behaviorClass)]), _defineProperty(_eventListeners, MONITORED_EVENTS.HTML_LOADED, [this.behaviorClass.onHtmlLoaded.bind(this.behaviorClass)]), _defineProperty(_eventListeners, MONITORED_EVENTS.VIEWABLE, [this.behaviorClass.onViewable.bind(this.behaviorClass)]), _defineProperty(_eventListeners, MONITORED_EVENTS.VIEWABLE_CHANGE, [this.behaviorClass.onViewableChange.bind(this.behaviorClass)]), _defineProperty(_eventListeners, MONITORED_EVENTS.COMPLETED, [this.behaviorClass.onCompleted.bind(this.behaviorClass)]), _defineProperty(_eventListeners, MONITORED_EVENTS.INTERACTION_EVENT,
    // Order matters.
    [this._recordLastInteraction.bind(this), this.behaviorClass.onInteraction.bind(this.behaviorClass)]), _defineProperty(_eventListeners, AUTOCLICK_EVENT_COUNT_CHANGE, []), _eventListeners);
  }

  _createClass(Autoclick, [{
    key: "disable",
    value: function disable() {
      this.autoclickDisabled = true;
    }
  }, {
    key: "emitInteractionEvent",
    value: function emitInteractionEvent() {
      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      this.emit.apply(this, [MONITORED_EVENTS.INTERACTION_EVENT].concat(args));
    }
  }, {
    key: "emitInteractionPromptReachedEvent",
    value: function emitInteractionPromptReachedEvent() {
      for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      this.emit.apply(this, [MONITORED_EVENTS.COMPLETED].concat(args));
    }
  }, {
    key: "emitHtmlLoadedEvent",
    value: function emitHtmlLoadedEvent() {
      for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        args[_key3] = arguments[_key3];
      }

      this.emit.apply(this, [MONITORED_EVENTS.HTML_LOADED].concat(args));
    }
  }, {
    key: "emitViewableEvent",
    value: function emitViewableEvent() {
      for (var _len4 = arguments.length, args = Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
        args[_key4] = arguments[_key4];
      }

      this.emit.apply(this, [MONITORED_EVENTS.VIEWABLE].concat(args));
    }
  }, {
    key: "emitViewableChangeEvent",
    value: function emitViewableChangeEvent() {
      for (var _len5 = arguments.length, args = Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
        args[_key5] = arguments[_key5];
      }

      this.emit.apply(this, [MONITORED_EVENTS.VIEWABLE_CHANGE].concat(args));
    }
  }, {
    key: "_recordLastInteraction",
    value: function _recordLastInteraction(e) {
      this._lastInteraction = e;
    }
  }, {
    key: "_handleDelayClickthrough",
    value: function _handleDelayClickthrough(delay) {
      var _this = this;

      clearTimeout(this._delayTimer);
      if (this.autoclickDisabled) return;

      this._delayTimer = setTimeout(function () {
        _this._clickthrough();
      }, delay || 0);
    }
  }, {
    key: "_clickthrough",
    value: function _clickthrough() {
      if (this.autoclickDisabled) return;
      this._clickthroughHandler(this._lastInteraction);
      this.disable();
    }
  }, {
    key: "emit",
    value: function emit(eventName) {
      for (var _len6 = arguments.length, args = Array(_len6 > 1 ? _len6 - 1 : 0), _key6 = 1; _key6 < _len6; _key6++) {
        args[_key6 - 1] = arguments[_key6];
      }

      if (this.autoclickDisabled) return;
      if (!(eventName in this.eventListeners)) {
        throw new Error("Event " + eventName + " not found!");
      }
      this.eventListeners[eventName].forEach(function (f) {
        f.apply(undefined, args);
      });
    }
  }]);

  return Autoclick;
}();

/* harmony default export */ __webpack_exports__["a"] = (Autoclick);

/***/ }),
/* 59 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AutoclickBehaviorAbstract__ = __webpack_require__(8);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



var AutoclickBehaviorCompletedDelay = function (_AutoclickBehaviorAbs) {
  _inherits(AutoclickBehaviorCompletedDelay, _AutoclickBehaviorAbs);

  function AutoclickBehaviorCompletedDelay() {
    _classCallCheck(this, AutoclickBehaviorCompletedDelay);

    return _possibleConstructorReturn(this, (AutoclickBehaviorCompletedDelay.__proto__ || Object.getPrototypeOf(AutoclickBehaviorCompletedDelay)).apply(this, arguments));
  }

  _createClass(AutoclickBehaviorCompletedDelay, [{
    key: "onCompleted",
    value: function onCompleted() {
      this.delayClickthrough(this.getBehaviorDelay());
    }
  }]);

  return AutoclickBehaviorCompletedDelay;
}(__WEBPACK_IMPORTED_MODULE_0__AutoclickBehaviorAbstract__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (AutoclickBehaviorCompletedDelay);

/***/ }),
/* 60 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AutoclickBehaviorAbstract__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__autoclick_utils__ = __webpack_require__(37);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var AutoclickBehaviorInteractionCount = function (_AutoclickBehaviorAbs) {
  _inherits(AutoclickBehaviorInteractionCount, _AutoclickBehaviorAbs);

  function AutoclickBehaviorInteractionCount() {
    _classCallCheck(this, AutoclickBehaviorInteractionCount);

    return _possibleConstructorReturn(this, (AutoclickBehaviorInteractionCount.__proto__ || Object.getPrototypeOf(AutoclickBehaviorInteractionCount)).apply(this, arguments));
  }

  _createClass(AutoclickBehaviorInteractionCount, [{
    key: "init",
    value: function init() {
      this._counter = Object(__WEBPACK_IMPORTED_MODULE_1__autoclick_utils__["a" /* intentionalInteractionCounterFn */])(this.getBehaviorCount());
      this.triggered = false;
    }
  }, {
    key: "onInteraction",
    value: function onInteraction(e) {
      this.setCurrentCount(this._counter(e));

      if (!this.isCountReached() || this.triggered) return;
      this.triggered = true;

      this.delayClickthrough(this.getBehaviorDelay());
    }
  }]);

  return AutoclickBehaviorInteractionCount;
}(__WEBPACK_IMPORTED_MODULE_0__AutoclickBehaviorAbstract__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (AutoclickBehaviorInteractionCount);

/***/ }),
/* 61 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AutoclickBehaviorAbstract__ = __webpack_require__(8);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



var AutoclickBehaviorLastInteraction = function (_AutoclickBehaviorAbs) {
  _inherits(AutoclickBehaviorLastInteraction, _AutoclickBehaviorAbs);

  function AutoclickBehaviorLastInteraction() {
    _classCallCheck(this, AutoclickBehaviorLastInteraction);

    return _possibleConstructorReturn(this, (AutoclickBehaviorLastInteraction.__proto__ || Object.getPrototypeOf(AutoclickBehaviorLastInteraction)).apply(this, arguments));
  }

  _createClass(AutoclickBehaviorLastInteraction, [{
    key: "onInteraction",
    value: function onInteraction() {
      this.delayClickthrough(this.getBehaviorDelay());
    }
  }]);

  return AutoclickBehaviorLastInteraction;
}(__WEBPACK_IMPORTED_MODULE_0__AutoclickBehaviorAbstract__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (AutoclickBehaviorLastInteraction);

/***/ }),
/* 62 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AutoclickBehaviorAbstract__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__autoclick_utils__ = __webpack_require__(37);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var AutoclickBehaviorLastInteractionAndCount = function (_AutoclickBehaviorAbs) {
  _inherits(AutoclickBehaviorLastInteractionAndCount, _AutoclickBehaviorAbs);

  function AutoclickBehaviorLastInteractionAndCount() {
    _classCallCheck(this, AutoclickBehaviorLastInteractionAndCount);

    return _possibleConstructorReturn(this, (AutoclickBehaviorLastInteractionAndCount.__proto__ || Object.getPrototypeOf(AutoclickBehaviorLastInteractionAndCount)).apply(this, arguments));
  }

  _createClass(AutoclickBehaviorLastInteractionAndCount, [{
    key: "init",
    value: function init() {
      this._counter = Object(__WEBPACK_IMPORTED_MODULE_1__autoclick_utils__["a" /* intentionalInteractionCounterFn */])(this.getBehaviorCount());
    }
  }, {
    key: "onInteraction",
    value: function onInteraction(e) {
      this.setCurrentCount(this._counter(e));

      this.delayClickthrough(this.getBehaviorDelay());
    }
  }]);

  return AutoclickBehaviorLastInteractionAndCount;
}(__WEBPACK_IMPORTED_MODULE_0__AutoclickBehaviorAbstract__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (AutoclickBehaviorLastInteractionAndCount);

/***/ }),
/* 63 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AutoclickBehaviorAbstract__ = __webpack_require__(8);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



var AutoclickBehaviorLoadDelay = function (_AutoclickBehaviorAbs) {
  _inherits(AutoclickBehaviorLoadDelay, _AutoclickBehaviorAbs);

  function AutoclickBehaviorLoadDelay() {
    _classCallCheck(this, AutoclickBehaviorLoadDelay);

    return _possibleConstructorReturn(this, (AutoclickBehaviorLoadDelay.__proto__ || Object.getPrototypeOf(AutoclickBehaviorLoadDelay)).apply(this, arguments));
  }

  _createClass(AutoclickBehaviorLoadDelay, [{
    key: "onHtmlLoaded",
    value: function onHtmlLoaded() {
      this.delayClickthrough(this.getBehaviorDelay());
    }
  }]);

  return AutoclickBehaviorLoadDelay;
}(__WEBPACK_IMPORTED_MODULE_0__AutoclickBehaviorAbstract__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (AutoclickBehaviorLoadDelay);

/***/ }),
/* 64 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AutoclickBehaviorAbstract__ = __webpack_require__(8);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



var AutoclickBehaviorViewableDelay = function (_AutoclickBehaviorAbs) {
  _inherits(AutoclickBehaviorViewableDelay, _AutoclickBehaviorAbs);

  function AutoclickBehaviorViewableDelay() {
    _classCallCheck(this, AutoclickBehaviorViewableDelay);

    return _possibleConstructorReturn(this, (AutoclickBehaviorViewableDelay.__proto__ || Object.getPrototypeOf(AutoclickBehaviorViewableDelay)).apply(this, arguments));
  }

  _createClass(AutoclickBehaviorViewableDelay, [{
    key: "onViewable",
    value: function onViewable() {
      this.delayClickthrough(this.getBehaviorDelay());
    }
  }]);

  return AutoclickBehaviorViewableDelay;
}(__WEBPACK_IMPORTED_MODULE_0__AutoclickBehaviorAbstract__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (AutoclickBehaviorViewableDelay);

/***/ }),
/* 65 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AutoclickBehaviorAbstract__ = __webpack_require__(8);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



var AutoclickBehaviorViewableDelay = function (_AutoclickBehaviorAbs) {
  _inherits(AutoclickBehaviorViewableDelay, _AutoclickBehaviorAbs);

  function AutoclickBehaviorViewableDelay() {
    _classCallCheck(this, AutoclickBehaviorViewableDelay);

    return _possibleConstructorReturn(this, (AutoclickBehaviorViewableDelay.__proto__ || Object.getPrototypeOf(AutoclickBehaviorViewableDelay)).apply(this, arguments));
  }

  _createClass(AutoclickBehaviorViewableDelay, [{
    key: "onViewable",
    value: function onViewable() {
      this.delayClickthrough(this.getBehaviorDelay());
    }
  }, {
    key: "onViewableChange",
    value: function onViewableChange(isViewable) {
      if (!isViewable) {
        clearTimeout(this._autoclick._delayTimer);
      }
    }
  }]);

  return AutoclickBehaviorViewableDelay;
}(__WEBPACK_IMPORTED_MODULE_0__AutoclickBehaviorAbstract__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (AutoclickBehaviorViewableDelay);

/***/ }),
/* 66 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__frontendlib_dom_utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__frontendlib_utils__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__frontendlib_event_listener__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_click_interaction__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__container__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__cta__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__liftoff_mraid__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__addDeadzones__ = __webpack_require__(39);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }












var Madlib = function () {
  function Madlib() {
    _classCallCheck(this, Madlib);
  }

  _createClass(Madlib, null, [{
    key: "init",
    value: function init() {
      __WEBPACK_IMPORTED_MODULE_2__frontendlib_event_listener__["a" /* default */].pubsubify(this);

      this.rootEl = null;
      this.config = null;

      this.loaded = false;
      this.containerByID = {};
      this.allContainers = [];
      this.rootContainer = null;

      // TODO(vsingh): Remove hacky global once we are more clear on how Madlib resize events should
      //   be handled.
      this.didEverApplyLetterboxStyles = false;

      this.productIndex = 0;

      this.on("navigation-click", function (queryParams, clickAreaType) {
        Liftoff.handleClick(queryParams, clickAreaType);
      });
    }

    /**
     * Returns a product cycling indefinitely.
     */

  }, {
    key: "getNextProduct",
    value: function getNextProduct() {
      var _Liftoff$env$products = Liftoff.env.products,
          products = _Liftoff$env$products === undefined ? [] : _Liftoff$env$products;
      var productIndex = this.productIndex;

      this.productIndex += 1;

      return products[productIndex % products.length];
    }
  }, {
    key: "error",
    value: function error() {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new Error("Unspecified Madlib error.");

      Liftoff.handleMadlibError(e);
    }
  }, {
    key: "load",
    value: function load(rootEl, config) {
      this.rootEl = rootEl;
      this.config = config;
      this.applyExchangePolicies();
      this.loadDOM();
      this.addEventListeners();
      this.coordinate();
      this.layout();

      Liftoff.onLoadCompleted();
    }
  }, {
    key: "applyExchangePolicies",
    value: function applyExchangePolicies() {
      var animationDurationLimit = Liftoff.getAnimationDurationLimit();
      if (animationDurationLimit > 0) {
        setTimeout(function () {
          Madlib.allContainers.forEach(function (container) {
            var content = container.content;

            if (content == null) return;
            container.layout().then(function () {
              content.stop();
            });
          });
        }, animationDurationLimit);
      }
    }
  }, {
    key: "loadDOM",
    value: function loadDOM() {
      var _this = this;

      this.layoutEl = document.createElement("div");
      this.layoutEl.id = "liftoff-layout";
      this.rootEl.appendChild(this.layoutEl);

      this.clickEl = document.createElement("div");
      this.clickEl.id = "liftoff-click";
      __WEBPACK_IMPORTED_MODULE_3__lib_click_interaction__["a" /* default */].addListeners(this.clickEl, function (e) {
        _this.handleNavigationClick(e);
      });
      this.rootEl.appendChild(this.clickEl);

      var _Liftoff$bidContext = Liftoff.bidContext,
          is_interstitial = _Liftoff$bidContext.is_interstitial,
          is_reengagement = _Liftoff$bidContext.is_reengagement;
      // TODO(oscar): Cleanup test code once crserve-deadzone experiment is over.

      var isDeadzoneExperiment = Liftoff.hasTestGroup("crserve-deadzone-v2-experiment");
      var useDeadzones = is_interstitial && (!is_reengagement || isDeadzoneExperiment);
      if (useDeadzones) {
        Object(__WEBPACK_IMPORTED_MODULE_7__addDeadzones__["b" /* default */])(isDeadzoneExperiment, this.rootEl);
      }
    }
  }, {
    key: "handleNavigationClick",
    value: function handleNavigationClick(e) {
      var queryParams = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      this.emit("navigation-click", queryParams, Object(__WEBPACK_IMPORTED_MODULE_5__cta__["a" /* clickAreaTypeFromEvent */])(e));
    }
  }, {
    key: "addEventListeners",
    value: function addEventListeners() {
      var _this2 = this;

      window.addEventListener("resize", function () {
        _this2.layout();
      });
    }
  }, {
    key: "coordinate",
    value: function coordinate() {
      this.on("wait", function (_ref) {
        var timeMS = _ref.timeMS;

        return new Promise(function (resolve) {
          return setTimeout(resolve, Number(timeMS));
        });
      });
    }
  }, {
    key: "getEvents",
    value: function getEvents() {
      return [{ name: "beforeVisible" }].map(function (e) {
        e.type = "madlib";
        return e;
      });
    }
  }, {
    key: "getActions",
    value: function getActions() {
      return [{
        name: "wait",
        data: ["timeMS"]
      }].map(function (a) {
        a.type = "madlib";
        return a;
      });
    }
  }, {
    key: "getCreativeConfig",
    value: function getCreativeConfig() {
      // TODO(cory) Implement rendering for multiple scenes. For now, all configs have exactly one scene.
      return this.config.scenes[0].layoutContent;
    }
  }, {
    key: "configureLetterbox",
    value: function configureLetterbox(letterboxConfig) {
      var useDarkRootBackground = letterboxConfig.useDarkRootBackground();
      var useLayoutBackground = letterboxConfig.useLayoutBackground();

      this.rootEl.classList.toggle("letterbox-dark-background", useDarkRootBackground);
      this.layoutEl.classList.toggle("letterbox-layout-background", useLayoutBackground);

      this.didEverApplyLetterboxStyles = true;

      Object.assign(this.clickEl.style, letterboxConfig.getStyleForClickElement());
    }
  }, {
    key: "layout",
    value: function layout() {
      var _this3 = this;

      if (this.rootContainer != null) {
        this.rootContainer.invalidate();
      }

      this.reset();

      var letterboxConfig = Liftoff.getLetterboxConfig();
      var rootElementConstraints = null;

      if (letterboxConfig.enabled()) {
        this.configureLetterbox(letterboxConfig);
        rootElementConstraints = letterboxConfig.getLetterboxConstraintsForMadlibRootElement();
      }

      this.parseCreativeConfig(this.layoutEl, this.getCreativeConfig(), rootElementConstraints);

      var allContainers = this.allContainers,
          rootContainer = this.rootContainer;


      var loaded = rootContainer.loadContent().catch(function (e) {
        return _this3.error(e);
      });

      var ready = rootContainer.layout().then(function () {
        __WEBPACK_IMPORTED_MODULE_6__liftoff_mraid__["a" /* default */].onViewable(function () {
          if (rootContainer.invalidated) return;
          allContainers.forEach(function (_ref2) {
            var content = _ref2.content;

            if (content) content.start();
          });
        });
      }).catch(function (e) {
        return _this3.error(e);
      });

      Promise.all([loaded, ready]).then(function () {
        if (!_this3.loaded) {
          _this3.loaded = true;
          Liftoff.onMadlibLoaded();
          _this3.emit("beforeVisible");
          Liftoff.onFirstLayoutFinished();
        }
      });
    }
  }, {
    key: "reset",
    value: function reset() {
      this.productIndex = 0;
      // TODO(brian): Teardown existing components here.
      Liftoff.resetClickParams();
      this.clickEl.classList.remove("active");
      Object(__WEBPACK_IMPORTED_MODULE_0__frontendlib_dom_utils__["empty"])(this.layoutEl);
      if (this.didEverApplyLetterboxStyles) {
        [this.layoutEl, this.clickEl].forEach(function (el) {
          ["left", "top", "width", "height", "right", "bottom", "transform"].forEach(function (prop) {
            el.style[prop] = "";
          });
        });
      }
    }
  }, {
    key: "parseCreativeConfig",
    value: function parseCreativeConfig(rootEl, config, rootElementConstraints) {
      var _this4 = this;

      var componentParams = config.componentParams;

      var clickTargets = config.clickTargets,
          constraints = config.constraints,
          containers = config.containers,
          coordination = config.coordination,
          css = config.css;

      var _ref3 = rootElementConstraints || {},
          rootConstraints = _ref3.rootConstraints,
          rootPostLayoutTransform = _ref3.rootPostLayoutTransform;

      var traverse = function traverse(parent, _ref4) {
        var id = _ref4.id,
            children = _ref4.children;

        var container = new __WEBPACK_IMPORTED_MODULE_4__container__["a" /* default */](document.createElement("div"), id);
        container.parent = parent;
        container.children = (children || []).map(traverse.bind(null, container));
        container.css = css[id];
        container.constraints = constraints[id];
        if (componentParams[id] != null) {
          var _componentParams$id = componentParams[id],
              component = _componentParams$id.component,
              params = _componentParams$id.params;

          var subcomponents = [];
          var fixValues = function fixValues(params) {
            Object.keys(params).forEach(function (key) {
              var _params$key = params[key],
                  type = _params$key.type,
                  value = _params$key.value;

              if (value != null) {
                switch (type) {
                  case "array":
                    params[key].value = value.map(fixValues);
                    break;
                  case "image_original":
                  case "video_original":
                    params[key].value = Liftoff.resolveAsset(type, value);
                    break;
                  case "component":
                    var componentName = value.component;
                    var _componentParams = fixValues(Object(__WEBPACK_IMPORTED_MODULE_1__frontendlib_utils__["clone"])(value.params));
                    var _component = Liftoff.Component.new(componentName, _componentParams);
                    params[key].value = _component;
                    subcomponents.push(_component);
                    break;
                }
              }

              params[key] = params[key].value;
            });
            return params;
          };

          params = fixValues(Object(__WEBPACK_IMPORTED_MODULE_1__frontendlib_utils__["clone"])(params));
          container.content = Liftoff.Component.new(component, params);
          container.content.on("error", _this4.error.bind(_this4));
          // Errors from all subcomponents, regardless of nesting depth, are
          // relayed directly to the top-level component.
          subcomponents.forEach(function (subcomponent) {
            return subcomponent.relay(container.content, "error");
          });
        }

        _this4.containerByID[id] = container;
        _this4.allContainers.push(container);
        return container;
      };

      this.containerByID = {};
      this.allContainers = [];
      this.rootContainer = new __WEBPACK_IMPORTED_MODULE_4__container__["a" /* default */](rootEl);
      this.rootContainer.parent = new __WEBPACK_IMPORTED_MODULE_4__container__["a" /* default */](rootEl.parentNode);
      this.rootContainer.children = containers.map(traverse.bind(null, this.rootContainer));
      this.rootContainer.css = { overflow: "hidden" };
      this.rootContainer.constraints = rootConstraints || {
        width: "100%",
        height: "100%"
      };
      this.rootContainer.postLayoutTransform = rootPostLayoutTransform;

      this.attachAnchors();
      this.configureCoordination(coordination);
      this.configureClickTargets(clickTargets);

      this.rootContainer.layout();
    }
  }, {
    key: "attachAnchors",
    value: function attachAnchors() {
      var _this5 = this;

      this.allContainers.forEach(function (container) {
        if (container.constraints == null) return;
        container.anchors = ["top", "right", "bottom", "left"].filter(function (edge) {
          return Object(__WEBPACK_IMPORTED_MODULE_1__frontendlib_utils__["type"])(container.constraints[edge]) === "object";
        }).map(function (edge) {
          return {
            edge: edge,
            anchor: _this5.containerByID[container.constraints[edge].anchor]
          };
        });
      });
    }

    // Link events with actions.

  }, {
    key: "configureCoordination",
    value: function configureCoordination(coordination) {
      var _this6 = this;

      coordination.filter(function (_ref5) {
        var event = _ref5.event;
        return event.name != null;
      }).forEach(function (_ref6) {
        var event = _ref6.event,
            actions = _ref6.actions;
        var eventName = event.name,
            eventType = event.type,
            source = event.source,
            eventMacros = event.data;


        var actors = actions.map(function (action) {
          var actionName = action.name,
              actionType = action.type,
              target = action.target,
              actionMacros = action.data;

          var actor = void 0;
          switch (actionType) {
            case "madlib":
              actor = _this6;
              break;
            case "component":
              actor = _this6.containerByID[target].content;
              break;
            case "container":
              actor = _this6.containerByID[target];
              break;
          }

          return { actionName: actionName, actor: actor, actionMacros: actionMacros };
        }).filter(function (_ref7) {
          var actionName = _ref7.actionName;
          return actionName != null;
        });

        var emitter = void 0;
        switch (eventType) {
          case "madlib":
            emitter = _this6;
            break;
          case "component":
            emitter = _this6.containerByID[source].content;
            break;
          case "container":
            emitter = _this6.containerByID[source];
            break;
        }

        var getMacroValues = function getMacroValues(eventPayload) {
          var macroValues = {};
          Object.keys(eventMacros).forEach(function (key) {
            var macro = eventMacros[key];
            macroValues[macro] = eventPayload[key];
          });

          return macroValues;
        };

        var expandMacros = function expandMacros(macroValues, actionMacros) {
          var actionPayload = {};
          Object.keys(actionMacros).forEach(function (key) {
            var expansion = Object.keys(macroValues).reduce(function (s, macro) {
              // TODO(oscar): Tokenize macro better.
              s = s == null ? "" : s;
              var r = Object(__WEBPACK_IMPORTED_MODULE_1__frontendlib_utils__["escapeRegExp"])(macro);
              var sub = macroValues[macro] == null ? "" : String(macroValues[macro]);
              return s.replace(new RegExp(r, "g"), sub);
            }, actionMacros[key]);

            actionPayload[key] = expansion;
          });

          return actionPayload;
        };

        var processEventPayload = function processEventPayload(eventPayload, actionMacros) {
          return expandMacros(getMacroValues(eventPayload), actionMacros);
        };

        var dispatchActions = function dispatchActions() {
          var eventPayload = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

          // "Waterfall" the `.emit` Promises to process them serially.
          return actors.reduce(function (promise, _ref8) {
            var actionName = _ref8.actionName,
                actor = _ref8.actor,
                actionMacros = _ref8.actionMacros;

            var data = processEventPayload(eventPayload, actionMacros);
            return promise.then(function () {
              return actor.emit(actionName, data);
            });
          }, Promise.resolve()).catch(function (e) {
            return _this6.error(e);
          });
        };

        emitter.on(eventName, dispatchActions);
      });
    }

    // Setup click listeners.

  }, {
    key: "configureClickTargets",
    value: function configureClickTargets(clickTargets) {
      var _this7 = this;

      if (clickTargets.length > 0) {
        clickTargets.forEach(function (id) {
          __WEBPACK_IMPORTED_MODULE_3__lib_click_interaction__["a" /* default */].addListeners(_this7.containerByID[id].el, function (e) {
            _this7.handleNavigationClick(e);
          });
        });
      }
      // tre HTML endcards have their own way of handling click events.
      else if (!window.Liftoff.env.is_tre || !window.TreSensa) {
          this.clickEl.classList.add("active");
        }
    }
  }]);

  return Madlib;
}();

Madlib.init();

Madlib.ClickInteraction = __WEBPACK_IMPORTED_MODULE_3__lib_click_interaction__["a" /* default */];

window.Madlib = Madlib;

/* harmony default export */ __webpack_exports__["default"] = (Madlib);

/***/ }),
/* 67 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__frontendlib_dom_utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__frontendlib_utils__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__frontendlib_event_listener__ = __webpack_require__(11);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var EDGE_TO_TYPE = {
  left: "leading",
  right: "trailing",
  top: "leading",
  bottom: "trailing"
};
var EDGE_TO_DIMENSION = {
  left: "width",
  right: "width",
  top: "height",
  bottom: "height"
};

// We currently require CTA containers to be prefixed with "CTA", but we're
// more liberal here to support some legacy templates.
var ctaContainerRegex = /\bcta\b/i;
var isCTAContainer = function isCTAContainer(containerID) {
  return ctaContainerRegex.test(containerID);
};

var Container = function (_EventListener) {
  _inherits(Container, _EventListener);

  _createClass(Container, null, [{
    key: "getEvents",
    value: function getEvents() {
      return [{ name: "beforeLayout", system: true }, { name: "onClick" }].map(function (e) {
        e.type = "container";
        return e;
      });
    }
  }, {
    key: "getActions",
    value: function getActions() {
      return [{ name: "show" }, { name: "hide" }].map(function (a) {
        a.type = "container";
        return a;
      });
    }

    /** @param {HTMLDivElement} el - The container element. */

  }]);

  function Container(el) {
    var id = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";

    _classCallCheck(this, Container);

    var _this = _possibleConstructorReturn(this, (Container.__proto__ || Object.getPrototypeOf(Container)).call(this));

    _this.el = el;
    _this.el.classList.add("madlib-container");
    if (isCTAContainer(id)) {
      // We tag CTA containers to help us detect when clicks occur on CTAs.
      _this.el.classList.add("cta-container");
    }
    // `parent` and `children` refer to other Containers.
    _this.parent = null;
    _this.children = [];

    _this.fixedWidth = false;
    _this.fixedHeight = false;

    _this.css = null;
    _this.constraints = null;
    _this.anchors = [];
    _this.content = null;

    _this.layoutReady = null;
    _this.contentReady = null;
    _this.hidden = false;

    _this.postLayoutTransform = null;

    _this.addEventListeners();
    _this.coordinate();
    return _this;
  }

  _createClass(Container, [{
    key: "addEventListeners",
    value: function addEventListeners() {
      var _this2 = this;

      this.el.addEventListener("click", function () {
        return _this2.emit("onClick");
      });
    }
  }, {
    key: "coordinate",
    value: function coordinate() {
      var _this3 = this;

      this.on({
        hide: function hide() {
          Object.assign(_this3.el.style, {
            pointerEvents: "none",
            visibility: "hidden"
          });
        },
        show: function show() {
          Object.assign(_this3.el.style, {
            pointerEvents: _this3.css && _this3.css["pointer-events"] || "auto",
            visibility: _this3.css && _this3.css.visibility || "visible"
          });
        }
      });
    }
  }, {
    key: "loadContent",
    value: function loadContent() {
      if (this.contentReady == null) {
        var promises = this.children.map(function (child) {
          return child.loadContent();
        });
        if (this.content != null) {
          promises.push(this.content.load());
        }

        this.contentReady = Promise.all(promises);
      }

      return this.contentReady;
    }
  }, {
    key: "layout",
    value: function layout() {
      var _this4 = this;

      if (this.layoutReady == null) {
        // NOTE(oscar): beforeLayout should probably only trigger at most once per
        // container.
        this.emit("beforeLayout");
      }
      if (this.layoutReady == null) {
        if (this.el.parentNode !== this.parent.el) {
          this.parent.el.appendChild(this.el);
        }

        if (this.constraints != null) {
          if (this.constraints.left != null && this.constraints.right != null || this.constraints.width != null) {
            this.fixedWidth = true;
          }

          if (this.constraints.top != null && this.constraints.bottom != null || this.constraints.height != null) {
            this.fixedHeight = true;
          }
        }

        // The child components do not layout properly if a transform is active.
        // So, let's reset the transform before we proceed, then apply it later.
        this.resetTransform();

        this.style();
        this.position();
        this.layoutReady = this.loadContent().then(function () {
          return _this4.anchor();
        }).then(function () {
          return _this4.match();
        }).then(function () {
          return _this4.layoutContent();
        }).then(function () {
          return _this4.center();
        }).then(function () {
          return _this4.applyTransform();
        });
      }

      return this.layoutReady;
    }
  }, {
    key: "style",
    value: function style() {
      // The zIndex creates a stacking context for the contents of the container
      // element so that they don't interfere with other containers.
      Object.assign(this.el.style, { zIndex: 1 }, this.css);
    }
  }, {
    key: "position",
    value: function position() {
      var _this5 = this;

      if (this.constraints == null) return;
      var styles = { position: "absolute" };
      ["top", "bottom", "left", "right", "width", "height"].forEach(function (prop) {
        var value = _this5.constraints[prop];
        if (value != null && Object(__WEBPACK_IMPORTED_MODULE_1__frontendlib_utils__["type"])(value) !== "object") {
          styles[prop] = value;
        }
      });
      Object.assign(this.el.style, styles);
    }
  }, {
    key: "resetTransform",
    value: function resetTransform() {
      if (this.postLayoutTransform != null) {
        this.el.style.transform = "none";
      }
    }
  }, {
    key: "applyTransform",
    value: function applyTransform() {
      if (this.postLayoutTransform != null) {
        this.el.style.transform = this.postLayoutTransform;
      }
    }
  }, {
    key: "anchor",
    value: function anchor() {
      var _this6 = this;

      var pRect = void 0;
      var promises = this.anchors.map(function (_ref) {
        var containerEdge = _ref.edge,
            anchor = _ref.anchor;
        var _constraints$containe = _this6.constraints[containerEdge],
            distance = _constraints$containe.distance,
            anchorEdge = _constraints$containe.edge;

        var containerEdgeType = EDGE_TO_TYPE[containerEdge];
        var anchorEdgeType = EDGE_TO_TYPE[anchorEdge];
        var dimension = EDGE_TO_DIMENSION[containerEdge];
        // Block positioning until the anchor is ready.
        return anchor.layout().then(function () {
          if (pRect == null) {
            pRect = _this6.parent.el.getBoundingClientRect();
          }

          var rect = Object(__WEBPACK_IMPORTED_MODULE_0__frontendlib_dom_utils__["getRelativeBoundingClientRect"])(anchor.el);
          var offset = void 0;
          switch (containerEdgeType + " " + anchorEdgeType) {
            case "leading leading":
              offset = rect[anchorEdge];
              break;
            case "trailing trailing":
              offset = -rect[anchorEdge];
              break;
            case "leading trailing":
              offset = pRect[dimension] + rect[anchorEdge];
              break;
            case "trailing leading":
              offset = pRect[dimension] - rect[anchorEdge];
              break;
          }

          var _parseCSSLength = Object(__WEBPACK_IMPORTED_MODULE_0__frontendlib_dom_utils__["parseCSSLength"])(distance),
              value = _parseCSSLength.value,
              units = _parseCSSLength.units;

          switch (units) {
            case "px":
              offset += value;
              break;
            case "%":
              offset += pRect[dimension] * value / 100;
              break;
          }

          _this6.el.style[containerEdge] = offset + "px";
        });
      });
      return Promise.all(promises);
    }
  }, {
    key: "match",
    value: function match() {
      if (this.constraints == null || !(this.constraints.matchWidthToHeight || this.constraints.matchHeightToWidth)) {
        return;
      }

      var _el$getBoundingClient = this.el.getBoundingClientRect(),
          width = _el$getBoundingClient.width,
          height = _el$getBoundingClient.height;

      if (this.constraints.matchWidthToHeight) {
        this.el.style.width = height + "px";
      } else if (this.constraints.matchHeightToWidth) {
        this.el.style.height = width + "px";
      }
    }
  }, {
    key: "layoutContent",
    value: function layoutContent() {
      var _this7 = this;

      if (this.invalidated) return;

      var promises = this.children.map(function (child) {
        return child.layout();
      });
      if (this.content != null) {
        promises.push(this.content.layout(this.el));
      }

      return Promise.all(promises).then(function () {
        // For containers that serve as wrappers for other containers (i.e. do not
        // have content), calculate the aggregate bounding rectangle for all
        // children and resize the container to match the rectangle. This allows
        // centering to work properly.
        if (_this7.content != null || _this7.fixedWidth && _this7.fixedHeight) return;
        var rect = Object(__WEBPACK_IMPORTED_MODULE_0__frontendlib_dom_utils__["getAggregateBoundingClientRect"])(_this7.children.map(function (child) {
          return child.el;
        }));
        var style = {};
        if (!_this7.fixedWidth) {
          style.width = rect.width + "px";
        }

        if (!_this7.fixedHeight) {
          style.height = rect.height + "px";
        }

        Object.assign(_this7.el.style, style);
      });
    }
  }, {
    key: "center",
    value: function center() {
      if (this.constraints == null || !(this.constraints.centerHorizontal || this.constraints.centerVertical)) {
        return;
      }

      var pRect = this.parent.el.getBoundingClientRect();
      var rect = this.el.getBoundingClientRect();
      if (this.constraints.centerHorizontal) {
        this.el.style.left = (pRect.width - rect.width) / 2 + "px";
      }

      if (this.constraints.centerVertical) {
        this.el.style.top = (pRect.height - rect.height) / 2 + "px";
      }
    }
  }, {
    key: "invalidate",
    value: function invalidate() {
      this.invalidated = true;

      // NOTE(vsingh):
      // The following is a hack on top of a hack. We invalidate containers when
      // resetting layout, so that any asynchronous process kicked off
      // by those containers will have no further effect.
      // Unfortunately the invalidation hack has holes: there are still
      // cases where side effects are applied to the DOM element
      // associated with the container. Therefore, dissociate the
      // container and the DOM element immediately upon container
      // invalidation.
      this.el = document.createElement("div");
    }
  }]);

  return Container;
}(__WEBPACK_IMPORTED_MODULE_2__frontendlib_event_listener__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (Container);

/***/ }),
/* 68 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__frontendlib_dom_utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__frontendlib_utils__ = __webpack_require__(0);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }




var TEMPLATE = "<div class=\"last-chance-endscreen\">\n  <svg class=\"back-cta-icon hidden\" width=\"24px\" height=\"24px\" fill=\"white\">\n    <path d=\"M12 17.414 3.293 8.707l1.414-1.414L12 14.586l7.293-7.293 1.414 1.414L12 17.414z\"/>\n  </svg>\n  <div class=\"last-chance-endscreen-container\">\n    <div class=\"inner-container hidden\">\n      <img class=\"last-chance-logo\" />\n      <div class=\"icon-container\"></div>\n      <div class=\"caption\"></div>\n      <a class=\"liftoff-link liftoff-cta\">\n        <img />\n        <div class=\"common-cta\"></div>\n      </a>\n    </div>\n  </div>\n</div>";

/**
 * @typedef AppStoreData
 * @property {string} icon - application icon.
 * @property {string} name - application name.
 * @property {string} company - application company/developer.
 * @property {number} rating - application rating on Google Play store.
 * @property {number} rating_count - number of times the app has been rated on
 * the Google Play store.
 * @property {string | number} download_count - number of times the app has been
 * downloaded from the Google Play store.
 * @property {string} content_rating - app content rating on the Google Play
 * store.
 * @property {string} screenshots - screenshots available for the app.
 * @property {string} description - app description.
 */

/**
 * Creates a Liftoff Last Chance Endscreen component which is displayed to the
 * user as an overlay HTML endscreen.
 *
 * @see https://docs.google.com/presentation/d/15EUBJUVXP2DpFbkA3hB0yE8z-iEy6C1I5tlZ-1h-jBw/edit?usp=sharing
 */

var LastChanceEndscreen = function () {
  /**
   *
   * @param {AppStoreData} appStoreData
   * @param {Object} parentEl
   * @param {function} handleClick
   * @param {boolean} validateUserClick - if true then CTA is only triggered if
   * click is invoked by the user and not programmatically.
   * @param {Object} env
   */
  function LastChanceEndscreen(appStoreData, parentEl, handleClick) {
    var validateUserClick = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
    var env = arguments[4];

    _classCallCheck(this, LastChanceEndscreen);

    this.appStoreData = appStoreData;
    this.parentEl = parentEl;
    this.el = __WEBPACK_IMPORTED_MODULE_0__frontendlib_dom_utils__["strToElement"](TEMPLATE);
    this.handleClick = handleClick;
    this.validateUserClick = validateUserClick;
    this.env = env;
    this.ctaText = env.cta_text || "INSTALL";
    this.autoEndCardCallCount = 0;
    this.timeout = null;

    if (this.parentEl == null) {
      console.error("Last chance endscreen was created without a parent container");
    }
    // Load app icon when the Liftoff Last Chance Endscreen instance is created.
    this.images = this.loadImages([this.appStoreData.icon]);
  }

  _createClass(LastChanceEndscreen, [{
    key: "loadImages",
    value: function loadImages(imagePaths) {
      return __WEBPACK_IMPORTED_MODULE_1__frontendlib_utils__["loadImages"](imagePaths);
    }
  }, {
    key: "prepareAutoEndcard",
    value: function prepareAutoEndcard() {
      var _this = this;

      this.el.querySelector(".caption").innerHTML = this.appStoreData.name;
      this.el.querySelector(".common-cta").innerHTML = this.ctaText.toUpperCase();
      // Show all elements in the LO last chance endscreen after app icon is
      // loaded on the browser.
      this.images.then(function (values) {
        values.forEach(function (img) {
          img.classList.add("icon");
          _this.el.querySelector(".icon-container").appendChild(img);
        });
      }).catch(function (error) {
        console.error("Error while rendering app icon: " + error.message);
      }).finally(function () {
        // This will run on success or error.
        _this.el.querySelector(".inner-container").classList.remove("hidden");
      });

      this.parentEl.appendChild(this.el);
    }
  }, {
    key: "showAutoEndcard",
    value: function showAutoEndcard() {
      if (this.env.has_html_endscreen) {
        if (this.env.platform) {
          // For adding iOS/Android specific styles on the AutoEndcard
          this.el.closest("#liftoff-snippet").classList.add(this.env.platform);
        }

        this.el.querySelector(".back-cta-icon").classList.remove("hidden");
        this.el.classList.add("rolling-up-animation");
      }
    }
  }, {
    key: "initAutoEndcard",
    value: function initAutoEndcard() {
      if (this.wasShown) return;
      this.wasShown = true;
      this.prepareAutoEndcard();
      this.showAutoEndcard();
      this.initializeEvents();
    }
  }, {
    key: "initializeEvents",
    value: function initializeEvents() {
      var _this2 = this;

      var touchstart = 0;

      // Fire CTA if user clicks anywhere on the screen.
      this.el.addEventListener("click", function (e) {
        if (!e.target.closest(".back-cta-icon")) {
          var triggerCTA = _this2.validateUserClick ? e.isTrusted : true;
          if (triggerCTA) {
            _this2.handleClick(!_this2.useInteractionMonitor ? e : _this2._lastInteraction);
          }
        }
      });

      this.el.querySelector(".back-cta-icon").addEventListener("click", function () {
        _this2.el.classList.add("rolling-down-animation");
      });

      this.el.addEventListener("touchstart", function (e) {
        touchstart = e.changedTouches[0].screenY;
      });

      this.el.addEventListener("touchend", function (e) {
        // Adding 70px buffer to avoid accidental taps on screen
        if (e.changedTouches[0].screenY > touchstart + 70) {
          _this2.el.classList.add("rolling-down-animation");
        }
      });
    }
  }]);

  return LastChanceEndscreen;
}();

/* harmony default export */ __webpack_exports__["a"] = (LastChanceEndscreen);

/***/ }),
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(136);
module.exports = __webpack_require__(140);


/***/ }),
/* 136 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__component__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__creative_utils__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__click_handling__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__liftoff_mraid__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__interaction_monitor__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__letterbox_config__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__logger__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__window_resize_logger__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__constants__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__frontendlib_dom_utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__frontendlib_utils__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__cta__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__adexp__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__autoclick_Autoclick__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__madlib__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__lib_last_chance_endscreen_last_chance_endscreen__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__csp_env_messages__ = __webpack_require__(22);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }



















/**
 * NOTE(oscar): After 3 seconds, log what mraid methods/events have been
 * supported. This should be right before users typically close the ad
 * which should give enough time to check what events have triggered or
 * methods used.
 */
var logMraidSupport = function logMraidSupport() {
  setTimeout(function () {
    __WEBPACK_IMPORTED_MODULE_6__logger__["a" /* default */].recordLog("mraid",
    // TODO(oscar): Use the data param once adexp logs can save it.
    JSON.stringify(Object.assign({
      tag: "mraidSupport"
    }, __WEBPACK_IMPORTED_MODULE_3__liftoff_mraid__["a" /* default */].getSupportedLog())));
  }, 3000);
};

/**
 * Function used to handle auto-endcard interaction event from TreSensa
 * creatives made from the "tresensa-snippet" Madlib component.
 * @param {*} e
 * @param {*} autoEndcard
 * @param {*} lastChanceEndscreenAutoclick
 * @param {*} lastChanceEndscreenInteractionAutoclick
 * TODO(luis): We need to integrate TreSensa interaction events with the
 * InteractionMonitor class.
 */
var onTreSensaInteraction = function onTreSensaInteraction(e, autoEndcard, lastChanceEndscreenAutoclick, lastChanceEndscreenInteractionAutoclick, vxInteractionListeners) {
  if (e.data === __WEBPACK_IMPORTED_MODULE_16__csp_env_messages__["m" /* MESSAGE_TRESENSA_INTERACTION */]) {
    if (lastChanceEndscreenAutoclick) {
      lastChanceEndscreenAutoclick.disable();
    }
    // TODO(Luis): This is a temporary fix to handle the case where the
    // interaction event is triggered from a TreSensa wrapped 3p.
    // Eventually this needs to be deleted and updated so that a
    // tre_interaction event does trigger a global interaction that can be
    // detected by the AutoClick interaction behaviour.
    if (autoEndcard && lastChanceEndscreenInteractionAutoclick && lastChanceEndscreenInteractionAutoclick._behavior && lastChanceEndscreenInteractionAutoclick._behavior.delay) {
      // Display auto-endcard after a delay on interaction.
      setTimeout(function () {
        autoEndcard.initAutoEndcard();
      }, lastChanceEndscreenInteractionAutoclick._behavior.delay);
    }

    // NOTE(Sangeeth): The onTreSensaInteraction handler is only called for
    // tresensa client wrapped playables. These playables run inside an iframe
    // so we can't detect interaction events for them through the interaction
    // monitor.
    vxInteractionListeners.forEach(function (cb) {
      return cb();
    });
  }
};

var Liftoff = function () {
  function Liftoff() {
    _classCallCheck(this, Liftoff);
  }

  _createClass(Liftoff, null, [{
    key: "init",
    value: function init(env, assets) {
      var _this = this;

      var trackingTags = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];

      try {
        /** TODO(oscar): Consider logging MRAID support for CSP creatives. */
        logMraidSupport();

        if (trackingTags != null) {
          __WEBPACK_IMPORTED_MODULE_3__liftoff_mraid__["a" /* default */].onViewable(function () {
            var trackingTagHolder = document.getElementById("tracking-tag-holder");
            __WEBPACK_IMPORTED_MODULE_9__frontendlib_dom_utils__["appendImpressionTags"](trackingTagHolder, trackingTags);
          });
        }

        this.env = env;
        this.populateAppStoreData();
        // The bid context is often used, giving it an alias saves characters and lines of this JS.
        this.bidContext = env.bid_context;
        this.assets = assets;
        this.testGroups = {};
        this.bidContext.ab_tests.forEach(function (group) {
          _this.testGroups[group] = true;
        });
        this.lastClickMetric = null;
        this.resetClickParams();
        this.interactionMonitor = new __WEBPACK_IMPORTED_MODULE_4__interaction_monitor__["a" /* InteractionMonitor */]();
        this.vxInteractionListeners = [];
        this.interactionMonitor.onInteractionChange(function (e) {
          _this.vxInteractionListeners.forEach(function (cb) {
            return cb(e);
          });
          _this._autoclickBus.forEach(function (ac) {
            return ac.emitInteractionEvent(e);
          });
        });

        this.snippetEl = null;
        this.updateMRAID();
        this.loadDOM();
        this.loadLogger();
        this.initAutoclickBehaviors();
        __WEBPACK_IMPORTED_MODULE_6__logger__["a" /* default */].recordMetricV2("initial_load_count", 1);
        this.applyPolicy();
        this.windowResizeLogger = new __WEBPACK_IMPORTED_MODULE_7__window_resize_logger__["a" /* default */](this.snippetEl, this.env.enable_logging);
        this.addEventListeners();
        this.madlibLoaded = false;
        this.useAutoendcardBehaviour = null;

        __WEBPACK_IMPORTED_MODULE_3__liftoff_mraid__["a" /* default */].on("error", function (e) {
          return __WEBPACK_IMPORTED_MODULE_6__logger__["a" /* default */].recordError(e);
        });
      } catch (e) {
        __WEBPACK_IMPORTED_MODULE_6__logger__["a" /* default */].recordError(e);
      }
    }
  }, {
    key: "populateAppStoreData",
    value: function populateAppStoreData() {
      if (!this.env.app_store_data) {
        try {
          if (window.parent.VungleHelper) {
            var tokens = window.parent.VungleHelper.tokens;
            if (tokens) {
              this.env.app_store_data = {
                icon: tokens.APP_ICON,
                name: tokens.APP_NAME,
                description: tokens.APP_DESCRIPTION,
                rating: tokens.APP_STORE_RATING
              };
            }
          }
        } catch (error) {
          console.error("Error occurred:", error.message);
        }
      }
    }
  }, {
    key: "initAutoclickBehaviors",
    value: function initAutoclickBehaviors() {
      var _this2 = this;

      this._autoclickBus = [];
      __WEBPACK_IMPORTED_MODULE_3__liftoff_mraid__["a" /* default */].on("clickMethodTried", function (_ref) {
        var clickOpenMethod = _ref.clickOpenMethod,
            isAutoclick = _ref.isAutoclick;

        if (isAutoclick && clickOpenMethod === __WEBPACK_IMPORTED_MODULE_8__constants__["t" /* CLICK_OPEN_METHOD_MRAID */]) {
          __WEBPACK_IMPORTED_MODULE_6__logger__["a" /* default */].recordMetricV2("mraid_autoclick_fired_ms", Date.now() - LIFTOFF_START_TS);
        }
      });

      this._viewclick = new __WEBPACK_IMPORTED_MODULE_13__autoclick_Autoclick__["a" /* default */](this.bidContext.viewclick_behavior, {
        clickthroughHandler: function clickthroughHandler(lastEvent) {
          return _this2.handleClick({
            mac: 1
          }, Object(__WEBPACK_IMPORTED_MODULE_11__cta__["a" /* clickAreaTypeFromEvent */])({
            clientX: lastEvent == null ? null : lastEvent.lastInteraction.startX,
            clientY: lastEvent == null ? null : lastEvent.lastInteraction.startY
          }));
        }
      });
      this._autoclickBus.push(this._viewclick);

      // We store app store data in this variable for reusability.
      var appStoreData = this.env.app_store_data;

      var autoEndcard = void 0;
      // Only initialize autoEndcard if there is app store data in the bid context.
      if (appStoreData) {
        autoEndcard = new __WEBPACK_IMPORTED_MODULE_15__lib_last_chance_endscreen_last_chance_endscreen__["a" /* default */](appStoreData, this.snippetEl, function (e) {
          __WEBPACK_IMPORTED_MODULE_14__madlib__["default"].handleNavigationClick(e, {
            ae: 1
          });
        }, this.bidContext.exchange === "inmobi", this.env);
      }

      this.useAutoendcardBehaviour = this.bidContext.last_chance_endscreen_autoclick_behavior;

      // If exchange is mintegral then only display the auto endcard on delay if
      // platform is ios.
      if (this.useAutoendcardBehaviour && (this.bidContext.exchange != "mintegral" || this.bidContext.platform === "ios")) {
        this._lastChanceEndscreenAutoclick = new __WEBPACK_IMPORTED_MODULE_13__autoclick_Autoclick__["a" /* default */](this.useAutoendcardBehaviour, {
          clickthroughHandler: function clickthroughHandler() {
            if (autoEndcard) {
              autoEndcard.initAutoEndcard();
            }
          }
        });
        this._autoclickBus.push(this._lastChanceEndscreenAutoclick);
      }

      this._lastChanceEndscreenInteractionAutoclick = new __WEBPACK_IMPORTED_MODULE_13__autoclick_Autoclick__["a" /* default */](this.bidContext.last_chance_endscreen_interaction_autoclick_behavior, {
        clickthroughHandler: function clickthroughHandler() {
          if (autoEndcard) {
            autoEndcard.initAutoEndcard();
          }
        }
      });
      this._autoclickBus.push(this._lastChanceEndscreenInteractionAutoclick);
      /**
       * Handle cases where the interaction event is triggered from the
       * "tresensa-snippet" Madlib component.
       */
      window.addEventListener("message", function (e) {
        onTreSensaInteraction(e, autoEndcard, _this2._lastChanceEndscreenAutoclick, _this2._lastChanceEndscreenInteractionAutoclick, _this2.vxInteractionListeners);
      }, true);
    }
  }, {
    key: "setInteractionPromptReached",
    value: function setInteractionPromptReached(e) {
      this._autoclickBus.forEach(function (ac) {
        return ac.emitInteractionPromptReachedEvent(e);
      });
    }
  }, {
    key: "getAnimationDurationLimit",
    value: function getAnimationDurationLimit() {
      return this.env.creative_policy.animation_duration_limit;
    }
  }, {
    key: "handleMadlibError",
    value: function handleMadlibError(e) {
      __WEBPACK_IMPORTED_MODULE_6__logger__["a" /* default */].recordError(e);
    }
  }, {
    key: "hasTestGroup",
    value: function hasTestGroup(group) {
      return !!this.testGroups[group];
    }
  }, {
    key: "isExchange",
    value: function isExchange(exchange) {
      return this.bidContext.exchange.toLowerCase() === exchange.toLowerCase();
    }
  }, {
    key: "updateMRAID",
    value: function updateMRAID() {
      if (this.bidContext.is_interstitial) {
        var _bidContext = this.bidContext,
            width = _bidContext.width,
            height = _bidContext.height;

        __WEBPACK_IMPORTED_MODULE_3__liftoff_mraid__["a" /* default */].lockOrientation(width < height ? "portrait" : "landscape");
      }
    }
  }, {
    key: "loadLogger",
    value: function loadLogger() {
      var _env = this.env,
          enableLogging = _env.enable_logging,
          enableHtmlReturn = _env.enable_html_return,
          endpoint = _env.logging_endpoint,
          trackingParam = _env.event_tracking_param,
          delay = _env.html_return_delay;


      __WEBPACK_IMPORTED_MODULE_6__logger__["a" /* default */].passContext(endpoint, trackingParam, Object(__WEBPACK_IMPORTED_MODULE_12__adexp__["e" /* getAdexpContextSnapshotFn */])(this.snippetEl, function () {
        return __WEBPACK_IMPORTED_MODULE_3__liftoff_mraid__["a" /* default */].hasSupport("mraid");
      }));

      if (!enableLogging) {
        return;
      }

      __WEBPACK_IMPORTED_MODULE_6__logger__["a" /* default */].enable();
      __WEBPACK_IMPORTED_MODULE_6__logger__["a" /* default */].addErrorListeners();

      if (!enableHtmlReturn) {
        return;
      }
      __WEBPACK_IMPORTED_MODULE_1__creative_utils__["b" /* configureHTMLReturn */](endpoint, delay);
    }
  }, {
    key: "loadDOM",
    value: function loadDOM() {
      var _snippetEl$classList;

      this.snippetEl = document.createElement("div");
      this.snippetEl.id = "liftoff-snippet";
      this.snippetEl.classList.add(this.bidContext.platform.toLowerCase());
      (_snippetEl$classList = this.snippetEl.classList).add.apply(_snippetEl$classList, _toConsumableArray(this.bidContext.ab_tests));
      document.body.appendChild(this.snippetEl);
      // TreSensa endcards using the adcontainer.js library rely on the
      // "tre_container" div being present.
      if (this.env.is_tre) {
        this.treContainerEl = document.createElement("div");
        this.treContainerEl.id = "tre_container";
        this.treContainerEl.zIndex = 2;
        this.snippetEl.appendChild(this.treContainerEl);
      }
    }

    /**
     * A creative policy is a collection of special requirements the creative must comply with. These tend
     * to be country and/or exchange specific.
     * Creative policies are set in admarkup/core.
     * @param {Object} policy - A series of requirements.
     * @param {boolean} policy.add_border - Adds a border around the creative.
     * @param {string} policy.russian_age_rating - Shows age rating watermark.
     * @param {number} policy.animation_duration_limit - Stops all animation after a set time.
     * @param {boolean} policy.show_chinese_watermark - Shows Chinese watermark.
     * @param {boolean} policy.show_ad_choices - Shows the AdChoices watermark.
     * @param {boolean} policy.block_notifications - Blocks notification icons from appearing on chat banners.
     * @param {boolean} policy.block_strobing - Keeps strobing/blinking animations from happening.
     * @param {boolean} policy.use_custom_close - True iff we should use a custom close button for this
     *                                            impression.
     * @param {number} policy.close_delay - Overrides any previously set close delay duration.
     */

  }, {
    key: "applyPolicy",
    value: function applyPolicy() {
      var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.env.creative_policy,
          add_border = _ref2.add_border,
          russian_age_rating = _ref2.russian_age_rating,
          show_chinese_watermark = _ref2.show_chinese_watermark,
          show_ad_choices = _ref2.show_ad_choices,
          use_custom_close = _ref2.use_custom_close,
          close_delay = _ref2.close_delay;

      var bidContext = this.bidContext;
      __WEBPACK_IMPORTED_MODULE_1__creative_utils__["a" /* applyLiftoffPolicy */](this.snippetEl, {
        addBorder: add_border,
        showAdChoices: show_ad_choices,
        russianAgeRating: russian_age_rating,
        showChineseWatermark: show_chinese_watermark,
        useCustomClose: use_custom_close,
        closeDelay: close_delay,
        // NOTE(Casey): `applyLiftoffPolicy` globally modifies audio output of the entire creative. Currently,
        // madlib creatives do not use these global controls -- we depend on components to directly check
        // the audio policy before making sound. We therefore set `audioPolicy` here to `NO_RESTRICTION` to
        // disable the global controls.
        // TODO(Casey): Update this if we decide to use global controls for madlib creatives in the future.
        audioPolicy: __WEBPACK_IMPORTED_MODULE_8__constants__["b" /* AUDIO_POLICY_NO_RESTRICTIONS */]
      }, {
        creativeID: bidContext.creative_id,
        platform: bidContext.platform,
        exchange: bidContext.exchange.toLowerCase(),
        sourceAppName: bidContext.source_app_name,
        sourceAppID: bidContext.source_app_id,
        cdnURL: bidContext.cdnURL
      });
    }
  }, {
    key: "onMadlibLoaded",
    value: function onMadlibLoaded() {
      this.madlibLoaded = true;
    }
  }, {
    key: "resetClickParams",
    value: function resetClickParams() {
      this.clickParams = {};
    }
  }, {
    key: "mergeClickParams",
    value: function mergeClickParams(params) {
      Object.assign(this.clickParams, params);
    }
  }, {
    key: "getClickParams",
    value: function getClickParams() {
      return this.clickParams;
    }

    /** Handles clickthrough/CTA clicks. */

  }, {
    key: "handleClick",
    value: function handleClick() {
      var queryParams = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var clickAreaType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

      /**
       * NOTE(oscar): To prevent aggressive behavior, we disable autoclick the
       * first time the store page is opened regardless of how.
       * mac=1 means there will be no UX change.
       */
      if (this._lastChanceEndscreenAutoclick && !queryParams.mac) {
        this._lastChanceEndscreenAutoclick.disable();
      }
      // NOTE(oscar): pv=1 clicks should mean the MMP is not sent a click.
      if (!queryParams.pv) {
        this._viewclick.disable();
      }

      var clickTrackingParams = __WEBPACK_IMPORTED_MODULE_2__click_handling__["a" /* getClickTrackingQueryParams */](this.interactionMonitor.getAllInteractionData());

      var allQueryParams = Object.assign({
        cbl: this.madlibLoaded ? 0 : 1
      }, this.getClickParams(), clickTrackingParams, queryParams);

      if (clickAreaType != null) {
        allQueryParams.ca = clickAreaType;
      }

      var bidContext = this.bidContext,
          clickConfig = this.env.click_config;

      __WEBPACK_IMPORTED_MODULE_2__click_handling__["b" /* handleClick */]({
        clickConfig: {
          clickthroughURL: clickConfig.clickthrough_url,
          clickTrackingURLs: clickConfig.click_tracking_urls
        },
        queryParams: allQueryParams,
        isReengagement: bidContext.is_reengagement,
        platform: bidContext.platform,
        exchange: bidContext.exchange,
        abTests: bidContext.ab_tests
      });
    }
  }, {
    key: "onClickCapture",
    value: function onClickCapture(e) {
      var _this3 = this;

      // An array of EventTarget objects, some of which may be instances of Element.
      var path = e.composedPath && e.composedPath() || e.path;
      if (path == null) {
        return;
      }

      var foundSnippet = path.some(function (el) {
        return el === _this3.snippetEl;
      });
      if (!foundSnippet) {
        return;
      }

      var rect = this.snippetEl.getBoundingClientRect();
      var clickMetric = {
        x: Math.round(e.pageX - rect.left),
        y: Math.round(e.pageY - rect.top),
        time_ms: Date.now() - LIFTOFF_START_TS,
        // NOTE(vsingh): The click type below must be one of AdexpMetric.ClickType.
        type: __WEBPACK_IMPORTED_MODULE_8__constants__["q" /* CLICK_METRIC_TYPE_UNKNOWN */]
      };

      // Helper function that returns true if some Elements in `path` satisfy the condition `pred`.
      var someElements = function someElements(pred) {
        return path.some(function (eventtarget) {
          return eventtarget instanceof Element && pred(eventtarget);
        });
      };

      if (someElements(function (el) {
        return el.classList.contains("liftoff-close-target");
      })) {
        clickMetric.type = __WEBPACK_IMPORTED_MODULE_8__constants__["n" /* CLICK_METRIC_TYPE_CLOSE */];
      } else if (Object(__WEBPACK_IMPORTED_MODULE_11__cta__["c" /* pointInCTA */])(e.clientX, e.clientY)) {
        clickMetric.type = __WEBPACK_IMPORTED_MODULE_8__constants__["o" /* CLICK_METRIC_TYPE_CTA */];
      } else if (someElements(function (el) {
        return el.classList.contains("liftoff-deadzone");
      })) {
        clickMetric.type = __WEBPACK_IMPORTED_MODULE_8__constants__["p" /* CLICK_METRIC_TYPE_DEADZONE */];
      } else if (someElements(function (el) {
        return el.id === "liftoff-close";
      })) {
        // NOTE(vsingh): Special/weird case: if we hit liftoff-close but not liftoff-close-target,
        // consider it a deadzone click. There are just a few pixels around the close button that
        // trigger this `if` clause.
        clickMetric.type = __WEBPACK_IMPORTED_MODULE_8__constants__["p" /* CLICK_METRIC_TYPE_DEADZONE */];
      }

      __WEBPACK_IMPORTED_MODULE_6__logger__["a" /* default */].recordMetricV2("click", clickMetric);
      this.lastClickMetric = clickMetric;
    }
  }, {
    key: "addEventListeners",
    value: function addEventListeners() {
      var _this4 = this;

      __WEBPACK_IMPORTED_MODULE_3__liftoff_mraid__["a" /* default */].onViewable(function () {
        __WEBPACK_IMPORTED_MODULE_6__logger__["a" /* default */].recordMetricV2("first_viewable_ms", Date.now() - LIFTOFF_START_TS);
      });
      __WEBPACK_IMPORTED_MODULE_3__liftoff_mraid__["a" /* default */].onViewable(function (e) {
        _this4._autoclickBus.forEach(function (ac) {
          return ac.emitViewableEvent(e);
        });
      }, true);
      __WEBPACK_IMPORTED_MODULE_3__liftoff_mraid__["a" /* default */].onViewableChange(function (e) {
        _this4._autoclickBus.forEach(function (ac) {
          return ac.emitViewableChangeEvent(e);
        });
      });

      window.addEventListener("click", function (e) {
        _this4.onClickCapture(e);
        if (_this4._lastChanceEndscreenAutoclick) {
          _this4._lastChanceEndscreenAutoclick.disable();
        }
      }, true);
    }
  }, {
    key: "onLoadCompleted",
    value: function onLoadCompleted() {
      // NOTE(oscar): We log the initial dimensions immediately in case no "resize" event triggers.
      this.windowResizeLogger.logInitialDims();
    }
  }, {
    key: "onFirstLayoutFinished",
    value: function onFirstLayoutFinished() {
      __WEBPACK_IMPORTED_MODULE_6__logger__["a" /* default */].recordMetricV2("load_time_ms", Date.now() - LIFTOFF_START_TS);
      this._autoclickBus.forEach(function (ac) {
        return ac.emitHtmlLoadedEvent();
      });
    }
  }, {
    key: "getLetterboxConfig",
    value: function getLetterboxConfig() {
      return new __WEBPACK_IMPORTED_MODULE_5__letterbox_config__["a" /* default */](this.snippetEl);
    }
  }, {
    key: "resolveAsset",
    value: function resolveAsset(assetType, assetID) {
      var asset = this.assets[assetType + "s"][assetID];
      if (asset == null) {
        throw new Error(assetType + ": " + assetID + " not found");
      }

      switch (assetType) {
        // NOTE(oscar): By default, we should assume only 1 asset URL per original will be passed to the markup.
        // Occasionally, we will test how we serve our assets, which may entail providing more than 1 version to
        // be selected here.

        // The common structure for an original asset is as follows:
        /**
         * {
         *  "id",
         *  "asset-versions": [{ "public-url", "version-id" }, ...]
         * }
         */
        case "image_original":
          return asset.image_versions[0]["public-url"];
        case "video_original":
          return asset.video_versions[0]["public-url"];
      }

      return asset.url;
    }

    /**
     * Enables exclusive format creatives to listen for Madlib interaction events.
     * Note: This method does not register interaction events for Madlib CSPs.
     */

  }, {
    key: "addVXInteractionEventListener",
    value: function addVXInteractionEventListener(cb) {
      this.vxInteractionListeners.push(cb);
    }
  }]);

  return Liftoff;
}();

Object.assign(Liftoff, {
  Component: __WEBPACK_IMPORTED_MODULE_0__component__["a" /* default */],
  DOMUtils: __WEBPACK_IMPORTED_MODULE_9__frontendlib_dom_utils__,
  LiftoffMRAID: __WEBPACK_IMPORTED_MODULE_3__liftoff_mraid__["a" /* default */],
  Logger: __WEBPACK_IMPORTED_MODULE_6__logger__["a" /* default */],
  Utils: __WEBPACK_IMPORTED_MODULE_10__frontendlib_utils__
});

window.Liftoff = Liftoff;

/***/ }),
/* 137 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__frontendlib_event_listener__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__logger__ = __webpack_require__(5);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var overrideMethods = {
  layout: true,
  load: true,
  resize: true,
  start: true,
  stop: true,
  restart: true
};

var Component = function (_EventListener) {
  _inherits(Component, _EventListener);

  _createClass(Component, null, [{
    key: "init",
    value: function init() {
      this.registry = {};
    }
  }, {
    key: "register",
    value: function register(name, cls) {
      if (this.registry[name] != null) {
        throw new Error("ComponentError: " + name + " already registered");
      }

      this.assertSubclassed(cls);
      this.registry[name] = cls;
    }
  }, {
    key: "new",
    value: function _new(name, config) {
      var cls = this.registry[name];
      if (cls == null) {
        throw new Error("ComponentError: component \"" + name + "\" not registered");
      }

      return new cls(config);
    }
  }, {
    key: "assertSubclassed",
    value: function assertSubclassed(cls) {
      var _this2 = this;

      var methods = Object.getOwnPropertyNames(this.prototype);
      methods.forEach(function (method) {
        if (overrideMethods[method] !== true) return;
        if (cls.prototype[method] === _this2.prototype[method]) {
          throw new Error("ComponentError: " + method + " must be overridden");
        }
      });
    }
  }]);

  function Component(config) {
    _classCallCheck(this, Component);

    var _this = _possibleConstructorReturn(this, (Component.__proto__ || Object.getPrototypeOf(Component)).call(this));

    _this.config = config;
    _this.on({
      start: function start() {
        return _this.start();
      },
      stop: function stop() {
        return _this.stop();
      },
      restart: function restart() {
        return _this.restart();
      }
    });
    return _this;
  }

  _createClass(Component, [{
    key: "error",
    value: function error(err) {
      this.emit("error", this.constructor.name + "Error: " + err);
    }

    // The layout method should prepare the component to take up a stable size and
    // position within the DOM.

  }, {
    key: "layout",
    value: function layout(parentNode) {
      this.parentNode = parentNode;
    }

    // The load method should load assets. This is intended to capture the time it
    // takes for the component to be fully visible (all images/videos loaded).

  }, {
    key: "load",
    value: function load() {}
  }, {
    key: "resize",
    value: function resize() {}
  }, {
    key: "start",
    value: function start() {}
  }, {
    key: "stop",
    value: function stop() {}
  }, {
    key: "restart",
    value: function restart() {}
  }, {
    key: "recordInteraction",
    value: function recordInteraction() {
      __WEBPACK_IMPORTED_MODULE_1__logger__["a" /* default */].recordMetricV2("interaction_count", 1);
    }
  }, {
    key: "recordInteractionPromptReached",
    value: function recordInteractionPromptReached() {
      __WEBPACK_IMPORTED_MODULE_1__logger__["a" /* default */].recordMetricV2("interaction_prompt_reached_count", 1);
      if (window.Liftoff != null && window.Liftoff.setInteractionPromptReached != null) {
        window.Liftoff.setInteractionPromptReached();
      }
    }
  }]);

  return Component;
}(__WEBPACK_IMPORTED_MODULE_0__frontendlib_event_listener__["a" /* default */]);

Component.init();

/* harmony default export */ __webpack_exports__["a"] = (Component);

/***/ }),
/* 138 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * This config is used for letterboxing Madlib creatives. It works by changing the size
 * of liftoff-layout element (specific to Madlib), and scale it within liftoff-snippet
 * (provided by Liftoff.js).
 *
 * Arguably the better way to implement letterboxing is by controlling the size of
 * liftoff-snippet element based on Madlib configuration (i.e. fixed size or
 * stretchable, in the future), for example, by displaying Madlib creative in
 * an iFrame. If iFrames do not involve performance penalty, it would be
 * preferable since it would be another step to unify Madlib and CSP creatives.
 */
var LetterboxConfig = function () {
  /**
   * @typedef {Object} Dimensions
   * @property {number} width - The width of the element.
   * @property {number} height - The height of the element.
   */

  /**
   * @typedef {Object} LetterboxConfigData
   * @property {Dimensions} viewportSize - The size of the viewport.
   * @property {Dimensions} bidCreativeSize - The size of the bid creative.
   * @property {boolean} enable - Indicates if the creative should be letterboxed.
   * @property {boolean} useDarkRootBackground - Indicates if the root element should use a dark background.
   * @property {boolean} useLayoutBackground - Indicates if the layout element should use its own light-colored background.
   */

  function LetterboxConfig(snippetEl) {
    _classCallCheck(this, LetterboxConfig);

    this.snippetEl = snippetEl;

    /** @type {LetterboxConfigData} */
    this.config = this.getLetterboxConfig();
  }

  _createClass(LetterboxConfig, [{
    key: "enabled",
    value: function enabled() {
      return this.config.enable;
    }
  }, {
    key: "useDarkRootBackground",
    value: function useDarkRootBackground() {
      return this.config.useDarkRootBackground;
    }
  }, {
    key: "useLayoutBackground",
    value: function useLayoutBackground() {
      return this.config.useLayoutBackground;
    }

    /**
     * Choose the appropriate config based on viewport dimensions.
     * If one orientation's config is missing, default to the other one.
     */

  }, {
    key: "getCreativePreferredOrientation",
    value: function getCreativePreferredOrientation(_ref) {
      var width = _ref.width,
          height = _ref.height;

      return width <= height ? "portrait" : "landscape";
    }

    /**
     * Analyze the viewport and make some decisions about how we will present our
     * creative content.
     * @returns {LetterboxConfigData}
     */

  }, {
    key: "getLetterboxConfig",
    value: function getLetterboxConfig() {
      var dims = function dims(obj) {
        return { width: obj.width, height: obj.height };
      };

      var viewportSize = dims(this.snippetEl.getBoundingClientRect());
      var bidCreativeSize = dims(Liftoff.bidContext);

      var viewportOrientation = viewportSize.width <= viewportSize.height ? "portrait" : "landscape";

      // We are trying to show a portrait creative in a landscape-size viewport, or a landscape creative
      // in a portrait-size viewport.
      var orientationMismatch = viewportOrientation !== this.getCreativePreferredOrientation(bidCreativeSize);

      var isRotated = Liftoff.bidContext.is_interstitial && orientationMismatch;

      var useWhiteBars = isRotated;
      var useDarkRootBackground = !useWhiteBars;
      var useLayoutBackground = useDarkRootBackground;
      var enable = useWhiteBars || isRotated;

      return {
        viewportSize: viewportSize,
        bidCreativeSize: bidCreativeSize,
        enable: enable,
        useDarkRootBackground: useDarkRootBackground,
        useLayoutBackground: useLayoutBackground
      };
    }

    // Returns the scaling factor necessary to scale `contentSize` up to `viewportSize`
    // whilst maintaining the aspect ratio of the content.

  }, {
    key: "preserveAspectRatioScalingFactor",
    value: function preserveAspectRatioScalingFactor(contentSize, viewportSize) {
      if (contentSize.height * viewportSize.width <= viewportSize.height * contentSize.width) {
        return viewportSize.width / contentSize.width;
      } else {
        return viewportSize.height / contentSize.height;
      }
    }

    // Given a letterbox config, returns information that is useful for laying out the various DOM elements.
    // Returns an object with the following keys:
    //   scaleFactor: the scale factor to be applied to the layout element
    //   rootContainerSize: the width and height in pixels of the layout element
    //   rootContainerOffset: the x and y coordinates in pixels of the layout element
    //   rootContainerTransformedArea: expected values in pixels for the x, y, width, and height of the root
    //     container after scale and rotation are applied

  }, {
    key: "getLetterboxLayoutInfo",
    value: function getLetterboxLayoutInfo() {
      var _config = this.config,
          viewportSize = _config.viewportSize,
          bidCreativeSize = _config.bidCreativeSize;


      var scaleFactor = this.preserveAspectRatioScalingFactor(bidCreativeSize, viewportSize);
      var rootContainerSize = bidCreativeSize;
      var rootContainerOffset = {
        x: (viewportSize.width - rootContainerSize.width) / 2,
        y: (viewportSize.height - rootContainerSize.height) / 2
      };

      var rootContainerScaled = {
        width: bidCreativeSize.width * scaleFactor,
        height: bidCreativeSize.height * scaleFactor
      };
      var rootContainerTransformedArea = {
        x: (viewportSize.width - rootContainerScaled.width) / 2,
        y: (viewportSize.height - rootContainerScaled.height) / 2,
        width: rootContainerScaled.width,
        height: rootContainerScaled.height
      };

      return {
        scaleFactor: scaleFactor,
        rootContainerSize: rootContainerSize,
        rootContainerOffset: rootContainerOffset,
        rootContainerTransformedArea: rootContainerTransformedArea
      };
    }
  }, {
    key: "getLetterboxConstraintsForMadlibRootElement",
    value: function getLetterboxConstraintsForMadlibRootElement() {
      var _getLetterboxLayoutIn = this.getLetterboxLayoutInfo(),
          scaleFactor = _getLetterboxLayoutIn.scaleFactor,
          rootContainerSize = _getLetterboxLayoutIn.rootContainerSize,
          rootContainerOffset = _getLetterboxLayoutIn.rootContainerOffset;

      return {
        rootConstraints: {
          left: rootContainerOffset.x + "px",
          top: rootContainerOffset.y + "px",
          width: rootContainerSize.width + "px",
          height: rootContainerSize.height + "px"
        },
        rootPostLayoutTransform: "scale(" + scaleFactor + ")"
      };
    }
  }, {
    key: "getStyleForClickElement",
    value: function getStyleForClickElement() {
      var _getLetterboxLayoutIn2 = this.getLetterboxLayoutInfo(),
          rootContainerTransformedArea = _getLetterboxLayoutIn2.rootContainerTransformedArea;

      return {
        left: rootContainerTransformedArea.x + "px",
        top: rootContainerTransformedArea.y + "px",
        width: rootContainerTransformedArea.width + "px",
        height: rootContainerTransformedArea.height + "px",
        right: "auto",
        bottom: "auto"
      };
    }
  }]);

  return LetterboxConfig;
}();

/* harmony default export */ __webpack_exports__["a"] = (LetterboxConfig);

/***/ }),
/* 139 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__logger__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__frontendlib_utils__ = __webpack_require__(0);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }




var initialScreenAngle = Object(__WEBPACK_IMPORTED_MODULE_1__frontendlib_utils__["getIn"])(window, ["screen", "orientation", "angle"]);

var RESIZE_LOGGING_SAMPLING_FREQUENCY_MULTIPLIER = 0.1;

/**
 * Logs window resize events to Adexp.
 */

var WindowResizeLogger = function () {
  function WindowResizeLogger(snippetEl, enable_logging) {
    var _this = this;

    _classCallCheck(this, WindowResizeLogger);

    // We log resizes at a lower sampling frequency, because the log messages can be very numerous.
    this.enableResizeLogging = enable_logging ? Math.random() < RESIZE_LOGGING_SAMPLING_FREQUENCY_MULTIPLIER : false;

    this.resizeCount = 0;
    this.resizeLog = [];
    this.snippetEl = snippetEl;

    window.addEventListener("resize", function () {
      _this.logResizedDims();
    });
  }

  _createClass(WindowResizeLogger, [{
    key: "_logDims",
    value: function _logDims() {
      if (!this.enableResizeLogging) return;

      var _snippetEl$getBoundin = this.snippetEl.getBoundingClientRect(),
          width = _snippetEl$getBoundin.width,
          height = _snippetEl$getBoundin.height;

      var data = {
        height: height,
        width: width,
        sinceStartMS: Date.now() - LIFTOFF_START_TS,
        "screen.orientation.angle": Object(__WEBPACK_IMPORTED_MODULE_1__frontendlib_utils__["getIn"])(window, ["screen", "orientation", "angle"]),
        initialScreenAngle: initialScreenAngle,
        resizeCount: this.resizeCount,
        // Check support of rotation events.
        supportsOrientationChange: "onorientationchange" in window,
        supportsDeviceOrientation: "ondeviceorientation" in window,
        "window.innerWidth": window.innerWidth,
        "window.innerHeight": window.innerHeight,
        "documentElement.clientWidth": document.documentElement != null && document.documentElement.clientWidth,
        "documentElement.clientHeight": document.documentElement != null && document.documentElement.clientHeight
      };
      this.resizeLog = [].concat(_toConsumableArray(this.resizeLog), [data]);
      __WEBPACK_IMPORTED_MODULE_0__logger__["a" /* default */].recordLog("resize", "resize", { resizeLog: this.resizeLog });
    }
  }, {
    key: "logInitialDims",
    value: function logInitialDims() {
      this._logDims();
    }
  }, {
    key: "logResizedDims",
    value: function logResizedDims() {
      this.resizeCount += 1;
      this._logDims();
    }
  }]);

  return WindowResizeLogger;
}();

/* harmony default export */ __webpack_exports__["a"] = (WindowResizeLogger);

/***/ }),
/* 140 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// liftoff-bf9aa97ee00ee5c6f2cc.js